// Lesson 2 - Dental Hygiene Theory II

// Topic 7: Care Plan
// Topic 8: Ultrasonic
// Topic 9: Dentinal Hypersensitivity
// Topic 10: Polishing and Whitening
// Topic 11: Handpiece Maintenance
// Topic 12: Local Anesthetic

export const questions = {
  "7. Care Plan": [
    {
      id: 50001,
      question: "Which type of goal involves physical skills and actions in client-centered care planning?",
      options: [
        "Cognitive goals",
        "Psychomotor goals",
        "Affective goals",
        "Oral health status goals",
      ],
      correct: 1
    },
    {
      id: 50002,
      question: "What are the four essential components that each client-centered goal should include?",
      options: [
        "A diagnosis, treatment plan, medication list, and follow-up schedule",
        "A subject, verb, criterion for measurement, and time dimension for evaluation",
        "An assessment, intervention, evaluation, and documentation protocol",
        "A risk factor, protective factor, treatment option, and consent form",
      ],
      correct: 1
    },
    {
      id: 50003,
      question: "Which factor is NOT listed as a contributor to unmet dental hygiene needs?",
      options: [
        "Lack of knowledge",
        "Skill deficit in oral self-care",
        "Excessive dental insurance coverage",
        "Inadequate financial resources",
      ],
      correct: 2
    },
    {
      id: 50004,
      question: "What does a written care plan primarily represent in dental hygiene practice?",
      options: [
        "A billing document for insurance companies to process claims efficiently",
        "A legal contract between the practitioner and regulatory authorities",
        "A prioritized sequence of evidence-based interventions predicated on dental hygiene diagnosis",
        "A standardized protocol that applies identically to all patient populations",
      ],
      correct: 2
    },
    {
      id: 50005,
      question: "Which element is included as part of the care plan according to the document?",
      options: [
        "Plans for periodontal/gingival health and caries control",
        "Marketing strategies for the dental practice",
        "Financial investment recommendations",
        "Equipment maintenance schedules",
      ],
      correct: 0
    },
    {
      id: 50006,
      question: "What does the appointment schedule in a care plan specifically determine?",
      options: [
        "The practitioner's salary and benefits package details",
        "The number of visits, time needed, and interventions for each visit",
        "The patient's insurance coverage limits and deductibles",
        "The clinic's operating hours and holiday schedule",
      ],
      correct: 1
    },
    {
      id: 50007,
      question: "Which assessment finding should be considered when developing a care plan?",
      options: [
        "The dental office's profit margins",
        "Demographic data and all assessment findings",
        "Competing dental practices in the area",
        "The practitioner's personal preferences",
      ],
      correct: 1
    },
    {
      id: 50008,
      question: "What must occur before presenting the care plan to the client?",
      options: [
        "The insurance company must approve all procedures",
        "The care plan must be reviewed and signed by the clinical instructor",
        "The patient must pay the full treatment cost",
        "All dental equipment must be sterilized",
      ],
      correct: 1
    },
    {
      id: 50009,
      question: "How is the recare interval primarily determined?",
      options: [
        "By the patient's insurance policy renewal date",
        "Based on the degree of difficulty and severity of dental hygiene diagnosis (DD level)",
        "According to the dental office's scheduling preferences",
        "By random selection from standard appointment options",
      ],
      correct: 1
    },
    {
      id: 50010,
      question: "For a DD1 classification, what percentage of tooth surfaces have supra and subgingival calculus present?",
      options: [
        "Present on more than 50% of surfaces",
        "Present on 40-60% of surfaces",
        "Present on less than 20% of tooth surfaces",
        "Present on 70-80% of surfaces",
      ],
      correct: 2
    },
    {
      id: 50011,
      question: "Which periodontal condition characterizes a DD2 classification?",
      options: [
        "Severe periodontitis with 7-9 mm pocket depths",
        "Healthy periodontal status only",
        "Gingivitis to mild periodontitis with 1-4 mm pocket depths",
        "Advanced periodontitis with bone loss exceeding 50%",
      ],
      correct: 2
    },
    {
      id: 50012,
      question: "What distinguishes DD3 from DD2 in terms of deposits?",
      options: [
        "DD3 has minimal deposits while DD2 has heavy deposits",
        "DD3 has moderate deposits while DD2 has minimal to moderate deposits",
        "DD3 has no deposits while DD2 has abundant deposits",
        "DD3 and DD2 have identical deposit levels",
      ],
      correct: 1
    },
    {
      id: 50013,
      question: "What is the pocket depth range for DD3 classification?",
      options: [
        "1-3 mm pocket depths",
        "7-9 mm pocket depths",
        "4-6 mm pocket depths",
        "Greater than 10 mm pocket depths",
      ],
      correct: 2
    },
    {
      id: 50014,
      question: "Which characteristic is specific to DD4 classification?",
      options: [
        "Minimal stain and no calculus",
        "6mm or greater pockets and could exhibit tooth mobility",
        "Healthy gingival tissues throughout",
        "Localized areas of mild inflammation only",
      ],
      correct: 1
    },
    {
      id: 50015,
      question: "What percentage of tooth surfaces have supragingival calculus in DD4?",
      options: [
        "Less than 20% of tooth surfaces",
        "Between 40-50% of tooth surfaces",
        "Between 20-40% of tooth surfaces",
        "Greater than 60% of tooth surfaces",
      ],
      correct: 3
    },
    {
      id: 50016,
      question: "When presenting the dental hygiene care plan, which elements must be outlined?",
      options: [
        "Purpose, procedure, risks, benefits, and evaluation/outcome",
        "Only the cost and payment schedule",
        "Marketing materials and promotional offers",
        "Staff qualifications and office amenities",
      ],
      correct: 0
    },
    {
      id: 50017,
      question: "What type of consent must be obtained from the client before treatment?",
      options: [
        "Verbal consent given casually in the waiting room",
        "Implied consent through the patient's presence",
        "Informed consent including indications, contraindications, and risk factors",
        "Consent obtained from family members only",
      ],
      correct: 2
    },
    {
      id: 50018,
      question: "What should the clinician do if a client refuses recommended services?",
      options: [
        "Immediately discharge the patient from the practice",
        "Engage patient in conversation, listen, and evaluate reasons for declining services",
        "Proceed with treatment despite the refusal",
        "Report the patient to health authorities",
      ],
      correct: 1
    },
    {
      id: 50019,
      question: "How should informed refusal be documented?",
      options: [
        "It should not be documented to avoid legal issues",
        "Only verbal acknowledgment is sufficient",
        "Client should sign declaration of informed refusal that remains in dental record",
        "The clinician should document but not have client sign anything",
      ],
      correct: 2
    },
    {
      id: 50020,
      question: "What is the proper documentation after obtaining consent?",
      options: [
        "No documentation is necessary once consent form is signed",
        "Document that care plan was presented, procedures discussed, and consent form signed",
        "Only document the financial transaction",
        "Document only if complications occur during treatment",
      ],
      correct: 1
    },
    {
      id: 50021,
      question: "What must happen after the client signs the acknowledgement of consent form?",
      options: [
        "Treatment can begin immediately without instructor review",
        "Sign up for instructor to review that client signed the form",
        "The form is filed without any further verification",
        "The patient must wait 24 hours before treatment begins",
      ],
      correct: 1
    },
    {
      id: 50022,
      question: "What typically occurs first after obtaining client consent and instructor review?",
      options: [
        "Billing and payment processing",
        "Ordering of dental supplies",
        "Oral Health Education (OHE)",
        "Final evaluation and discharge planning",
      ],
      correct: 2
    },
    {
      id: 50023,
      question: "What must be documented if planned treatment is not completed?",
      options: [
        "Nothing needs to be documented",
        "A treatment modification must be documented",
        "Only billing adjustments are necessary",
        "A new patient must be found",
      ],
      correct: 1
    },
    {
      id: 50024,
      question: "What should be discussed with the client if treatment is not completed as planned?",
      options: [
        "Alternative dental offices they could visit",
        "What was completed and what still needs to be completed",
        "Reasons why the clinician is inadequate",
        "Financial penalties for incomplete treatment",
      ],
      correct: 1
    },
    {
      id: 50025,
      question: "What does the care plan help control according to the document?",
      options: [
        "Staff scheduling and payroll management",
        "Periodontal disease, dental caries, and risk factors",
        "Marketing strategies and patient acquisition",
        "Dental supply inventory levels",
      ],
      correct: 1
    },
    {
      id: 50026,
      question: "Which factor is mentioned as potentially being a barrier to professional care?",
      options: [
        "Excessive wealth and resources",
        "Culture as a barrier to professional care",
        "Too much dental knowledge",
        "Overutilization of dental services",
      ],
      correct: 1
    },
    {
      id: 50027,
      question: "What should be identified in the periodontal/gingival health portion of the care plan?",
      options: [
        "The dentist's treatment preferences",
        "Modifiable risk factors for periodontal disease development and progression",
        "Office policies and procedures",
        "Marketing demographics for the practice",
      ],
      correct: 1
    },
    {
      id: 50028,
      question: "Which complications should be identified in the care plan?",
      options: [
        "Complications in the office scheduling system",
        "Complications between systemic and periodontal disease",
        "Complications in staff relationships",
        "Complications in billing procedures",
      ],
      correct: 1
    },
    {
      id: 50029,
      question: "What specific caries control interventions are mentioned in the care plan components?",
      options: [
        "Social media marketing and patient testimonials",
        "Dietary modifications, fluoride application, and sealants",
        "Office expansion and equipment upgrades",
        "Staff training and continuing education",
      ],
      correct: 1
    },
    {
      id: 50030,
      question: "According to the document, are DD levels always used in private practice?",
      options: [
        "Yes, they are mandatory in all dental settings",
        "Yes, but only for insurance billing purposes",
        "No, they are used in educational institutions and not always in private practice",
        "No, they are only used in hospital settings",
      ],
      correct: 2
    },
    {
      id: 50031,
      question: "What describes the relationship between DHD interventions and unmet needs?",
      options: [
        "They are completely unrelated concepts",
        "DHD interventions are selected in relationship to unmet needs",
        "Unmet needs are ignored when selecting interventions",
        "DHD interventions create unmet needs",
      ],
      correct: 1
    },
    {
      id: 50032,
      question: "How much supragingival calculus is present in DD2 classification?",
      options: [
        "Present on less than 20% of tooth surfaces",
        "Present on up to 40% of tooth surface",
        "Present on greater than 60% of surfaces",
        "Present on 70-80% of surfaces",
      ],
      correct: 1
    },
    {
      id: 50033,
      question: "What percentage of tooth surfaces have subgingival calculus in DD2?",
      options: [
        "Up to 50% of tooth surface",
        "Less than 20% of tooth surfaces",
        "Greater than 70% of surfaces",
        "Between 80-90% of surfaces",
      ],
      correct: 0
    },
    {
      id: 50034,
      question: "What level of stain is associated with DD3 classification?",
      options: [
        "No stain present",
        "Heavy stain throughout",
        "Moderate stain",
        "Minimal to absent stain",
      ],
      correct: 2
    },
    {
      id: 50035,
      question: "Which periodontal condition is associated with DD3?",
      options: [
        "Healthy periodontal tissues",
        "Severe periodontitis with furcation involvement",
        "Mild to moderate periodontitis",
        "Necrotizing periodontal disease",
      ],
      correct: 2
    },
    {
      id: 50036,
      question: "What percentage of surfaces have subgingival calculus in DD3?",
      options: [
        "Less than 20% of tooth surfaces",
        "Up to 50% of tooth surfaces",
        "Up to 70% of tooth surfaces",
        "Up to 30% of tooth surfaces",
      ],
      correct: 2
    },
    {
      id: 50037,
      question: "Which deposit characteristic defines DD4?",
      options: [
        "Minimal deposits with excellent oral hygiene",
        "Moderate deposits limited to anterior teeth",
        "Heavy/abundant deposits throughout the dentition",
        "No deposits but severe inflammation present",
      ],
      correct: 2
    },
    {
      id: 50038,
      question: "What is a key consideration that should be included in care planning?",
      options: [
        "The clinic's marketing budget",
        "Pain and anxiety control for the patient",
        "Staff vacation schedules",
        "Pharmaceutical company representatives' visits",
      ],
      correct: 1
    },
    {
      id: 50039,
      question: "What periodontal status range is associated with DD1?",
      options: [
        "Severe periodontitis with attachment loss",
        "Moderate periodontitis throughout",
        "Healthy periodontal status to localized areas of mild gingivitis",
        "Necrotizing ulcerative gingivitis",
      ],
      correct: 2
    },
    {
      id: 50040,
      question: "According to informed consent requirements, what must consent be for?",
      options: [
        "Any procedure regardless of legality",
        "A procedure that is legal",
        "Experimental procedures without FDA approval",
        "Procedures that benefit the practitioner primarily",
      ],
      correct: 1
    },
    {
      id: 50041,
      question: "What demonstrates that DD levels are primarily educational tools?",
      options: [
        "They generate higher insurance reimbursements",
        "They are required by federal law",
        "They are used in educational institutions and not always seen in private practice",
        "They replace all other diagnostic criteria",
      ],
      correct: 2
    },
    {
      id: 50042,
      question: "When presenting the care plan, only the benefits need to be discussed with the client.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    }
  ],
  "8. Ultrasonic": [
    {
      id: 50200,
      question: "What is the primary objective of periodontal debridement?",
      options: [
        "Increasing tooth sensitivity and removing enamel layers",
        "Disruption and removal of subgingival biofilm",
        "Whitening teeth and improving aesthetic appearance only",
        "Reducing saliva production and drying oral tissues",
      ],
      correct: 1
    },
    {
      id: 50201,
      question: "Which mechanism of action is considered the primary action in ultrasonic instrumentation?",
      options: [
        "Acoustic microstreaming",
        "Cavitation",
        "Mechanical action",
        "Irrigation",
      ],
      correct: 2
    },
    {
      id: 50202,
      question: "What is the purpose of the irrigant used with ultrasonic instruments?",
      options: [
        "To enhance the whitening effect on tooth surfaces",
        "To provide nutrition to periodontal tissues",
        "To counteract frictional heat generated by the oscillating tip",
        "To increase bacterial growth for research purposes",
      ],
      correct: 2
    },
    {
      id: 50203,
      question: "What characterizes the cavitation mechanism in ultrasonic instrumentation?",
      options: [
        "Formation and explosive collapse of microscopic bubbles in flowing liquid",
        "Steady flow of water without any bubble formation",
        "Creation of large air pockets in solid tooth structure",
        "Development of bacterial colonies in liquid medium",
      ],
      correct: 0
    },
    {
      id: 50204,
      question: "Where does acoustic microstreaming occur during ultrasonic scaling?",
      options: [
        "In the dental unit water supply system",
        "Near any object in oscillatory motion in liquid",
        "Only in the patient's saliva glands",
        "Exclusively in the suction evacuation tubing",
      ],
      correct: 1
    },
    {
      id: 50205,
      question: "What are the main components of a magnetostrictive ultrasonic device?",
      options: [
        "Insert, handpiece, base unit, and foot switch",
        "Only a handpiece and electrical cord",
        "Base unit, mirror, explorer, and gauze",
        "Foot switch, patient chair, light, and tray",
      ],
      correct: 0
    },
    {
      id: 50206,
      question: "What are the main components of a piezoelectric ultrasonic device?",
      options: [
        "Base unit, patient bib, suction, and mirror",
        "Handpiece, explorer, scaler, and curette",
        "Tip, handpiece, base unit, and foot switch",
        "Insert, drill, syringe, and cotton rolls",
      ],
      correct: 2
    },
    {
      id: 50207,
      question: "Which category of ultrasonic tip has the greatest mass and widest diameter?",
      options: [
        "Ultra-slim tips",
        "Slim or thin tips",
        "Standard scaling tips",
        "Micro-thin specialty tips",
      ],
      correct: 2
    },
    {
      id: 50208,
      question: "What geometry can slim (thin or perio) ultrasonic tips have?",
      options: [
        "Only perfectly circular geometry",
        "Circular or rectangular; straight or curved geometry",
        "Exclusively triangular shaped",
        "Only hexagonal configuration",
      ],
      correct: 1
    },
    {
      id: 50209,
      question: "What characterizes ultra-slim (extra-thin) ultrasonic tips?",
      options: [
        "Greatest mass with widest diameter available",
        "Rectangular shape with curved geometry only",
        "Least mass; narrowest diameter with circular, straight geometry",
        "Medium mass with variable diameter options",
      ],
      correct: 2
    },
    {
      id: 50210,
      question: "What factors determine the acoustic power produced by an ultrasonic scaler?",
      options: [
        "Patient age, tooth color, and saliva consistency",
        "Displacement amplitude, tip diameter, and tip shape",
        "Room temperature, humidity, and air pressure",
        "Operator height, hand size, and grip strength",
      ],
      correct: 1
    },
    {
      id: 50211,
      question: "What does the function produced by an ultrasonic scaler depend on?",
      options: [
        "The brand of dental chair and lighting conditions",
        "Patient cooperation and appointment duration",
        "Efficiency of mechanical action and cavitation/microstreaming activity",
        "Clinic location and scheduling preferences",
      ],
      correct: 2
    },
    {
      id: 50212,
      question: "What are the key design features of ultrasonic tips?",
      options: [
        "Color, brand name, packaging, and price",
        "Weight, length, manufacturer, and warranty",
        "Diameter, shape, geometry, and profile",
        "Flexibility, temperature, conductivity, and magnetism",
      ],
      correct: 2
    },
    {
      id: 50213,
      question: "When do manufacturers suggest replacing ultrasonic tips?",
      options: [
        "After every single patient use",
        "When 2 mm of tip length is lost",
        "Every six months regardless of wear",
        "Only when the tip completely breaks off",
      ],
      correct: 1
    },
    {
      id: 50214,
      question: "What is the active area of an ultrasonic tip?",
      options: [
        "The entire length from handpiece to point",
        "Only the very tip point",
        "The terminal 2-4 mm including point, face, back, and lateral surfaces",
        "The area where the tip connects to handpiece",
      ],
      correct: 2
    },
    {
      id: 50215,
      question: "How does power setting affect displacement amplitude?",
      options: [
        "Higher power decreases displacement amplitude",
        "Power setting has no effect on amplitude",
        "Higher power increases displacement amplitude",
        "Power only affects water flow, not amplitude",
      ],
      correct: 2
    },
    {
      id: 50216,
      question: "What is the recommended water flow rate at medium power?",
      options: [
        "Continuous heavy stream creating puddles",
        "No water flow is necessary",
        "Intermittent droplets",
        "Constant mist with no visible drops",
      ],
      correct: 2
    },
    {
      id: 50217,
      question: "What pattern does the tip oscillate in during magnetostrictive scaling?",
      options: [
        "A perfect circular motion",
        "An elliptical pattern (squashed circle with one side longer)",
        "A figure-eight pattern",
        "A completely linear back-and-forth motion",
      ],
      correct: 1
    },
    {
      id: 50218,
      question: "What are the three types of adaptation used in ultrasonic instrumentation?",
      options: [
        "Vertical, horizontal, and oblique",
        "Proximal, facial, and lingual",
        "Anterior, posterior, and lateral",
        "Maxillary, mandibular, and incisal",
      ],
      correct: 0
    },
    {
      id: 50219,
      question: "How should the clinician grasp the ultrasonic handpiece?",
      options: [
        "With maximum pressure using entire fist",
        "By balancing handpiece between thumb and forefinger",
        "Using only the pinky and ring fingers",
        "By gripping with palm of hand only",
      ],
      correct: 1
    },
    {
      id: 50220,
      question: "Why are fulcrum points needed during ultrasonic instrumentation?",
      options: [
        "To increase patient discomfort",
        "For stabilization",
        "To block the patient's view",
        "To reduce treatment effectiveness",
      ],
      correct: 1
    },
    {
      id: 50221,
      question: "What technique is used for advancing the tip in deeper pockets?",
      options: [
        "Pushing forcefully until resistance is met",
        "Avoiding any insertion below gum line",
        "Channeling with stroke pattern to base of pocket",
        "Inserting without any specific pattern",
      ],
      correct: 2
    },
    {
      id: 50222,
      question: "How should instrumentation be executed for efficiency?",
      options: [
        "Randomly throughout the mouth",
        "By quadrant only",
        "By sextant",
        "One tooth at a time throughout entire mouth",
      ],
      correct: 2
    },
    {
      id: 50223,
      question: "What is the general consensus regarding ultrasonic instruments and implanted medical devices?",
      options: [
        "Ultrasonic instruments definitely damage all devices",
        "Ultrasonic instruments pose no known risk to proper device function",
        "All medical devices must be removed before treatment",
        "Only piezoelectric devices are safe to use",
      ],
      correct: 1
    },
    {
      id: 50224,
      question: "How do periodontal instruments affect restorative materials?",
      options: [
        "They have no effect on any materials",
        "They only affect composite materials",
        "All periodontal instruments have capacity to modify surfaces of restorative materials",
        "Only hand instruments affect restorations",
      ],
      correct: 2
    },
    {
      id: 50225,
      question: "What methods help with aerosol management during ultrasonic scaling?",
      options: [
        "Opening windows and using fans exclusively",
        "Barrier protection, preprocedural rinsing, HVE",
        "Treating only one patient per day",
        "Using only hand instruments instead",
      ],
      correct: 1
    },
    {
      id: 50226,
      question: "Which part of the tip should be used to conform to the mesial aspect of teeth?",
      options: [
        "The point only",
        "The face of the tip",
        "The back of the tip",
        "Any part works equally well",
      ],
      correct: 2
    },
    {
      id: 50227,
      question: "Which part of the tip is used when the back cannot access the distal surface?",
      options: [
        "The point only",
        "The face exclusively",
        "The lateral side of the tip",
        "No part can access the distal",
      ],
      correct: 2
    },
    {
      id: 50228,
      question: "What type of lateral pressure should be applied during ultrasonic scaling?",
      options: [
        "Maximum pressure to ensure thorough cleaning",
        "Light, feather-like pressure",
        "Moderate, intermittent heavy pressure",
        "No contact with tooth surface",
      ],
      correct: 1
    },
    {
      id: 50229,
      question: "What is channeling in ultrasonic instrumentation?",
      options: [
        "Creating grooves in the tooth surface",
        "Advancing tip to base of pocket using stroke pattern",
        "Directing water flow into suction",
        "Moving tip only on facial surfaces",
      ],
      correct: 1
    },
    {
      id: 50230,
      question: "What stroke pattern is used in deeper pockets?",
      options: [
        "Only horizontal strokes across pocket",
        "Circular motions at pocket entrance",
        "Advancing and retracting tip across treatment area",
        "Stationary tip placement without movement",
      ],
      correct: 2
    },
    {
      id: 50231,
      question: "What should be done when initially debriding moderate to heavy deposits?",
      options: [
        "Avoid the area completely until deposits soften",
        "Use maximum power with heavy pressure",
        "Begin with appropriate power and light lateral pressure",
        "Only use hand instruments for heavy deposits",
      ],
      correct: 2
    },
    {
      id: 50232,
      question: "What is a specialty tip designed for implant maintenance?",
      options: [
        "Standard scaling tip with metal working end",
        "Plastic or carbon fiber implant-specific tip",
        "Any regular periodontal tip works fine",
        "Ultra-slim metal tip only",
      ],
      correct: 1
    },
    {
      id: 50233,
      question: "Why is working by sextant more efficient than by quadrant?",
      options: [
        "It takes more time but is more thorough",
        "It reduces frequency of tip changes and operator position changes",
        "It allows for more breaks during treatment",
        "It requires more instrument changes per area",
      ],
      correct: 1
    },
    {
      id: 50234,
      question: "What operational variable affects ultrasonic scaler function?",
      options: [
        "Patient's insurance coverage",
        "Operator's years of experience",
        "Operating frequency",
        "Clinic's geographic location",
      ],
      correct: 2
    },
    {
      id: 50235,
      question: "Which operational variable directly affects tip performance?",
      options: [
        "Patient cooperation level",
        "Appointment scheduling time",
        "Water flow rate",
        "Operator's dominant hand",
      ],
      correct: 2
    },
    {
      id: 50236,
      question: "What happens when higher power settings are used?",
      options: [
        "Water flow decreases automatically",
        "Tip vibration stops completely",
        "Displacement amplitude increases",
        "Cavitation effect disappears",
      ],
      correct: 2
    },
    {
      id: 50237,
      question: "How should the operator position the handpiece for proper grasp?",
      options: [
        "it tightly with all fingers clenched",
        "Balance it between thumb and forefinger",
        "Hold it with fingertips only",
        "Support it with the palm exclusively",
      ],
      correct: 1
    },
    {
      id: 50238,
      question: "What type of tip geometry is standard scaling tips available in?",
      options: [
        "Only circular shape",
        "Only rectangular shape",
        "Circular or rectangular with straight geometry",
        "Triangular with curved geometry",
      ],
      correct: 2
    },
    {
      id: 50239,
      question: "Which tip category would be most appropriate for deep, narrow pockets?",
      options: [
        "Standard scaling tips",
        "Slim or thin tips",
        "Ultra-slim (extra-thin) tips",
        "Implant-specific tips",
      ],
      correct: 2
    },
    {
      id: 50240,
      question: "What is one objective of periodontal debridement?",
      options: [
        "Removal of plaque retentive factors",
        "Increasing tooth mobility",
        "Creating tooth sensitivity",
        "Exposing root surfaces unnecessarily",
      ],
      correct: 0
    },
    {
      id: 50241,
      question: "Which objective relates to tooth structure preservation?",
      options: [
        "Maximum removal of tooth structure",
        "Conservation of tooth structure",
        "Complete enamel removal",
        "Exposing dentin on all surfaces",
      ],
      correct: 1
    },
    {
      id: 50242,
      question: "What is the desired outcome of periodontal debridement?",
      options: [
        "Increased inflammation throughout tissues",
        "Maintenance of existing infection",
        "Resolution of inflammation",
        "Development of periodontal pockets",
      ],
      correct: 2
    }
  ],
  "9. Dentinal Hypersensitivity": [
    {
      id: 50400,
      question: "How is dentinal hypersensitivity characterized in terms of pain presentation?",
      options: [
        "Long, dull ache in response to pressure stimuli",
        "Short, sharp pain in response to thermal, evaporative, tactile, osmotic, or chemical stimuli",
        "Constant throbbing pain without any specific trigger",
        "Intermittent burning sensation unrelated to external factors",
      ],
      correct: 1
    },
    {
      id: 50401,
      question: "What percentage of the time does cementum overlap enamel during tooth development?",
      options: [
        "30% of the time",
        "10% of the time",
        "60% of the time",
        "1.6% of the time",
      ],
      correct: 2
    },
    {
      id: 50402,
      question: "What percentage of the time do cementum and enamel meet without overlap?",
      options: [
        "60% of the time",
        "30% of the time",
        "10% of the time",
        "1.6% of the time",
      ],
      correct: 1
    },
    {
      id: 50403,
      question: "What percentage of the time do cementum and enamel not meet at all?",
      options: [
        "60% of the time",
        "1.6% of the time",
        "30% of the time",
        "10% of the time",
      ],
      correct: 3
    },
    {
      id: 50404,
      question: "What percentage of the time does enamel overlap cementum?",
      options: [
        "1.6% of the time",
        "10% of the time",
        "30% of the time",
        "60% of the time",
      ],
      correct: 0
    },
    {
      id: 50405,
      question: "Which nerve fibers are thought to be responsible for dental hypersensitivity?",
      options: [
        "Unmyelinated C-fibers producing dull pain",
        "A-delta fibers that evoke well-localized sharp pain",
        "A-beta fibers responding to electrical stimulation",
        "Large myelinated motor fibers",
      ],
      correct: 1
    },
    {
      id: 50406,
      question: "What type of pain sensation is associated with unmyelinated C-fibers?",
      options: [
        "Sharp, well-localized pain typical of hypersensitivity",
        "Brief tingling sensation without discomfort",
        "Dull, poorly localized, aching pain associated with pulpal pain",
        "Intense burning sensation in specific locations",
      ],
      correct: 2
    },
    {
      id: 50407,
      question: "Which nerve fibers respond more sensitively to electrical stimulation?",
      options: [
        "C-fibers",
        "A-delta fibers",
        "A-beta fibers",
        "Unmyelinated sensory fibers",
      ],
      correct: 2
    },
    {
      id: 50408,
      question: "What does the hydrodynamic theory propose about stimulus transmission?",
      options: [
        "Electrical signals travel through nerve fibers directly",
        "Chemical messengers cross synaptic gaps",
        "Stimuli are transmitted via movement of fluid within dentinal tubules",
        "Heat transfers through solid tooth structure",
      ],
      correct: 2
    },
    {
      id: 50409,
      question: "What must be present for dentinal hypersensitivity according to the hydrodynamic theory?",
      options: [
        "Bacterial infection in the pulp chamber",
        "An open dentinal tubule channel from exposed dentin to vital pulp",
        "Complete closure of all dentinal tubules",
        "Inflammation of surrounding gingival tissues",
      ],
      correct: 1
    },
    {
      id: 50410,
      question: "What is the most common result leading to exposed dentin in hypersensitivity?",
      options: [
        "Congenital enamel defects only",
        "Bacterial invasion of tooth structure",
        "Gingival recession or enamel loss",
        "Developmental anomalies exclusively",
      ],
      correct: 2
    },
    {
      id: 50411,
      question: "Which factor is listed as a cause of gingival recession?",
      options: [
        "Excessive fluoride application",
        "Age",
        "Vitamin deficiency",
        "Excessive saliva production",
      ],
      correct: 1
    },
    {
      id: 50412,
      question: "What type of trauma can cause gingival recession?",
      options: [
        "Chemical burns from acidic medications",
        "Trauma from traumatic toothbrushing",
        "Thermal injury from hot beverages",
        "Radiation exposure during dental radiographs",
      ],
      correct: 1
    },
    {
      id: 50413,
      question: "Which of the following is a cause of enamel loss?",
      options: [
        "Periodontal disease progression",
        "Gingival hyperplasia",
        "Attrition",
        "Cementum overgrowth",
      ],
      correct: 2
    },
    {
      id: 50414,
      question: "What is abfraction?",
      options: [
        "Bacterial erosion of tooth structure",
        "A cause of enamel loss",
        "A type of gingival disease",
        "A pulpal inflammatory condition",
      ],
      correct: 1
    },
    {
      id: 50415,
      question: "Which procedure is listed as an additional cause of dentinal hypersensitivity?",
      options: [
        "Routine dental prophylaxis only",
        "Orthodontic bracket placement",
        "Periodontal therapy",
        "Dental impression taking",
      ],
      correct: 2
    },
    {
      id: 50416,
      question: "What is a common side effect associated with vital teeth bleaching?",
      options: [
        "Permanent tooth discoloration",
        "Tooth sensitivity",
        "Increased caries susceptibility",
        "Gingival overgrowth",
      ],
      correct: 1
    },
    {
      id: 50417,
      question: "How does the prevalence of dentinal hypersensitivity change with age?",
      options: [
        "It increases steadily throughout life",
        "It remains constant regardless of age",
        "It decreases as the individual ages",
        "It peaks in middle age then stabilizes",
      ],
      correct: 2
    },
    {
      id: 50418,
      question: "Where is dentinal hypersensitivity most prevalent on teeth?",
      options: [
        "Lingual cervical regions exclusively",
        "Incisal edges of anterior teeth",
        "Buccal cervical regions of teeth",
        "Occlusal surfaces of molars",
      ],
      correct: 2
    },
    {
      id: 50419,
      question: "What pattern is observed in right-handed individuals regarding tooth cleaning?",
      options: [
        "They clean all teeth with equal vigor",
        "They clean right-sided teeth more vigorously than left",
        "They clean left-sided teeth more vigorously than right",
        "They avoid cleaning sensitive areas completely",
      ],
      correct: 2
    },
    {
      id: 50420,
      question: "What type of diagnosis is dentinal hypersensitivity?",
      options: [
        "A diagnosis confirmed by laboratory tests",
        "A diagnosis of exclusion",
        "A diagnosis based solely on radiographs",
        "A presumptive diagnosis without examination",
      ],
      correct: 1
    },
    {
      id: 50421,
      question: "What clinical criterion must be present for diagnosing dentinal hypersensitivity?",
      options: [
        "Obvious dental caries at multiple sites",
        "Sensitivity or pain when stimulus is applied",
        "Swelling of surrounding gingival tissues",
        "Visible fracture lines in tooth structure",
      ],
      correct: 1
    },
    {
      id: 50422,
      question: "What must be observed clinically at the site of sensitivity?",
      options: [
        "Active periodontal abscess formation",
        "Excessive plaque accumulation",
        "Exposed dentin at site of sensitivity",
        "Inflamed pulpal tissue",
      ],
      correct: 2
    },
    {
      id: 50423,
      question: "What should be absent clinically to diagnose dentinal hypersensitivity?",
      options: [
        "Any tooth structure whatsoever",
        "All dental restorations",
        "Clinical signs of dental caries",
        "Normal gingival contours",
      ],
      correct: 2
    },
    {
      id: 50424,
      question: "What is a radiographic criterion for diagnosing dentinal hypersensitivity?",
      options: [
        "Presence of extensive bone loss",
        "Evidence of multiple impacted teeth",
        "No pulpal inflammation or apical pathologic condition",
        "Visible calculus deposits on root surfaces",
      ],
      correct: 2
    },
    {
      id: 50425,
      question: "What should be absent radiographically under restorations?",
      options: [
        "Any tooth structure",
        "Normal bone density",
        "Healthy periodontal ligament space",
        "Radiolucent areas",
      ],
      correct: 3
    },
    {
      id: 50426,
      question: "Which factor contributes to dentinal hypersensitivity?",
      options: [
        "Excessive salivary flow",
        "Loss of enamel",
        "Bacterial plaque biofilm removal",
        "Proper oral hygiene maintenance",
      ],
      correct: 1
    },
    {
      id: 50427,
      question: "What type of foods can contribute to dentinal hypersensitivity?",
      options: [
        "High-protein foods",
        "Foods rich in calcium",
        "Acidic foods",
        "Foods containing complex carbohydrates",
      ],
      correct: 2
    },
    {
      id: 50428,
      question: "Which surgical procedure is listed as a contributing factor?",
      options: [
        "Cosmetic gingival recontouring",
        "Periodontal surgery",
        "Dental implant placement",
        "Orthodontic bracket bonding",
      ],
      correct: 1
    },
    {
      id: 50429,
      question: "What occlusal factor can contribute to dentinal hypersensitivity?",
      options: [
        "Normal masticatory function",
        "Proper bite alignment",
        "Occlusal hyperfunction",
        "Reduced chewing force",
      ],
      correct: 2
    },
    {
      id: 50430,
      question: "Which instrumentation procedure can contribute to hypersensitivity?",
      options: [
        "Polishing with prophy paste only",
        "Taking dental impressions",
        "Root planing and scaling",
        "Applying pit and fissure sealants",
      ],
      correct: 2
    },
    {
      id: 50431,
      question: "What is one mechanism of action for desensitizing agents?",
      options: [
        "Stimulation of increased saliva production",
        "Physical occlusion of dentinal tubules",
        "Acceleration of enamel regeneration",
        "Enhancement of immune system response",
      ],
      correct: 1
    },
    {
      id: 50432,
      question: "Which mechanism involves blocking pulp tissue transmission?",
      options: [
        "Chemical dissolution of tooth structure",
        "Increasing blood flow to pulpal tissues",
        "Nerve desensitization to block pulp tissue transmission",
        "Promoting bacterial colonization",
      ],
      correct: 2
    },
    {
      id: 50433,
      question: "What innovative therapy is mentioned for desensitization?",
      options: [
        "High-frequency sound wave therapy",
        "Magnetic field application",
        "Photobiomodulation using laser therapy",
        "Ultrasonic vibration treatment",
      ],
      correct: 2
    },
    {
      id: 50434,
      question: "What concentration of potassium nitrate is used in self-applied agents?",
      options: [
        "0.4%",
        "8%",
        "5%",
        "2%",
      ],
      correct: 2
    },
    {
      id: 50435,
      question: "What concentration of stannous fluoride is used for desensitization?",
      options: [
        "5%",
        "0.4%",
        "8%",
        "2%",
      ],
      correct: 1
    },
    {
      id: 50436,
      question: "What is the concentration of arginine used with calcium carbonate?",
      options: [
        "0.4%",
        "5%",
        "2%",
        "8%",
      ],
      correct: 3
    },
    {
      id: 50437,
      question: "Which compound is used as a self-applied desensitizing agent?",
      options: [
        "Sodium bicarbonate",
        "Strontium acetate or strontium chloride",
        "Calcium hydroxide",
        "Zinc oxide",
      ],
      correct: 1
    },
    {
      id: 50438,
      question: "What type of derivatives are included in self-applied agents?",
      options: [
        "Whey protein isolates",
        "Soy-based compounds",
        "Casein derivatives including CPP-ACP",
        "Collagen peptides",
      ],
      correct: 2
    },
    {
      id: 50439,
      question: "Which chemical class is used in self-applied desensitizing agents?",
      options: [
        "Phosphates",
        "Carbonates",
        "Sulfates",
        "Oxalates",
      ],
      correct: 3
    },
    {
      id: 50440,
      question: "What type of professionally applied agent includes varnishes?",
      options: [
        "Antibiotics and antiseptics",
        "Varnishes and precipitants",
        "Analgesics and anesthetics",
        "Whitening and bleaching agents",
      ],
      correct: 1
    },
    {
      id: 50441,
      question: "What do primers used professionally contain?",
      options: [
        "High concentrations of fluoride only",
        "Antibacterial compounds exclusively",
        "Hydroxyethyl methacrylate (HEMA)",
        "Sodium hypochlorite solutions",
      ],
      correct: 2
    },
    {
      id: 50442,
      question: "Which professionally applied agents work through polymerization?",
      options: [
        "Simple fluoride solutions",
        "Chlorhexidine rinses",
        "Polymerizing agents",
        "Saline irrigants",
      ],
      correct: 2
    },
    {
      id: 50443,
      question: "What specialized technique uses electrical current for desensitization?",
      options: [
        "Electrocautery",
        "Iontophoresis",
        "Electroconvulsive therapy",
        "Galvanic stimulation",
      ],
      correct: 1
    },
    {
      id: 50444,
      question: "Which advanced technology is used professionally for desensitization?",
      options: [
        "Ultrasonic scalers",
        "Lasers",
        "Air abrasion devices",
        "Piezoelectric instruments",
      ],
      correct: 1
    },
    {
      id: 50445,
      question: "What definitive treatment option is mentioned for severe cases?",
      options: [
        "Extractions",
        "Root canal therapy exclusively",
        "Restorations",
        "Orthodontic treatment",
      ],
      correct: 2
    },
    {
      id: 50446,
      question: "What surgical approach can be used to treat hypersensitivity?",
      options: [
        "Bone grafting procedures",
        "Apicoectomy",
        "Periodontal plastic surgery",
        "Dental implant placement",
      ],
      correct: 2
    },
    {
      id: 50447,
      question: "According to the comparison chart, what is the composition of Shield Force Plus?",
      options: [
        "Glutaraldehyde-based",
        "RMGI-based",
        "Resin-based",
        "Calcium phosphate-based",
      ],
      correct: 2
    },
    {
      id: 50448,
      question: "What is the composition of Gluma desensitizing agent?",
      options: [
        "Resin-based",
        "RMGI-based",
        "Glutaraldehyde",
        "Strontium chloride",
      ],
      correct: 2
    },
    {
      id: 50449,
      question: "What is the composition of Vanish XT?",
      options: [
        "Glutaraldehyde-based",
        "Resin-based",
        "RMGI-based",
        "Oxalate-based",
      ],
      correct: 2
    },
    {
      id: 50450,
      question: "Which product requires isolation with a dental dam?",
      options: [
        "Shield Force Plus",
        "Vanish XT",
        "Gluma",
        "All products equally",
      ],
      correct: 2
    },
    {
      id: 50451,
      question: "What is the application time for Shield Force Plus?",
      options: [
        "20 seconds",
        "30 seconds",
        "30-60 seconds",
        "60 seconds",
      ],
      correct: 1
    },
    {
      id: 50452,
      question: "What is the application time range for Gluma?",
      options: [
        "20 seconds",
        "30 seconds",
        "30-60 seconds",
        "60-90 seconds",
      ],
      correct: 2
    },
    {
      id: 50453,
      question: "What is the application time for Vanish XT?",
      options: [
        "20 seconds",
        "30 seconds",
        "30-60 seconds",
        "60 seconds",
      ],
      correct: 0
    },
    {
      id: 50454,
      question: "Which products can be placed under restorations?",
      options: [
        "Only Shield Force Plus",
        "Only Gluma",
        "Shield Force Plus and Gluma",
        "All three products equally",
      ],
      correct: 2
    },
    {
      id: 50455,
      question: "How many applications does Shield Force Plus provide?",
      options: [
        "80-480",
        "180",
        "220",
        "100",
      ],
      correct: 1
    },
    {
      id: 50456,
      question: "How many applications does Gluma provide?",
      options: [
        "180",
        "220",
        "80-480",
        "100",
      ],
      correct: 1
    },
    {
      id: 50457,
      question: "What is the application range for Vanish XT?",
      options: [
        "180",
        "220",
        "80-480",
        "100",
      ],
      correct: 2
    },
    {
      id: 50458,
      question: "What is the refill size for Shield Force Plus?",
      options: [
        "5ml",
        "10g",
        "3ml",
        "2ml",
      ],
      correct: 2
    },
    {
      id: 50459,
      question: "What is the refill size for Gluma?",
      options: [
        "3ml",
        "5ml",
        "10g",
        "2ml",
      ],
      correct: 1
    },
    {
      id: 50460,
      question: "What is the refill size for Vanish XT?",
      options: [
        "3ml",
        "5ml",
        "10g",
        "2ml",
      ],
      correct: 2
    }
  ],
  "10. Polishing and Whitening": [
    {
      id: 50600,
      question: "What is the primary role of the dental hygienist when a client is dissatisfied with tooth appearance due to staining?",
      options: [
        "Immediately recommend the most aggressive polishing technique available",
        "Determine the cause of staining and select the least damaging method to address it",
        "Refer the client to a cosmetic dentist without further assessment",
        "Suggest over-the-counter whitening products as the first option",
      ],
      correct: 1
    },
    {
      id: 50601,
      question: "Which two primary procedures are used for extrinsic stain management?",
      options: [
        "Scaling and root planing",
        "Fluoride application and sealant placement",
        "Rubber-cup polishing and air polishing",
        "Bleaching trays and laser whitening",
      ],
      correct: 2
    },
    {
      id: 50602,
      question: "What equipment is used in rubber cup tooth polishing?",
      options: [
        "High-speed handpiece with diamond bur and water spray",
        "Ultrasonic scaler with specialized tip and coolant system",
        "Air abrasion unit with aluminum oxide powder",
        "Low-speed dental handpiece with prophylaxis angle, rubber cup or brush, and prophylaxis paste",
      ],
      correct: 3
    },
    {
      id: 50603,
      question: "Which of the following is NOT a contraindication for tooth polishing?",
      options: [
        "Presence of moderate extrinsic staining on enamel surfaces",
        "Newly erupted teeth, especially primary teeth",
        "Enamel hypoplasia or hypocalcification",
        "Areas of recession where cementum or dentin is exposed",
      ],
      correct: 0
    },
    {
      id: 50604,
      question: "What layer does rubber cup polishing remove from the tooth surface?",
      options: [
        "The entire enamel layer down to dentin",
        "Only the pellicle layer without affecting enamel",
        "The microscopic layer of tooth enamel",
        "The cementum layer on root surfaces",
      ],
      correct: 2
    },
    {
      id: 50605,
      question: "Why is it recommended to use fluoridated paste during rubber cup polishing?",
      options: [
        "To make the paste taste better for patient comfort",
        "To increase the abrasiveness of the polishing paste",
        "Because it removes a microscopic layer of the tooth surface",
        "To reduce the time needed for the polishing procedure",
      ],
      correct: 2
    },
    {
      id: 50606,
      question: "What is a critical step that must be performed following tooth polishing?",
      options: [
        "Immediate consumption of acidic beverages to neutralize the paste",
        "Application of fluoride to remineralize the tooth surface",
        "Rinsing with alcohol-based mouthwash for disinfection",
        "Avoidance of all oral hygiene for 24 hours",
      ],
      correct: 1
    },
    {
      id: 50607,
      question: "What range describes the particle size variation in prophylaxis pastes?",
      options: [
        "All pastes contain identical particle sizes for consistency",
        "Pastes only come in one standardized grit level",
        "Fine grit to coarse grit with small to large particle sizes",
        "Extra-fine grit only to prevent enamel damage",
      ],
      correct: 2
    },
    {
      id: 50608,
      question: "What must the dental hygienist assess before selecting the appropriate paste grit?",
      options: [
        "The manufacturer's profit margin on different paste types",
        "The color preferences of the patient",
        "The client's individual needs and staining severity",
        "The age of the paste container in the supply cabinet",
      ],
      correct: 2
    },
    {
      id: 50609,
      question: "What effect can using an abrasive grit with high speed or moderate to heavy pressure cause?",
      options: [
        "Improved enamel strengthening and remineralization",
        "Enhanced fluoride uptake into tooth structure",
        "Increased sensitivity and removal of more tooth surface",
        "Faster procedure completion with no adverse effects",
      ],
      correct: 2
    },
    {
      id: 50610,
      question: "How many variables influence the efficiency and effectiveness when removing extrinsic stain with a rubber cup?",
      options: [
        "Three variables that determine stain removal success",
        "Five variables affecting tooth structure loss and stain removal",
        "Seven variables controlling the polishing outcome",
        "Two variables that impact the procedure results",
      ],
      correct: 1
    },
    {
      id: 50611,
      question: "Which of the following is one of the five variables affecting rubber cup polishing?",
      options: [
        "The patient's age and medical history",
        "The color of the rubber cup used",
        "The abrasiveness of the paste used",
        "The time of day the procedure is performed",
      ],
      correct: 2
    },
    {
      id: 50612,
      question: "Why should paste never be used dry during polishing procedures?",
      options: [
        "Dry paste is more expensive and wasteful",
        "Dry paste causes discoloration of tooth enamel",
        "Water or moisture reduces the abrasiveness of the paste",
        "Dry paste makes the procedure take longer",
      ],
      correct: 2
    },
    {
      id: 50613,
      question: "What is another term commonly used for rubber-cup polishing?",
      options: [
        "Periodontal maintenance therapy",
        "Coronal polishing",
        "Subgingival debridement",
        "Enamel microabrasion",
      ],
      correct: 1
    },
    {
      id: 50614,
      question: "Which statement about tooth stain is accurate according to the document?",
      options: [
        "Tooth stain is a serious pathological condition requiring immediate treatment",
        "Tooth stain is not a pathological condition",
        "Tooth stain always indicates underlying systemic disease",
        "Tooth stain can only be removed through surgical intervention",
      ],
      correct: 1
    },
    {
      id: 50615,
      question: "What should NOT be polished with a rubber cup polishing technique?",
      options: [
        "Natural tooth enamel with heavy staining",
        "Porcelain crowns and bridges",
        "Dental implants",
        "Composite restorations with discoloration",
      ],
      correct: 2
    },
    {
      id: 50616,
      question: "What can happen if paste particles embed in the tissues during polishing?",
      options: [
        "Enhanced tissue healing and regeneration",
        "Improved gingival health and collagen production",
        "Irritation of the gingival margin",
        "Strengthening of the periodontal attachment",
      ],
      correct: 2
    },
    {
      id: 50617,
      question: "What device is shown in the document that uses air, water, and powder for stain removal?",
      options: [
        "Ultrasonic scaler system",
        "Piezoelectric scaling unit",
        "Prophy jet device",
        "Rotary endodontic handpiece",
      ],
      correct: 2
    },
    {
      id: 50618,
      question: "What is the recommended angulation of the prophy jet to the tooth surface for anterior teeth?",
      options: [
        "45 degrees for optimal stain removal",
        "80 degrees to prevent tissue damage",
        "90 degrees perpendicular to the surface",
        "30 degrees for maximum effectiveness",
      ],
      correct: 1
    },
    {
      id: 50619,
      question: "At what distance should the prophy jet tip be positioned from the tooth surface?",
      options: [
        "1 to 2 mm off the tooth",
        "3 to 4 mm off the tooth",
        "5 to 6 mm off the tooth",
        "Directly touching the tooth surface",
      ],
      correct: 1
    },
    {
      id: 50620,
      question: "Which of the following is a contraindication for using the prophy jet?",
      options: [
        "Presence of light to moderate extrinsic staining",
        "Breathing disorders such as asthma or COPD",
        "Patients with good oral hygiene habits",
        "Teeth with intact enamel surfaces",
      ],
      correct: 1
    },
    {
      id: 50621,
      question: "Which condition is listed as a contraindication for prophy jet use?",
      options: [
        "Patients with excellent respiratory function",
        "Clients with moderate composite resins",
        "Individuals with perfect kidney function",
        "Patients with low blood pressure",
      ],
      correct: 1
    },
    {
      id: 50622,
      question: "What advantage does the air polisher have over the prophy jet?",
      options: [
        "It requires no maintenance or cleaning",
        "It can be used on implants, crowns, and bridges",
        "It is less expensive to purchase and operate",
        "It removes calculus more effectively than scaling",
      ],
      correct: 1
    },
    {
      id: 50623,
      question: "Which powder type is mentioned as an option for air-polishing devices?",
      options: [
        "Titanium dioxide powder",
        "Sodium bicarbonate powder",
        "Potassium nitrate powder",
        "Calcium hydroxide powder",
      ],
      correct: 1
    },
    {
      id: 50624,
      question: "What must be considered when selecting an air-polishing device and powder?",
      options: [
        "All devices can accommodate all powder types equally",
        "Not all air-polishing devices can accommodate all powder options",
        "Only sodium bicarbonate works with any device",
        "Powder selection has no impact on device compatibility",
      ],
      correct: 1
    },
    {
      id: 50625,
      question: "Which powder option is mentioned for air-polishing along with sodium bicarbonate?",
      options: [
        "Zinc oxide and eugenol",
        "Silver diamine fluoride",
        "Glycine and erythritol",
        "Chlorhexidine gluconate",
      ],
      correct: 2
    },
    {
      id: 50626,
      question: "Which medical condition is listed as a contraindication for air polishing?",
      options: [
        "Well-controlled type 2 diabetes",
        "History of hypertension",
        "Seasonal allergies to pollen",
        "Previous minor dental cavities",
      ],
      correct: 1
    },
    {
      id: 50627,
      question: "Which endocrine disorder is mentioned as a contraindication for air polishing?",
      options: [
        "Hypothyroidism and hyperthyroidism",
        "Addison's disease and Cushing's disease",
        "Diabetes insipidus and SIADH",
        "Graves' disease and Hashimoto's thyroiditis",
      ],
      correct: 1
    },
    {
      id: 50628,
      question: "What type of patients require careful review of medical history before air polishing?",
      options: [
        "Only patients under 18 years of age",
        "Patients with immunocompromising conditions or on steroid medications",
        "All patients regardless of health status",
        "Only patients with dental anxiety",
      ],
      correct: 1
    },
    {
      id: 50629,
      question: "What must ALWAYS be done following any polishing technique?",
      options: [
        "Application of desensitizing agents",
        "Taking post-operative radiographs",
        "Flossing all interproximal areas",
        "Prophylactic antibiotic administration",
      ],
      correct: 2
    },
    {
      id: 50630,
      question: "What essential equipment must be used during all polishing techniques?",
      options: [
        "Protective eyewear for the patient only",
        "High volume evacuator (HVE) to minimize aerosols",
        "Intraoral camera for documentation",
        "Rubber dam isolation for all procedures",
      ],
      correct: 1
    },
    {
      id: 50631,
      question: "What is the purpose of using a saliva ejector during polishing?",
      options: [
        "To remove paste particles from the oral cavity entirely",
        "To measure saliva production rates",
        "For suction at the back of the throat for the client",
        "To deliver fluoride solution during the procedure",
      ],
      correct: 2
    },
    {
      id: 50632,
      question: "What type of stains may be removed with whitening agents?",
      options: [
        "Only extrinsic stains on the enamel surface",
        "Intrinsic stains within the tooth structure",
        "Stains on dental restorations and crowns",
        "Calcified deposits and calculus formations",
      ],
      correct: 1
    },
    {
      id: 50633,
      question: "What are the active ingredients in whitening products?",
      options: [
        "Sodium fluoride and stannous fluoride",
        "Chlorhexidine and cetylpyridinium chloride",
        "Carbamide peroxide and hydrogen peroxide",
        "Calcium carbonate and sodium bicarbonate",
      ],
      correct: 2
    },
    {
      id: 50634,
      question: "What term do clients commonly use when referring to tooth whitening?",
      options: [
        "Tooth brightening",
        "Enamel restoration",
        "Bleaching",
        "Tooth polishing",
      ],
      correct: 2
    },
    {
      id: 50635,
      question: "What types of whitening systems are available for intrinsic stain removal?",
      options: [
        "Only professional in-office systems are effective",
        "In-office processes, over-the-counter products, and tray systems from dental offices",
        "Exclusively over-the-counter products without professional supervision",
        "Only custom tray systems made by dental laboratories",
      ],
      correct: 1
    },
    {
      id: 50636,
      question: "What is a problem with over-the-counter whitening kits?",
      options: [
        "They are too expensive for most patients",
        "Poor or improperly fitted trays can cause gel seepage and tissue harm",
        "They work too quickly and cause enamel damage",
        "They contain no active whitening ingredients",
      ],
      correct: 1
    },
    {
      id: 50637,
      question: "What risk exists with acidic prerinse products in some whitening kits?",
      options: [
        "They can strengthen enamel beyond normal levels",
        "They improve the whitening effect significantly",
        "They can damage tooth enamel",
        "They reduce tooth sensitivity during treatment",
      ],
      correct: 2
    },
    {
      id: 50638,
      question: "What knowledge gap might exist with laypersons using OTC whitening products?",
      options: [
        "How to properly brush their teeth",
        "How to deal with side effects and may ignore oral disease such as caries",
        "When to schedule regular dental appointments",
        "How to select an appropriate toothbrush",
      ],
      correct: 1
    },
    {
      id: 50639,
      question: "What types of toothpaste can provide whitening effects?",
      options: [
        "Only prescription-strength toothpastes with high fluoride",
        "Toothpastes with mild abrasives, bleaching agents, or titanium dioxide",
        "All toothpastes provide equal whitening effects",
        "Only toothpastes containing antibacterial agents",
      ],
      correct: 1
    },
    {
      id: 50640,
      question: "How does toothpaste containing titanium dioxide help with staining?",
      options: [
        "It chemically bleaches the tooth enamel",
        "It prevents bacteria from adhering to teeth",
        "It covers extrinsic stains",
        "It removes intrinsic stains permanently",
      ],
      correct: 2
    },
    {
      id: 50641,
      question: "What is the first step in the dental hygienist's role for tooth whitening?",
      options: [
        "Immediately fabricate whitening trays for the patient",
        "Assess the client's oral self-care and provide education regarding bleaching",
        "Prescribe the strongest whitening agent available",
        "Schedule multiple whitening appointments without consultation",
      ],
      correct: 1
    },
    {
      id: 50642,
      question: "What should the dental hygienist help the client establish regarding whitening?",
      options: [
        "Unrealistic expectations for dramatic overnight results",
        "Realistic expectations based on individual circumstances",
        "Expectations that all teeth will become perfectly white",
        "Understanding that results are guaranteed in all cases",
      ],
      correct: 1
    },
    {
      id: 50643,
      question: "What must be assessed before proceeding with whitening treatment?",
      options: [
        "The patient's insurance coverage for cosmetic procedures",
        "Contraindications such as recession, cracks, or identified caries",
        "The patient's work schedule for multiple appointments",
        "The current shade of the patient's clothing",
      ],
      correct: 1
    },
    {
      id: 50644,
      question: "What tooth characteristic may need to be determined before whitening?",
      options: [
        "The exact number of teeth in the mouth",
        "The pulp vitality of the teeth",
        "The patient's bite force measurement",
        "The thickness of the gingival tissue",
      ],
      correct: 1
    },
    {
      id: 50645,
      question: "What must be removed before whitening treatments begin?",
      options: [
        "All existing dental restorations and crowns",
        "The patient's removable appliances only",
        "All biofilm and calculus deposits",
        "Only the most visible stains",
      ],
      correct: 2
    },
    {
      id: 50646,
      question: "What is one of the dental hygienist's responsibilities in the whitening process?",
      options: [
        "Diagnosing the cause of all intrinsic stains",
        "Taking impressions for fitted whitening trays",
        "Prescribing oral medications for sensitivity",
        "Performing surgical gingival recontouring",
      ],
      correct: 1
    },
    {
      id: 50647,
      question: "What common side effect is associated with tooth whitening?",
      options: [
        "Permanent tooth discoloration and enamel loss",
        "Mild thermal tooth sensitivity and gingival irritation",
        "Severe pulp necrosis requiring endodontic treatment",
        "Complete loss of tooth translucency",
      ],
      correct: 1
    },
    {
      id: 50648,
      question: "What can occur occasionally as a side effect of whitening?",
      options: [
        "Increased enamel hardness and strength",
        "Sore throats, tooth pain, and tingling of tissues",
        "Improved periodontal health and attachment",
        "Enhanced saliva production and flow",
      ],
      correct: 1
    },
    {
      id: 50649,
      question: "What can happen with overuse of whitening products?",
      options: [
        "Teeth become naturally immune to further whitening",
        "Enamel hardness can decrease",
        "Teeth develop permanent resistance to staining",
        "Gingival tissues become more resilient",
      ],
      correct: 1
    },
    {
      id: 50650,
      question: "What dental structure may be affected by tray fabrication or material?",
      options: [
        "The maxillary sinuses and nasal passages",
        "The temporomandibular joint (TMJ)",
        "The sublingual salivary glands",
        "The mental foramen and nerve",
      ],
      correct: 1
    },
    {
      id: 50651,
      question: "When should whitening be discussed with the client according to clinical procedures?",
      options: [
        "Only after all dental treatment is completely finished",
        "At short and long-term goal setting appointments",
        "Exclusively at emergency dental visits",
        "Never during routine hygiene appointments",
      ],
      correct: 1
    },
    {
      id: 50652,
      question: "What should be created for whitening in the client's care plan?",
      options: [
        "A referral to an external whitening specialist",
        "A dental hygiene diagnosis (DHD) for the whitening treatment",
        "A surgical treatment plan for enamel modification",
        "An insurance pre-authorization for cosmetic work",
      ],
      correct: 1
    },
    {
      id: 50653,
      question: "How many appointments are typically needed for the whitening tray process?",
      options: [
        "One appointment for impressions and immediate delivery",
        "Three appointments including consultation, impressions, and follow-up",
        "Two appointments: one for impressions and one for tray delivery",
        "Four appointments with weekly sensitivity assessments",
      ],
      correct: 2
    },
    {
      id: 50654,
      question: "Where are whitening trays fabricated after impressions are taken?",
      options: [
        "At an external commercial dental laboratory",
        "By the patient at home using a kit",
        "In the materials lab area of the dental office",
        "By a specialized orthodontic laboratory",
      ],
      correct: 2
    },
    {
      id: 50655,
      question: "What must the dental hygienist read before dispensing whitening materials?",
      options: [
        "Online reviews from other dental professionals",
        "The manufacturer's guidelines on use and dispensing",
        "General whitening articles from dental magazines",
        "Patient testimonials from social media platforms",
      ],
      correct: 1
    },
    {
      id: 50656,
      question: "How long should the client use the whitening product before the follow-up appointment?",
      options: [
        "One week with daily applications",
        "Two weeks for optimal results",
        "Three days before returning for follow-up",
        "One month before reassessment",
      ],
      correct: 2
    },
    {
      id: 50657,
      question: "What ethical principle requires following safe use guidelines for polishing and whitening?",
      options: [
        "Beneficence - maximizing patient benefits",
        "Nonmaleficence - avoiding harm to patients",
        "Justice - fair distribution of dental services",
        "Autonomy - respecting patient choices",
      ],
      correct: 1
    },
    {
      id: 50658,
      question: "What must patients do before polishing or whitening procedures are performed?",
      options: [
        "Sign a liability waiver releasing the office from responsibility",
        "Be informed of and consent to the procedures",
        "Pay the full fee before any treatment begins",
        "Complete a satisfaction survey about expected results",
      ],
      correct: 1
    },
    {
      id: 50659,
      question: "What information must be included in patient education for whitening?",
      options: [
        "Only the advantages and benefits of treatment",
        "Advantages, disadvantages, risks, and potential adverse effects",
        "Just the cost and payment options available",
        "Only the procedure steps without discussing outcomes",
      ],
      correct: 1
    },
    {
      id: 50660,
      question: "What strategies must be followed for medically compromised patients?",
      options: [
        "Standard treatment protocols with no modifications",
        "Risk management strategies specific to their conditions",
        "Complete avoidance of all polishing and whitening",
        "Reduced appointment times without safety considerations",
      ],
      correct: 1
    },
    {
      id: 50661,
      question: "What specific product information must be documented in the client chart?",
      options: [
        "Only the general category of product used",
        "The specific product name, areas treated, and time spent",
        "Just the cost of materials used",
        "Only complications if they occur",
      ],
      correct: 1
    },
    {
      id: 50662,
      question: "What details about polishing should be included in documentation?",
      options: [
        "Only the start time of the procedure",
        "Product name, grit, areas polished, start/end times, equipment used, and patient tolerance",
        "Just a brief note that polishing was performed",
        "Only unusual complications or adverse reactions",
      ],
      correct: 1
    },
    {
      id: 50663,
      question: "What should be documented when flossing is performed after polishing?",
      options: [
        "Flossing should never be documented",
        "Only document if bleeding occurs",
        "That all areas were flossed",
        "Only the interproximal spaces with visible staining",
      ],
      correct: 2
    },
    {
      id: 50664,
      question: "Documentation should include specific product names, areas treated, and time spent.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    }
  ],
  "11. Handpiece Maintenance": [
    {
      id: 50900,
      question: "What is the primary function of the Latch Head part of the handpiece?",
      options: [
        "To connect the handpiece to the dental unit's air supply",
        "To hold the round bur or latch prophy cup",
        "To regulate the speed of the motor during operation",
        "To provide water cooling during tooth preparation",
      ],
      correct: 1
    },
    {
      id: 50901,
      question: "What is the round bur in the Latch Head used for?",
      options: [
        "Removing decay from tooth surfaces",
        "Polishing tooth surfaces after cleaning",
        "Adjusting the occlusion on a sealant",
        "Preparing teeth for crown placement",
      ],
      correct: 2
    },
    {
      id: 50902,
      question: "What component is indicated by the arrow on the Latch Head and must not be discarded or lost?",
      options: [
        "The bearing mechanism that controls rotation",
        "The post that comes out of the head",
        "The latch release button for bur changes",
        "The water delivery tube connection point",
      ],
      correct: 1
    },
    {
      id: 50903,
      question: "What is the specific purpose of the Prophy Head?",
      options: [
        "To hold scaling tips for calculus removal",
        "To attach diamond burs for crown preparation",
        "To connect suction tubing to the handpiece",
        "To attach prophy cups for tooth polishing",
      ],
      correct: 3
    },
    {
      id: 50904,
      question: "What types of prophy cups can be attached to the Prophy Head?",
      options: [
        "Only disposable single-use prophy cups",
        "Screw-in prophy cup or pop on and off prophy cup",
        "Only autoclavable metal prophy cups",
        "Exclusively silicone-based prophy cups",
      ],
      correct: 1
    },
    {
      id: 50905,
      question: "What critical component on the Prophy Head is easily removed and important not to lose?",
      options: [
        "The chuck mechanism for bur retention",
        "The post at the bottom of the head",
        "The water spray adjustment valve",
        "The speed control regulator dial",
      ],
      correct: 1
    },
    {
      id: 50906,
      question: "How should the Latch head be opened and closed?",
      options: [
        "Forcefully to ensure proper seal",
        "Gently to prevent damage",
        "With pliers for secure closure",
        "Rapidly for efficient workflow",
      ],
      correct: 1
    },
    {
      id: 50907,
      question: "What must be done when the latch is pushed to the side?",
      options: [
        "The motor should be activated to test function",
        "The handpiece should be disconnected from the unit",
        "You will be able to put the bur into place",
        "The oil reservoir should be refilled immediately",
      ],
      correct: 2
    },
    {
      id: 50908,
      question: "What are the two main parts of the handpiece body?",
      options: [
        "The chuck and the bearing assembly",
        "The shank and the motor",
        "The head and the water line",
        "The grip and the power cord",
      ],
      correct: 1
    },
    {
      id: 50909,
      question: "What should be used to wipe the head and shank before lubricating?",
      options: [
        "Alcohol-based disinfectant spray only",
        "Sterile gauze with saline solution",
        "An Optimum Wipe",
        "Dry paper towel without any solution",
      ],
      correct: 2
    },
    {
      id: 50910,
      question: "What should be removed from the handpiece before lubrication?",
      options: [
        "Only visible blood and tissue debris",
        "The motor assembly for thorough cleaning",
        "Excess blood, saliva, and prophy paste",
        "Just the external housing and grip",
      ],
      correct: 2
    },
    {
      id: 50911,
      question: "Why is lubricating the handpiece considered critical?",
      options: [
        "It enhances the shine and appearance of the handpiece",
        "It prevents corrosion of external metal surfaces only",
        "If not done correctly, it will cause the handpiece to seize and not work",
        "It reduces the noise level during operation",
      ],
      correct: 2
    },
    {
      id: 50912,
      question: "Where should oil be applied on the handpiece?",
      options: [
        "Only on external moving parts visible to the eye",
        "Exclusively on the head attachment mechanism",
        "Into the small hole at the base of the motor and into the shank",
        "Only into the shank without treating the motor",
      ],
      correct: 2
    },
    {
      id: 50913,
      question: "Should the head/contra angle be attached when oiling the shank?",
      options: [
        "No, it must always be removed before oiling",
        "Yes, the head/contra angle should be attached",
        "Only for the first oiling of a new handpiece",
        "It depends on the manufacturer's model specifications",
      ],
      correct: 1
    },
    {
      id: 50914,
      question: "What should be done with excess oil after application?",
      options: [
        "Leave it on for maximum lubrication protection",
        "Wipe the outside with a paper towel to remove all excess oil",
        "Allow it to drip off naturally over time",
        "Spray compressed air to blow it away",
      ],
      correct: 1
    },
    {
      id: 50915,
      question: "How long should the handpiece be run after oiling?",
      options: [
        "30 to 45 seconds for thorough distribution",
        "5 seconds just to check function",
        "10 to 15 seconds",
        "1 to 2 minutes for complete lubrication",
      ],
      correct: 2
    },
    {
      id: 50916,
      question: "At what angle should the handpiece be held when running it after oiling?",
      options: [
        "Horizontal angle parallel to the floor",
        "Downward angle for oil to move from motor through shank to head",
        "Upward angle to prevent oil from draining",
        "At a 45-degree angle to the right",
      ],
      correct: 1
    },
    {
      id: 50917,
      question: "What should be held at the head while running the handpiece after oiling?",
      options: [
        "A suction tip to collect oil vapors",
        "A paper towel to collect excess oil that runs out",
        "A gauze pad soaked in alcohol",
        "A plastic shield to protect surrounding areas",
      ],
      correct: 1
    },
    {
      id: 50918,
      question: "What does proper lubrication prevent in handpiece operation?",
      options: [
        "Discoloration of the handpiece exterior",
        "Excessive noise during low-speed operation",
        "Seizing of internal components",
        "Wear of the electrical cord connections",
      ],
      correct: 2
    }
  ],
  "12. Local Anesthetic": [
    {
      id: 51000,
      question: "What is the primary mechanism by which local anesthetic agents work?",
      options: [
        "Increasing potassium ion permeability in nerve membranes",
        "Reducing nerve membrane permeability to sodium ions",
        "Enhancing calcium channel activity in neurons",
        "Blocking acetylcholine receptors at synapses",
      ],
      correct: 1
    },
    {
      id: 51001,
      question: "Which division of the trigeminal nerve is LEAST important in local anesthesia administration?",
      options: [
        "Ophthalmic division (V1)",
        "Maxillary division (V2)",
        "Mandibular division (V3)",
        "All divisions are equally important",
      ],
      correct: 0
    },
    {
      id: 51002,
      question: "Where do amide local anesthetic agents undergo biotransformation?",
      options: [
        "In the kidneys",
        "In the bloodstream",
        "In the liver",
        "At the injection site",
      ],
      correct: 2
    },
    {
      id: 51003,
      question: "What is the primary topical anesthetic ester used in dentistry?",
      options: [
        "Lidocaine",
        "Benzocaine",
        "Prilocaine",
        "Articaine",
      ],
      correct: 1
    },
    {
      id: 51004,
      question: "Which of the following is NOT a benefit of adding vasoconstrictors to local anesthetic solutions?",
      options: [
        "Decreased blood flow to injection site",
        "Increased duration of action",
        "Faster onset of anesthesia",
        "Decreased bleeding",
      ],
      correct: 2
    },
    {
      id: 51005,
      question: "What is vasodilation in the context of local anesthesia?",
      options: [
        "Constriction of blood vessels reducing blood flow",
        "Relaxation of blood vessel walls increasing blood flow",
        "Blockage of nerve impulses to blood vessels",
        "Inflammation of blood vessel walls",
      ],
      correct: 1
    },
    {
      id: 51006,
      question: "How long can prilocaine with epinephrine provide soft tissue anesthesia?",
      options: [
        "1 to 2 hours",
        "2 to 4 hours",
        "5 to 8 hours",
        "10 to 12 hours",
      ],
      correct: 2
    },
    {
      id: 51007,
      question: "Which factor must be considered when determining maximum recommended doses of local anesthetics?",
      options: [
        "Time of day the injection is administered",
        "Patient's weight",
        "Room temperature",
        "Type of syringe used",
      ],
      correct: 1
    },
    {
      id: 51008,
      question: "What must dental hygienists assess before administering local anesthesia to eliminate or decrease patient risk?",
      options: [
        "Patient's insurance coverage",
        "Conditions representing contraindications to the care plan",
        "Weather conditions",
        "Availability of emergency services",
      ],
      correct: 1
    },
    {
      id: 51009,
      question: "What is an absolute contraindication?",
      options: [
        "A drug may be used with careful risk assessment",
        "A drug should never be administered under any circumstance",
        "A drug requires medical consultation first",
        "A drug needs dose adjustment",
      ],
      correct: 1
    },
    {
      id: 51010,
      question: "What are the main components of local anesthetic armamentarium?",
      options: [
        "Syringe, needle, cartridge, and supplementary items",
        "Gloves, mask, and protective eyewear only",
        "Sterilization equipment and disinfectants",
        "Patient records and consent forms",
      ],
      correct: 0
    },
    {
      id: 51011,
      question: "What is the purpose of the harpoon on an aspirating syringe?",
      options: [
        "To secure the needle to the syringe",
        "To engage the rubber stopper for aspiration",
        "To measure the amount of anesthetic delivered",
        "To pierce the aluminum cap of the cartridge",
      ],
      correct: 1
    },
    {
      id: 51012,
      question: "What gauge needle has a larger diameter lumen?",
      options: [
        "30 gauge",
        "27 gauge",
        "25 gauge",
        "23 gauge",
      ],
      correct: 2
    },
    {
      id: 51013,
      question: "How often should needles be changed during administration on the same patient?",
      options: [
        "After every injection",
        "After approximately 3-4 injections",
        "Never during the same appointment",
        "Only if the needle becomes visibly damaged",
      ],
      correct: 1
    },
    {
      id: 51014,
      question: "What should be done with the needle when not in use during a procedure?",
      options: [
        "Leave it uncovered for quick access",
        "Place it in a sterile container",
        "Cover it with a protective sheath",
        "Dispose of it immediately",
      ],
      correct: 2
    },
    {
      id: 51015,
      question: "What is included in the supplementary armamentarium for local anesthesia?",
      options: [
        "Extra syringes and needles only",
        "Topical antiseptic, topical anesthetic, cotton-tipped applicators, sterile gauze, and hemostats",
        "Patient education materials",
        "Blood pressure monitoring equipment",
      ],
      correct: 1
    },
    {
      id: 51016,
      question: "Why should cartridges NOT be immersed in liquid disinfectant or sterilant?",
      options: [
        "It damages the glass cylinder",
        "It can contaminate the solution inside",
        "It dissolves the aluminum cap",
        "It affects the rubber stopper integrity",
      ],
      correct: 1
    },
    {
      id: 51017,
      question: "What are the three major types of injection techniques used in dentistry?",
      options: [
        "Superficial, intermediate, and deep",
        "Local infiltration, field block, and nerve block",
        "Intravenous, intramuscular, and subcutaneous",
        "Anterior, posterior, and lateral",
      ],
      correct: 1
    },
    {
      id: 51018,
      question: "What is the proper technique for a successful injection?",
      options: [
        "Inject rapidly to minimize patient discomfort",
        "Use topical anesthetic, deposit solution slowly, and wait before advancing",
        "Always use the largest gauge needle available",
        "Inject without aspirating to save time",
      ],
      correct: 1
    },
    {
      id: 51019,
      question: "Which injection technique provides anesthesia to the largest area?",
      options: [
        "Local infiltration",
        "Supraperiosteal injection",
        "Nerve block",
        "Intraseptal injection",
      ],
      correct: 2
    },
    {
      id: 51020,
      question: "What is a supraperiosteal injection also known as?",
      options: [
        "Nerve block",
        "Field block",
        "Periodontal ligament injection",
        "Intrapulpal injection",
      ],
      correct: 1
    },
    {
      id: 51021,
      question: "How many teeth does a field block typically anesthetize?",
      options: [
        "Only one tooth",
        "One to two teeth",
        "Three to four teeth",
        "An entire quadrant",
      ],
      correct: 1
    },
    {
      id: 51022,
      question: "What injection is used to anesthetize the maxillary posterior molar area?",
      options: [
        "Anterior Superior Alveolar (ASA) nerve block",
        "Middle Superior Alveolar (MSA) nerve block",
        "Posterior Superior Alveolar (PSA) nerve block",
        "Infraorbital nerve block",
      ],
      correct: 2
    },
    {
      id: 51023,
      question: "Which nerve block anesthetizes both the anterior and premolar areas of the maxilla?",
      options: [
        "Greater Palatine nerve block",
        "Infraorbital nerve block",
        "Nasopalatine nerve block",
        "Posterior Superior Alveolar nerve block",
      ],
      correct: 1
    },
    {
      id: 51024,
      question: "What area does the Greater Palatine nerve block anesthetize?",
      options: [
        "Facial tissues of maxillary incisors",
        "Hard and soft palatal tissues overlying molars and premolars",
        "Mandibular posterior teeth",
        "Maxillary sinus region",
      ],
      correct: 1
    },
    {
      id: 51025,
      question: "Which injection anesthetizes palatal tissues from the right to left premolar area?",
      options: [
        "Greater Palatine nerve block",
        "Posterior Superior Alveolar nerve block",
        "Nasopalatine nerve block",
        "Anterior Middle Superior Alveolar nerve block",
      ],
      correct: 2
    },
    {
      id: 51026,
      question: "What is the primary mandibular nerve block used in dental hygiene?",
      options: [
        "Buccal nerve block",
        "Mental nerve block",
        "Inferior alveolar nerve block",
        "Lingual nerve block",
      ],
      correct: 2
    },
    {
      id: 51027,
      question: "What anatomical landmark is used for the Inferior Alveolar nerve block?",
      options: [
        "Mental foramen",
        "Greater palatine foramen",
        "Mandibular foramen",
        "Infraorbital foramen",
      ],
      correct: 2
    },
    {
      id: 51028,
      question: "Which nerve provides sensation to the buccal tissues of mandibular molars?",
      options: [
        "Inferior alveolar nerve",
        "Lingual nerve",
        "Buccal nerve",
        "Mental nerve",
      ],
      correct: 2
    },
    {
      id: 51029,
      question: "What is the Mental nerve block used to anesthetize?",
      options: [
        "All mandibular teeth",
        "Lingual tissues",
        "Mandibular incisors and canines, chin, and lower lip",
        "Buccal tissues of molars",
      ],
      correct: 2
    },
    {
      id: 51030,
      question: "What local complication involves spasms due to trauma to muscle?",
      options: [
        "Hematoma",
        "Paresthesia",
        "Trismus",
        "Edema",
      ],
      correct: 2
    },
    {
      id: 51031,
      question: "What is paresthesia in the context of local anesthesia complications?",
      options: [
        "Temporary facial paralysis",
        "Prolonged numbness lasting hours or days",
        "Tissue death at injection site",
        "Allergic reaction to anesthetic",
      ],
      correct: 1
    },
    {
      id: 51032,
      question: "Which complication results from blood accumulation in tissues?",
      options: [
        "Edema",
        "Infection",
        "Hematoma",
        "Tissue sloughing",
      ],
      correct: 2
    },
    {
      id: 51033,
      question: "What causes burning sensation during local anesthetic injection?",
      options: [
        "Needle being too sharp",
        "Solution temperature or pH differences",
        "Injecting too slowly",
        "Using expired anesthetic",
      ],
      correct: 1
    },
    {
      id: 51034,
      question: "What should be done if a needle breaks during injection?",
      options: [
        "Immediately probe the area to retrieve it",
        "Keep the patient calm and still, retrieve carefully if visible",
        "Continue with the procedure",
        "Send the patient home immediately",
      ],
      correct: 1
    },
    {
      id: 51035,
      question: "What is tissue sloughing?",
      options: [
        "Normal healing response to injection",
        "Death and shedding of tissue",
        "Temporary discoloration of tissue",
        "Swelling of injected area",
      ],
      correct: 1
    },
    {
      id: 51036,
      question: "What systemic complication is related to excessive local anesthetic dose?",
      options: [
        "Hypertension",
        "Local anesthetic overdose",
        "Hypoglycemia",
        "Respiratory alkalosis",
      ],
      correct: 1
    },
    {
      id: 51037,
      question: "What factors predispose patients to local anesthetic overdose?",
      options: [
        "Time of day and season",
        "Age, weight, gender, and drug factors",
        "Room lighting and temperature",
        "Operator experience only",
      ],
      correct: 1
    },
    {
      id: 51038,
      question: "What drug can reverse the soft-tissue effects of local anesthesia?",
      options: [
        "Epinephrine",
        "Atropine",
        "Phentolamine mesylate",
        "Naloxone",
      ],
      correct: 2
    },
    {
      id: 51039,
      question: "What is the purpose of a mixing pen for local anesthesia?",
      options: [
        "To dilute the anesthetic solution",
        "To mix anesthetic with buffering solution to reduce burning",
        "To combine different anesthetic agents",
        "To add more vasoconstrictor",
      ],
      correct: 1
    },
    {
      id: 51040,
      question: "Where should topical anesthetic be applied before injection?",
      options: [
        "On the patient's arm",
        "On dried tissue at the injection site",
        "On wet tissue at the injection site",
        "Inside the anesthetic cartridge",
      ],
      correct: 1
    },
    {
      id: 51041,
      question: "What volume does a standard dental anesthetic cartridge contain?",
      options: [
        "1.0 mL",
        "1.8 mL",
        "2.5 mL",
        "3.0 mL",
      ],
      correct: 1
    },
    {
      id: 51042,
      question: "What should happen to tissue after topical anesthetic application?",
      options: [
        "Tissue should become red",
        "Tissue should blanch (turn white)",
        "Tissue should swell",
        "No visible change should occur",
      ],
      correct: 1
    },
    {
      id: 51043,
      question: "Why is aspiration important during local anesthetic injection?",
      options: [
        "To verify the anesthetic is flowing",
        "To ensure the needle is not in a blood vessel",
        "To measure the depth of penetration",
        "To reduce injection pressure",
      ],
      correct: 1
    },
    {
      id: 51044,
      question: "What should be included in patient assessment before local anesthesia?",
      options: [
        "Patient's hobbies and interests",
        "Health status, medications, and allergies",
        "Family medical history only",
        "Previous dental treatments only",
      ],
      correct: 1
    },
    {
      id: 51045,
      question: "How should anesthetic solution be deposited during injection?",
      options: [
        "As rapidly as possible",
        "Slowly over appropriate time",
        "In one quick bolus",
        "With intermittent stops every second",
      ],
      correct: 1
    },
    {
      id: 51046,
      question: "What describes the inferior alveolar nerve block's area of anesthesia?",
      options: [
        "Maxillary anterior teeth only",
        "Mandibular teeth from first molar to central incisor",
        "All maxillary teeth on one side",
        "Soft tissues only, no pulpal anesthesia",
      ],
      correct: 1
    },
    {
      id: 51047,
      question: "Which part of the cartridge does the harpoon engage?",
      options: [
        "Aluminum cap",
        "Rubber diaphragm",
        "Rubber stopper/plunger",
        "Glass cylinder",
      ],
      correct: 2
    },
    {
      id: 51048,
      question: "What is the correct order for loading a syringe?",
      options: [
        "Insert cartridge, attach needle, engage harpoon",
        "Attach needle, insert cartridge, engage harpoon",
        "Engage harpoon, insert cartridge, attach needle",
        "Insert cartridge, engage harpoon, attach needle",
      ],
      correct: 3
    },
    {
      id: 51049,
      question: "What indicates a cartridge should not be used?",
      options: [
        "Small air bubble present",
        "Clear solution",
        "Extruded stopper or corroded cap",
        "Intact aluminum cap",
      ],
      correct: 2
    },
    {
      id: 51051,
      question: "How should a used needle be transported back to the sterilization area?",
      options: [
        "In the operator's hand with cap",
        "In a covered container",
        "Wrapped in gauze",
        "In the original packaging",
      ],
      correct: 1
    },
    {
      id: 51052,
      question: "What nerve provides sensation to the lingual tissues adjacent to mandibular teeth?",
      options: [
        "Buccal nerve",
        "Mental nerve",
        "Lingual nerve",
        "Inferior alveolar nerve",
      ],
      correct: 2
    },
    {
      id: 51053,
      question: "What is the maximum number of injections typically given from one cartridge on the same patient?",
      options: [
        "One injection only",
        "Two to three injections",
        "As many as needed from one cartridge",
        "The entire cartridge must be used at once",
      ],
      correct: 1
    },
    {
      id: 51054,
      question: "Which cranial nerve is the trigeminal nerve?",
      options: [
        "Third cranial nerve",
        "Fifth cranial nerve",
        "Seventh cranial nerve",
        "Ninth cranial nerve",
      ],
      correct: 1
    },
    {
      id: 51055,
      question: "What happens when sodium ions remain outside the nerve cell during local anesthesia?",
      options: [
        "An action potential occurs normally",
        "An action potential never occurs",
        "The nerve becomes hyperexcitable",
        "Repolarization happens faster",
      ],
      correct: 1
    },
    {
      id: 51056,
      question: "Where are local anesthetic agents excreted after biotransformation?",
      options: [
        "Through perspiration",
        "In feces",
        "In urine",
        "Through respiration",
      ],
      correct: 2
    },
    {
      id: 51057,
      question: "What is a relative contraindication?",
      options: [
        "The drug must never be used",
        "The drug may be used with careful risk assessment",
        "The drug requires no special consideration",
        "The drug is always safe to use",
      ],
      correct: 1
    },
    {
      id: 51058,
      question: "What computer-controlled local anesthesia system is mentioned in the document?",
      options: [
        "The Injector",
        "The Wand",
        "The AutoSyringe",
        "The SmartNeedle",
      ],
      correct: 1
    },
    {
      id: 51059,
      question: "What submucosal anesthetic gel delivery system is discussed?",
      options: [
        "Septocaine",
        "EMLA",
        "Oraqix",
        "Cetacaine",
      ],
      correct: 2
    },
    {
      id: 51060,
      question: "What duration of soft tissue anesthesia does Oraqix provide?",
      options: [
        "5 minutes",
        "Approximately 20 minutes",
        "2 hours",
        "4 hours",
      ],
      correct: 1
    },
    {
      id: 51061,
      question: "What is the maximum recommended dose of Oraqix at one treatment session?",
      options: [
        "1 cartridge",
        "3 cartridges",
        "5 cartridges",
        "10 cartridges",
      ],
      correct: 2
    },
    {
      id: 51062,
      question: "What should be done before loading the Oraqix cartridge if the bubble is fixed?",
      options: [
        "Shake the cartridge vigorously",
        "Cool it in a refrigerator until it becomes liquid",
        "Heat it in warm water",
        "Replace it with a new cartridge",
      ],
      correct: 1
    },
    {
      id: 51063,
      question: "What typically constitutes one quadrant dose of Oraqix?",
      options: [
        "0.5 g or less",
        "1.7 g or less",
        "3.0 g",
        "5.0 g",
      ],
      correct: 1
    },
    {
      id: 51064,
      question: "What new drug delivery system for local anesthesia is FDA approved?",
      options: [
        "Transdermal patch",
        "Nasal spray",
        "Sublingual tablet",
        "Rectal suppository",
      ],
      correct: 1
    },
    {
      id: 51065,
      question: "What type of alternative syringe uses compressed air instead of a needle?",
      options: [
        "Computer-controlled syringe",
        "Self-aspirating syringe",
        "Pressure-type or jet injector",
        "Disposable syringe",
      ],
      correct: 2
    },
    {
      id: 51066,
      question: "What is the recommended length of needle for an inferior alveolar nerve block?",
      options: [
        "Extra-short needle",
        "Short needle",
        "Long needle",
        "Any length is acceptable",
      ],
      correct: 2
    },
    {
      id: 51067,
      question: "What determines the choice of needle gauge?",
      options: [
        "Cost considerations only",
        "Accessibility of area and aspiration requirements",
        "Patient preference",
        "Time of day",
      ],
      correct: 1
    },
    {
      id: 51068,
      question: "What problem can occur with a bent harpoon?",
      options: [
        "Cartridge leakage",
        "Inability to properly aspirate",
        "Needle breakage",
        "Rapid anesthetic delivery",
      ],
      correct: 1
    },
    {
      id: 51069,
      question: "Why should nonthreatening language be used when administering local anesthesia?",
      options: [
        "To comply with legal requirements",
        "To keep patients informed and reduce anxiety",
        "To shorten appointment time",
        "To avoid documentation",
      ],
      correct: 1
    },
    {
      id: 51070,
      question: "What could cause pain during needle insertion?",
      options: [
        "Using topical anesthetic",
        "Dull or barbed needle",
        "Slow injection technique",
        "Proper needle gauge",
      ],
      correct: 1
    },
    {
      id: 51071,
      question: "What happens if too much LA solution is deposited too rapidly?",
      options: [
        "Better anesthesia",
        "Tissue damage and pain",
        "Faster onset",
        "Longer duration",
      ],
      correct: 1
    },
    {
      id: 51072,
      question: "How should tissue be prepared before topical anesthetic application?",
      options: [
        "Kept moist with saliva",
        "Dried with sterile gauze",
        "Rinsed with water only",
        "No preparation needed",
      ],
      correct: 1
    },
    {
      id: 51073,
      question: "What position should the patient be in for local anesthesia administration?",
      options: [
        "Standing",
        "Supine or semi-supine",
        "Sitting upright at 90 degrees",
        "Prone",
      ],
      correct: 1
    },
    {
      id: 51074,
      question: "What should be done if blood appears in the cartridge during aspiration?",
      options: [
        "Continue injecting slowly",
        "Withdraw needle, replace cartridge, reinsert at different location",
        "Inject faster to clear the blood",
        "Stop and reschedule the appointment",
      ],
      correct: 1
    },
    {
      id: 51075,
      question: "What causes postanesthetic intraoral lesions?",
      options: [
        "Allergic reaction to anesthetic",
        "Trauma from biting numb tissue or viral lesions",
        "Bacterial infection from needle",
        "Chemical burn from anesthetic",
      ],
      correct: 1
    },
    {
      id: 51076,
      question: "What is the primary cause of facial nerve paralysis complication?",
      options: [
        "Anesthetic deposited near facial nerve",
        "Patient anxiety",
        "Contaminated anesthetic",
        "Using expired anesthetic",
      ],
      correct: 0
    },
    {
      id: 51077,
      question: "How long should you wait after depositing anesthetic before beginning treatment?",
      options: [
        "30 seconds",
        "1-2 minutes",
        "3-5 minutes depending on injection type",
        "10 minutes for all injections",
      ],
      correct: 2
    },
    {
      id: 51078,
      question: "What protective equipment should the operator wear during local anesthesia administration?",
      options: [
        "Gloves only",
        "Mask only",
        "Gloves, mask, and protective eyewear",
        "Surgical gown only",
      ],
      correct: 2
    },
    {
      id: 51079,
      question: "Where should topical anesthetic be stored?",
      options: [
        "In direct sunlight",
        "In a refrigerator",
        "At room temperature in a closed container",
        "In the freezer",
      ],
      correct: 2
    },
    {
      id: 51080,
      question: "What should be documented after local anesthesia administration?",
      options: [
        "Only the patient's reaction",
        "Type and amount of anesthetic, location, patient response",
        "Time of day only",
        "Nothing needs documentation",
      ],
      correct: 1
    }
  ],
  "4. Periodontal Assessments": [
    {
      id: 52001,
      question: "According to the ADA definition, what is periodontal assessment?",
      options: [
        "A surgical procedure to remove diseased tissue",
        "Collection and analysis of oral health data to establish patient needs",
        "The measurement of tooth mobility only",
        "A radiographic evaluation of bone loss"
      ],
      correct: 1
    },
    {
      id: 52002,
      question: "The periodontium consists of four physical units. Which of the following is NOT one of them?",
      options: [
        "Gingiva",
        "Periodontal ligament",
        "Alveolar mucosa",
        "Cementum"
      ],
      correct: 2
    },
    {
      id: 52003,
      question: "What characterizes the alveolar mucosa?",
      options: [
        "Firmly attached tissue with keratinization",
        "Moveable tissue loosely attached to underlying bone",
        "Tissue that blends into the periodontal ligament",
        "Mineralized tissue covering tooth roots"
      ],
      correct: 1
    },
    {
      id: 52004,
      question: "The junctional epithelium is described as which of the following?",
      options: [
        "The junction between enamel and dentin",
        "A hard tissue layer protecting the root surface",
        "A cufflike band of squamous epithelium encircling the tooth",
        "The space between adjacent teeth"
      ],
      correct: 2
    },
    {
      id: 52005,
      question: "What is gingival crevicular fluid (GCF)?",
      options: [
        "A serumlike fluid secreted from connective tissue into the sulcular space",
        "Saliva that pools around the teeth",
        "Blood from inflamed gingival tissue",
        "Bacterial exudate from periodontal pockets"
      ],
      correct: 0
    },
    {
      id: 52006,
      question: "Healthy gingival color varies according to several factors. Which is NOT one of them?",
      options: [
        "Degree of vascularity",
        "Amount of melanin pigmentation",
        "Degree of epithelial keratinization",
        "Patient's dietary intake"
      ],
      correct: 3
    },
    {
      id: 52007,
      question: "What are the essential periodontal assessment instruments?",
      options: [
        "Light source, air, mirror, explorer, probe, and radiographs",
        "Scaler, explorer, and mirror only",
        "Radiographs and visual examination only",
        "Probe and explorer exclusively"
      ],
      correct: 0
    },
    {
      id: 52008,
      question: "What is the typical measurement interval on a periodontal probe?",
      options: [
        "Every 2 mm along the entire length",
        "At 3, 6, 9, and 12 mm markings",
        "At 1, 2, 3, 4, 5, and 6 mm",
        "Only at 5 and 10 mm markings"
      ],
      correct: 1
    },
    {
      id: 52009,
      question: "When probing a tooth, you should assess how many zones per surface?",
      options: [
        "One zone covering the entire surface",
        "Two zones divided at the contact area",
        "Four zones around each tooth",
        "Three zones per tooth surface"
      ],
      correct: 3
    },
    {
      id: 52010,
      question: "According to the 2017 AAP-EFP classification, dental biofilm-induced gingivitis is characterized by all EXCEPT:",
      options: [
        "Presence of gingival inflammation",
        "Bleeding on probing",
        "Reversible with biofilm removal",
        "Irreversible bone loss"
      ],
      correct: 3
    },
    {
      id: 52011,
      question: "The new periodontal disease classification system includes how many stages of periodontitis?",
      options: [
        "Four stages",
        "Two stages",
        "Three stages",
        "Five stages"
      ],
      correct: 0
    },
    {
      id: 52012,
      question: "Stage I periodontitis is characterized by which probing depth?",
      options: [
        "2 mm or less",
        "4 mm or less",
        "6 mm or less",
        "8 mm or less"
      ],
      correct: 1
    },
    {
      id: 52013,
      question: "Stage IV periodontitis involves tooth loss of:",
      options: [
        "No tooth loss",
        "1 to 3 teeth lost",
        "5 or more teeth lost",
        "4 or less teeth lost"
      ],
      correct: 2
    },
    {
      id: 52014,
      question: "Grade A periodontitis progression is characterized by:",
      options: [
        "Moderate bone loss with smoking history",
        "No additional bone loss over past 5 years",
        "Rapid bone loss over 5 years",
        "Severe bone loss exceeding expectations"
      ],
      correct: 1
    },
    {
      id: 52015,
      question: "Which factor is a Grade C modifier for periodontitis?",
      options: [
        "Smoking 10 or more cigarettes daily",
        "Nonsmoking status",
        "No history of diabetes",
        "Low levels of tissue destruction"
      ],
      correct: 0
    },
    {
      id: 52016,
      question: "What characterizes peri-implant mucositis?",
      options: [
        "Bone loss around the implant",
        "Mobility of the implant",
        "Inflamed tissue with bleeding but no bone loss",
        "Reduced alveolar bone dimension"
      ],
      correct: 2
    },
    {
      id: 52017,
      question: "The initial lesion in periodontal disease progression occurs after how many days of biofilm accumulation?",
      options: [
        "1 day",
        "2 to 4 days",
        "7 to 14 days",
        "2 weeks or more"
      ],
      correct: 1
    },
    {
      id: 52018,
      question: "What is a suprabony periodontal pocket?",
      options: [
        "A pocket requiring surgical intervention",
        "A pocket where the base is coronal to the alveolar crest",
        "A pocket with bone loss extending beyond the mid-third of the root",
        "A pocket with vertical bone loss patterns"
      ],
      correct: 1
    },
    {
      id: 52019,
      question: "Clinical attachment level (CAL) is calculated using which two measurements?",
      options: [
        "Tooth length and gingival width",
        "Recession depth and pocket width",
        "Probing depth and distance from gingival margin to CEJ",
        "Bone loss and tooth mobility"
      ],
      correct: 2
    },
    {
      id: 52020,
      question: "Furcation involvement is commonly measured with which instrument?",
      options: [
        "Nabors probe",
        "Standard periodontal probe",
        "Explorer",
        "Shepherd's hook"
      ],
      correct: 0
    },
    {
      id: 52021,
      question: "What distance from the CEJ to the crestal bone is generally considered evidence of disease?",
      options: [
        "Greater than 1 mm",
        "Greater than 3 mm",
        "Greater than 2 mm",
        "Greater than 4 mm"
      ],
      correct: 2
    },
    {
      id: 52022,
      question: "Which radiographic technique is recommended for evaluating periodontal disease?",
      options: [
        "Horizontal bitewings only",
        "Panoramic projections",
        "Occlusal radiographs",
        "Periapical and/or vertical bitewings"
      ],
      correct: 3
    },
    {
      id: 52023,
      question: "What does CBCT stand for in dental imaging?",
      options: [
        "Cone-beam computed tomography",
        "Computerized Bone Clinical Test",
        "Clinical Bone Cavity Tomography",
        "Computed Bitewing Clinical Technique"
      ],
      correct: 0
    },
    {
      id: 52024,
      question: "Which of the following is the most reliable indicator that periodontal health will be maintained?",
      options: [
        "Absence of tooth mobility",
        "Continuous absence of bleeding on probing",
        "Normal probing depths",
        "Proper oral hygiene technique"
      ],
      correct: 1
    },
    {
      id: 52025,
      question: "Drug-influenced gingival enlargement can be caused by all of the following EXCEPT:",
      options: [
        "Calcium channel blockers",
        "Immunosuppressive drugs",
        "Antiseizure medications",
        "Antihistamine medications"
      ],
      correct: 3
    },
    {
      id: 52026,
      question: "What characterizes a Stillman cleft?",
      options: [
        "A V-shaped or slit-like defect in gingiva",
        "Cratered papillae between teeth",
        "Rolled gingival margins",
        "Bulbous interdental papillae"
      ],
      correct: 0
    },
    {
      id: 52027,
      question: "The width of the periodontal ligament depends on all EXCEPT:",
      options: [
        "Age of the individual",
        "Stage of tooth eruption",
        "Function of the tooth",
        "Color of the gingiva"
      ],
      correct: 3
    },
    {
      id: 52028,
      question: "Necrotizing periodontal disease is characterized by:",
      options: [
        "Slow progressive bone loss",
        "Papillary necrosis, bleeding, and pain",
        "Absence of inflammation",
        "Horizontal bone loss only"
      ],
      correct: 1
    },
    {
      id: 52029,
      question: "Which is considered a prohibited action when performing periodontal assessment?",
      options: [
        "Using a periodontal probe",
        "Taking radiographs",
        "Recording probing depths",
        "Entering sensitive financial data into forms"
      ],
      correct: 3
    },
    {
      id: 52030,
      question: "What type of bone comprises the alveolar process?",
      options: [
        "Only compact cortical bone",
        "Only spongy trabecular bone",
        "Mineralized cementum exclusively",
        "Compact cortical bone and spongy bone"
      ],
      correct: 3
    },
    {
      id: 52031,
      question: "Gingival shape abnormalities include all EXCEPT:",
      options: [
        "Pink stippled tissue",
        "Blunted papillae",
        "Bulbous margins",
        "Cratered interdental areas"
      ],
      correct: 0
    },
    {
      id: 52032,
      question: "Which diagnostic test involves sampling subgingival plaque to identify specific microorganisms?",
      options: [
        "Salivary diagnostics",
        "Microbiologic cultural analysis",
        "Radiographic evaluation",
        "Visual examination"
      ],
      correct: 1
    },
    {
      id: 52033,
      question: "What is fremitus in periodontal assessment?",
      options: [
        "Tooth discoloration",
        "Gingival inflammation",
        "Tooth movement during function",
        "Bleeding on probing"
      ],
      correct: 2
    },
    {
      id: 52034,
      question: "The periodontal screening and recording (PSR) system divides the mouth into how many sextants?",
      options: [
        "Four",
        "Six",
        "Eight",
        "Twelve"
      ],
      correct: 1
    },
    {
      id: 52035,
      question: "What size is the ball tip on a PSR probe?",
      options: [
        "0.5 mm",
        "0.3 mm",
        "0.7 mm",
        "1.0 mm"
      ],
      correct: 0
    },
    {
      id: 52036,
      question: "Which best describes \"prevalence\" in periodontal indices?",
      options: [
        "Number of new cases occurring over time",
        "Number of existing cases at a specific point in time",
        "Severity of destruction present",
        "Rate of disease progression"
      ],
      correct: 1
    },
    {
      id: 52037,
      question: "What is the primary purpose of using periodontal indices with patients?",
      options: [
        "To fulfill insurance requirements",
        "To determine surgical necessity",
        "To motivate patients and track changes over time",
        "To diagnose systemic diseases"
      ],
      correct: 2
    },
    {
      id: 52038,
      question: "Iatrogenic factors that may contribute to disease progression include:",
      options: [
        "Patient age and genetics",
        "Tobacco use and diabetes",
        "Stress and obesity",
        "Overhanging restorations and subgingival margins"
      ],
      correct: 3
    },
    {
      id: 52039,
      question: "Which is NOT a limitation of radiographic imaging for periodontal assessment?",
      options: [
        "Shows all furcation involvement clearly",
        "Cannot show soft tissue",
        "Projection factors may distort images",
        "Early interdental bone loss may be undetectable"
      ],
      correct: 0
    },
    {
      id: 52040,
      question: "Hyposalivation contributes to periodontal disease by:",
      options: [
        "Increasing acid production",
        "Facilitating bacterial plaque biofilm accumulation",
        "Causing immediate bone loss",
        "Preventing tooth eruption"
      ],
      correct: 1
    },
    {
      id: 52041,
      question: "Risk factors for periodontal disease include all EXCEPT:",
      options: [
        "Tobacco use",
        "Diabetes",
        "Leukemia",
        "Regular dental visits"
      ],
      correct: 3
    },
    {
      id: 52042,
      question: "What is the established lesion stage of periodontal disease?",
      options: [
        "2 to 4 days of biofilm accumulation",
        "7 to 14 days with redness and edema",
        "2 weeks or more with obvious chronic inflammation",
        "Advanced with apical progression"
      ],
      correct: 2
    },
    {
      id: 52043,
      question: "Peri-implantitis is characterized by:",
      options: [
        "Healthy tissue around the implant",
        "Bleeding on probing with no bone loss",
        "Slight redness without other symptoms",
        "Bleeding with progressive bone loss around implant"
      ],
      correct: 3
    },
    {
      id: 52044,
      question: "The mucogingival junction (MGJ) separates:",
      options: [
        "Alveolar gingiva from alveolar mucosa",
        "Enamel from dentin",
        "Free gingiva from attached gingiva",
        "Tooth from periodontal ligament"
      ],
      correct: 0
    },
    {
      id: 52045,
      question: "Grade B periodontitis shows evidence of:",
      options: [
        "No bone loss over 5 years",
        "Less than 2 mm bone loss over 5 years",
        "2 mm or more bone loss over 5 years",
        "Complete bone destruction"
      ],
      correct: 2
    },
    {
      id: 52046,
      question: "What is the maximum HbA1c level for Grade B in diabetic patients?",
      options: [
        "Less than 5%",
        "Less than 7%",
        "10% or greater",
        "7% or greater"
      ],
      correct: 1
    },
    {
      id: 52047,
      question: "Documentation in periodontal records serves all purposes EXCEPT:",
      options: [
        "Monitoring patient healing",
        "Meeting legal requirements",
        "Providing baseline data",
        "Replacing clinical judgment"
      ],
      correct: 3
    },
    {
      id: 52048,
      question: "The ADA defines assessment as a collection and analysis of oral health data to establish patient needs.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 52049,
      question: "The periodontal ligament is a mineralized tissue similar to bone.",
      options: [
        "True",
        "False"
      ],
      correct: 1
    },
    {
      id: 52050,
      question: "Healthy gingiva does not bleed when probed or air dried.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 52051,
      question: "The alveolar mucosa appears smooth and shiny and is loosely attached to underlying bone.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 52052,
      question: "Gingival crevicular fluid is essentially the same as saliva.",
      options: [
        "True",
        "False"
      ],
      correct: 1
    },
    {
      id: 52053,
      question: "Compressed air is currently being replaced by gauze for drying tissues during assessment.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 52054,
      question: "A periodontal probe should be walked across the tooth surface in overlapping increments.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 52055,
      question: "The 2017 AAP-EFP classification system eliminated the terms chronic and aggressive periodontitis.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 52056,
      question: "Stage III periodontitis involves 5 or more teeth lost due to periodontitis.",
      options: [
        "True",
        "False"
      ],
      correct: 1
    },
    {
      id: 52057,
      question: "Gingivitis is reversible with removal and disruption of bacterial biofilm.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 52058,
      question: "Panoramic radiographs are recommended for evaluating periodontal disease.",
      options: [
        "True",
        "False"
      ],
      correct: 1
    },
    {
      id: 52059,
      question: "The paralleling technique produces more anatomically accurate radiographic images than bisecting angle technique.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 52060,
      question: "Clinical attachment level distinguishes between gingivitis and periodontitis.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 52061,
      question: "Fremitus refers to visible tooth movement during function.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 52062,
      question: "The initial lesion of periodontal disease shows obvious clinical signs of inflammation.",
      options: [
        "True",
        "False"
      ],
      correct: 1
    },
    {
      id: 52063,
      question: "Peri-implant health is characterized by absence of redness, bleeding, and suppuration.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 52064,
      question: "Tobacco use is considered a modifiable risk factor for periodontal disease.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 52065,
      question: "The junctional epithelium is keratinized tissue.",
      options: [
        "True",
        "False"
      ],
      correct: 1
    },
    {
      id: 52066,
      question: "Bleeding on probing is caused by ulceration of the junctional and sulcular epithelium.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 52067,
      question: "Furcation involvement can always be detected on radiographs.",
      options: [
        "True",
        "False"
      ],
      correct: 1
    }
  ],
  "6-1. Oral Systemic Health Connection": [
    {
      id: 53001,
      question: "What is the relationship between periodontal diseases and systemic diseases?",
      options: [
        "Simple and easily understood with direct causation",
        "Complex with multiple factors to consider",
        "Nonexistent according to current research",
        "Only affects elderly patients exclusively"
      ],
      correct: 1
    },
    {
      id: 53002,
      question: "What are the three main topics for establishing causal association between two diseases?",
      options: [
        "Epidemiologic association, biological plausibility, intervention impact",
        "Patient age, genetic factors, environmental exposure",
        "Cost of treatment, insurance coverage, patient compliance",
        "Geographic location, socioeconomic status, education level"
      ],
      correct: 0
    },
    {
      id: 53003,
      question: "What is atherosclerotic cardiovascular disease (ACVD)?",
      options: [
        "Inflammation of the heart valves only",
        "When arteries narrow with plaque buildup",
        "Bacterial infection of cardiac tissue",
        "Congenital defect in heart structure"
      ],
      correct: 1
    },
    {
      id: 53004,
      question: "What conditions are associated with atherosclerotic cardiovascular disease?",
      options: [
        "Only high blood pressure and diabetes",
        "Exclusively respiratory and kidney diseases",
        "Angina, myocardial infarction, stroke, peripheral arterial disease",
        "Only digestive disorders and liver problems"
      ],
      correct: 2
    },
    {
      id: 53005,
      question: "What should dental care providers advise patients regarding cardiovascular disease management?",
      options: [
        "Only pharmaceutical interventions are effective",
        "Lifestyle modifications such as diet and exercise",
        "Avoid all physical activity completely",
        "Only surgical interventions can help"
      ],
      correct: 1
    },
    {
      id: 53006,
      question: "What characterizes type 1 diabetes mellitus?",
      options: [
        "Patients produce excessive amounts of insulin",
        "Patients cannot produce enough insulin",
        "Patients only have temporary insulin resistance",
        "Patients have normal insulin production"
      ],
      correct: 1
    },
    {
      id: 53007,
      question: "What characterizes type 2 diabetes mellitus?",
      options: [
        "Complete absence of all insulin production",
        "Patients' bodies cannot use insulin they produce",
        "Only affects children and adolescents",
        "Results from viral infections exclusively"
      ],
      correct: 1
    },
    {
      id: 53008,
      question: "What is a risk factor for developing type 2 diabetes?",
      options: [
        "Being underweight with low body fat",
        "Excessive physical activity and exercise",
        "Being overweight or obese",
        "Having no family history whatsoever"
      ],
      correct: 2
    },
    {
      id: 53009,
      question: "Which factor increases the risk of type 2 diabetes?",
      options: [
        "Young age below ten years old",
        "Physical inactivity and sedentary lifestyle",
        "Normal cholesterol levels consistently",
        "Absence of any genetic factors"
      ],
      correct: 1
    },
    {
      id: 53010,
      question: "What patient characteristic is a risk factor for type 2 diabetes?",
      options: [
        "Female gender exclusively without other factors",
        "Family history of diabetes",
        "Living in cold climate regions",
        "Having blond hair and blue eyes"
      ],
      correct: 1
    },
    {
      id: 53011,
      question: "Which demographic factor can influence type 2 diabetes risk?",
      options: [
        "Height and shoe size measurements",
        "Eye color and hair texture",
        "Race and ethnicity background",
        "Left or right hand dominance"
      ],
      correct: 2
    },
    {
      id: 53012,
      question: "What age-related factor affects type 2 diabetes risk?",
      options: [
        "Only pediatric patients are affected",
        "Advancing age increases risk",
        "Risk decreases with increasing age",
        "Age has no relationship whatsoever"
      ],
      correct: 1
    },
    {
      id: 53013,
      question: "What cholesterol abnormality is a diabetes risk factor?",
      options: [
        "Perfectly normal cholesterol levels only",
        "Abnormal cholesterol levels",
        "High HDL cholesterol exclusively",
        "Low triglyceride levels only"
      ],
      correct: 1
    },
    {
      id: 53014,
      question: "What pregnancy-related history increases diabetes risk?",
      options: [
        "History of uncomplicated pregnancies only",
        "Having multiple successful deliveries",
        "History of gestational diabetes",
        "Never having been pregnant"
      ],
      correct: 2
    },
    {
      id: 53015,
      question: "What are adverse pregnancy outcomes that can occur?",
      options: [
        "Only maternal weight gain issues",
        "Low birth weight, preterm birth, preeclampsia",
        "Exclusively fetal hair color variations",
        "Only postpartum depression symptoms"
      ],
      correct: 1
    },
    {
      id: 53016,
      question: "What are adverse pregnancy outcomes generally associated with?",
      options: [
        "Normal physiological pregnancy changes only",
        "Inflammation and intrauterine infections",
        "Adequate prenatal vitamin supplementation",
        "Regular exercise during pregnancy"
      ],
      correct: 1
    },
    {
      id: 53017,
      question: "When should elective dental procedures be avoided during pregnancy?",
      options: [
        "During the second trimester exclusively",
        "Throughout the entire pregnancy period",
        "In the first trimester",
        "Only during the third trimester"
      ],
      correct: 2
    },
    {
      id: 53018,
      question: "How are pregnant patients clinically classified periodontally?",
      options: [
        "Only as having severe periodontitis",
        "Healthy periodontium, gingivitis, or periodontitis",
        "Exclusively as having gingivitis",
        "Only as having healthy tissues"
      ],
      correct: 1
    },
    {
      id: 53019,
      question: "What respiratory disease is being investigated for links to periodontitis?",
      options: [
        "Asthma and allergic rhinitis only",
        "Common cold and influenza exclusively",
        "Respiratory infections of any type",
        "Chronic obstructive pulmonary disease"
      ],
      correct: 3
    },
    {
      id: 53020,
      question: "What systemic disease undergoing investigation has kidney involvement?",
      options: [
        "Acute appendicitis with complications",
        "Chronic kidney disease",
        "Gallbladder disease exclusively",
        "Pancreatic insufficiency only"
      ],
      correct: 1
    },
    {
      id: 53021,
      question: "What autoimmune condition is being investigated for periodontal links?",
      options: [
        "Psoriasis and eczema exclusively",
        "Lupus erythematosus only",
        "Rheumatoid arthritis",
        "Multiple sclerosis exclusively"
      ],
      correct: 2
    },
    {
      id: 53022,
      question: "What neurological condition is under investigation regarding periodontal disease?",
      options: [
        "Parkinson's disease exclusively",
        "Cognitive impairment and dementia",
        "Epilepsy and seizure disorders",
        "Migraine headaches only"
      ],
      correct: 1
    },
    {
      id: 53023,
      question: "What metabolic condition is being studied for periodontal connections?",
      options: [
        "Hyperthyroidism and goiter only",
        "Obesity and excess body weight",
        "Addison's disease exclusively",
        "Growth hormone deficiency"
      ],
      correct: 1
    },
    {
      id: 53024,
      question: "What syndrome combining multiple metabolic abnormalities is under investigation?",
      options: [
        "Down syndrome and genetic disorders",
        "Chronic fatigue syndrome exclusively",
        "Metabolic syndrome",
        "Irritable bowel syndrome"
      ],
      correct: 2
    },
    {
      id: 53025,
      question: "What serious disease category is being investigated for periodontal links?",
      options: [
        "Infectious diseases exclusively",
        "Autoimmune disorders only",
        "Various types of cancer",
        "Genetic disorders exclusively"
      ],
      correct: 2
    },
    {
      id: 53026,
      question: "For which systemic diseases is the periodontal association evidence most robust?",
      options: [
        "Type 2 diabetes and cardiovascular diseases",
        "Only respiratory diseases exclusively",
        "Exclusively cancer and tumors",
        "Only kidney and liver diseases"
      ],
      correct: 0
    },
    {
      id: 53027,
      question: "What should healthcare providers aim to promote for all patients?",
      options: [
        "Only oral health without systemic considerations",
        "Overall health for all patients",
        "Exclusively disease treatment approaches",
        "Only pharmaceutical interventions"
      ],
      correct: 1
    },
    {
      id: 53028,
      question: "What remains a simple and cost-effective procedure for the dental team?",
      options: [
        "Complex surgical interventions only",
        "Reduction of intraoral biofilm and gingival inflammation",
        "Expensive laboratory testing exclusively",
        "Lengthy pharmaceutical protocols only"
      ],
      correct: 1
    },
    {
      id: 53029,
      question: "What increased risk do patients with periodontitis face?",
      options: [
        "Developing skin rashes exclusively",
        "Developing aortic atheroma",
        "Having hair loss problems",
        "Experiencing vision changes only"
      ],
      correct: 1
    },
    {
      id: 53030,
      question: "What have studies on periodontal therapy's effect on cardiovascular events shown?",
      options: [
        "Definitive prevention of all events",
        "Complete cure of cardiovascular disease",
        "Results have been inconclusive",
        "Increased cardiovascular event risk"
      ],
      correct: 2
    },
    {
      id: 53031,
      question: "What have periodontal treatment studies demonstrated regarding cardiovascular markers?",
      options: [
        "Increased inflammatory markers consistently",
        "Decreased serum CRP levels and improved endothelial function",
        "No changes in any markers",
        "Worsening of all cardiovascular parameters"
      ],
      correct: 1
    },
    {
      id: 53032,
      question: "What type of relationship exists between periodontitis and diabetes?",
      options: [
        "One-directional with diabetes causing periodontitis only",
        "No relationship exists between them",
        "Bi-directional relationship",
        "Only periodontitis causes diabetes"
      ],
      correct: 2
    },
    {
      id: 53033,
      question: "How does periodontal inflammation affect blood glucose control?",
      options: [
        "Has no effect on glucose levels",
        "The more extensive the inflammation, the more difficult glucose control",
        "Always improves glucose control",
        "Only affects insulin production"
      ],
      correct: 1
    },
    {
      id: 53034,
      question: "What should periodontal treatment and maintenance help improve in diabetic patients?",
      options: [
        "Only oral health without systemic effects",
        "Blood glucose control",
        "Exclusively gingival appearance",
        "Only tooth mobility issues"
      ],
      correct: 1
    },
    {
      id: 53035,
      question: "What interval is recommended for supportive periodontal care in diabetic patients?",
      options: [
        "Annual visits are sufficient",
        "Five-year intervals recommended",
        "Three-month intervals recommended",
        "Six-month intervals exclusively"
      ],
      correct: 2
    },
    {
      id: 53036,
      question: "What is the direct pathway for adverse pregnancy outcomes related to oral bacteria?",
      options: [
        "Bacteria remain confined to oral cavity",
        "Bacteria reach fetal-placental unit via bloodstream or vagina",
        "Bacteria only affect maternal tissues",
        "Bacteria cannot leave the mouth"
      ],
      correct: 1
    },
    {
      id: 53037,
      question: "What is the indirect pathway for adverse pregnancy outcomes?",
      options: [
        "No inflammatory mediators are involved",
        "Inflammatory mediators travel via bloodstream to fetal-placental unit",
        "Only direct bacterial infection occurs",
        "Inflammation stays localized to gums"
      ],
      correct: 1
    },
    {
      id: 53038,
      question: "What is community-acquired pneumonia?",
      options: [
        "Pneumonia contracted outside healthcare settings",
        "Pneumonia only from dental offices",
        "Pneumonia exclusively from hospitals",
        "Pneumonia only from ventilators"
      ],
      correct: 0
    },
    {
      id: 53039,
      question: "What is nosocomial hospital-acquired pneumonia?",
      options: [
        "Pneumonia from community exposure only",
        "Pneumonia acquired in hospital settings",
        "Pneumonia from home environment",
        "Pneumonia from outdoor activities"
      ],
      correct: 1
    },
    {
      id: 53040,
      question: "What is ventilator-associated pneumonia?",
      options: [
        "Pneumonia from room air only",
        "Pneumonia unrelated to mechanical ventilation",
        "Pneumonia occurring in ventilated patients",
        "Pneumonia from environmental allergens"
      ],
      correct: 2
    },
    {
      id: 53041,
      question: "What is aspiration pneumonia?",
      options: [
        "Pneumonia from inhaling airborne particles only",
        "Pneumonia from inhaled oral/gastric contents",
        "Pneumonia from viral infections exclusively",
        "Pneumonia from bacterial skin infections"
      ],
      correct: 1
    },
    {
      id: 53042,
      question: "What is the strength of evidence linking periodontitis to COPD?",
      options: [
        "Strong and definitive evidence exists",
        "Some limited, weak evidence with need for more research",
        "No evidence exists at all",
        "Overwhelming conclusive evidence available"
      ],
      correct: 1
    },
    {
      id: 53043,
      question: "The relationship between periodontal diseases and systemic diseases is complex.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 53044,
      question: "Epidemiologic association is one of the three main topics for establishing causal association between two diseases.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 53045,
      question: "Atherosclerotic cardiovascular disease occurs when arteries narrow with plaque buildup.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 53046,
      question: "Type 1 diabetes is characterized by patients' inability to produce enough insulin.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 53047,
      question: "Type 2 diabetes occurs when patients' bodies cannot use the insulin they produce.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 53048,
      question: "Being overweight or obese is a risk factor for developing type 2 diabetes.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 53049,
      question: "Low birth weight, preterm birth, and preeclampsia are examples of adverse pregnancy outcomes.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 53050,
      question: "Elective dental procedures should be avoided in the first trimester of pregnancy.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 53051,
      question: "Chronic kidney disease is one of the diseases undergoing investigation for links to periodontal disease.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 53052,
      question: "The scientific evidence for association between periodontitis and type 2 diabetes mellitus is robust.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 53053,
      question: "Reduction of intraoral biofilm and gingival inflammation is a simple and cost-effective procedure for the dental team.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 53054,
      question: "Patients with periodontitis are at increased risk for developing aortic atheroma.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 53055,
      question: "Research supports a bi-directional relationship between periodontitis and diabetes.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 53056,
      question: "Three-month intervals for supportive periodontal care are recommended for diabetic patients.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 53057,
      question: "The direct pathway for adverse pregnancy outcomes involves oral bacteria reaching the fetal-placental unit via the bloodstream.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    }
  ],
  "14. Rubber Dam": [
    {
      id: 54001,
      question: "What does restorative therapy include?",
      options: [
        "Restorations of damaged tooth, defective restorations, esthetic appearance, and decayed areas",
        "Only treatment of damaged teeth exclusively",
        "Only cosmetic procedures for anterior teeth",
        "Exclusively preventive care and cleanings"
      ],
      correct: 0
    },
    {
      id: 54002,
      question: "What allows every team member to contribute their expertise in dental practice?",
      options: [
        "Strict hierarchy with limited communication",
        "Individual work without collaboration",
        "Separate treatment protocols for each provider",
        "Efficient use of all team members"
      ],
      correct: 3
    },
    {
      id: 54003,
      question: "What does the restorative care cycle integrate?",
      options: [
        "Only the dentist's role in treatment",
        "The role of dentist and dental hygienist throughout restorative care",
        "Only auxiliary staff responsibilities",
        "Patient self-care without professional involvement"
      ],
      correct: 1
    },
    {
      id: 54004,
      question: "Why has the scope of dental hygiene practice been expanded?",
      options: [
        "To reduce insurance costs for patients",
        "To eliminate the need for dentists",
        "To improve access to oral healthcare for underserved populations",
        "To increase profit margins for practices"
      ],
      correct: 2
    },
    {
      id: 54005,
      question: "What additional qualification can be obtained in Ontario for dental hygienists?",
      options: [
        "Restorative Dental Hygienist Diploma",
        "Orthodontic Specialist Certificate",
        "Periodontal Surgery License",
        "Endodontic Treatment Certification"
      ],
      correct: 0
    },
    {
      id: 54006,
      question: "What are dental hygienists currently allowed to do?",
      options: [
        "Perform root canal therapy",
        "Extract permanent teeth",
        "Prescribe narcotic pain medications",
        "IST placement procedures"
      ],
      correct: 3
    },
    {
      id: 54007,
      question: "What are examples of indirect restorations?",
      options: [
        "Amalgam fillings and composite resins",
        "Porcelain crowns and gold inlays",
        "Temporary cement and zinc oxide",
        "Fluoride varnish and sealant materials"
      ],
      correct: 1
    },
    {
      id: 54008,
      question: "What are examples of direct restorations?",
      options: [
        "Porcelain veneers and gold crowns",
        "Removable partial dentures only",
        "Amalgams, resin-based composites, or direct gold",
        "Fixed bridge abutments exclusively"
      ],
      correct: 2
    },
    {
      id: 54009,
      question: "What is the purpose of dental isolation?",
      options: [
        "To improve quality and comfort of restorative treatment",
        "To separate the dentist from the patient",
        "To prevent communication during procedures",
        "To eliminate the need for anesthesia"
      ],
      correct: 0
    },
    {
      id: 54010,
      question: "What does dental isolation provide in terms of moisture control?",
      options: [
        "Increases salivary flow during procedures",
        "Eliminates need for suction devices",
        "Prevents patient from swallowing entirely",
        "Controls moisture, improves accessibility and visibility"
      ],
      correct: 3
    },
    {
      id: 54011,
      question: "What does dental isolation provide for safety?",
      options: [
        "Protects only the dentist from injury",
        "Provides client and practitioner protection",
        "Guards only against chemical exposure",
        "Prevents only needle stick injuries"
      ],
      correct: 1
    },
    {
      id: 54012,
      question: "What is a disadvantage of rubber dam isolation?",
      options: [
        "It is too inexpensive to use",
        "Provides inadequate moisture control",
        "Time consuming and occasionally client objection",
        "Cannot be used with any procedure"
      ],
      correct: 2
    },
    {
      id: 54013,
      question: "What is a contraindication for rubber dam use?",
      options: [
        "Commissure cracking, herpetic lesions, respiratory congestion, asthma, latex allergy",
        "Patient cooperation and good health",
        "Young age and excellent oral hygiene",
        "Previous positive experience with isolation"
      ],
      correct: 0
    },
    {
      id: 54014,
      question: "When may rubber dam be used in dental hygiene?",
      options: [
        "For routine prophylaxis only",
        "During patient education sessions",
        "For medical history review",
        "For placement of pit and fissure sealants"
      ],
      correct: 3
    },
    {
      id: 54015,
      question: "What additional procedure may rubber dam be used for in dental hygiene?",
      options: [
        "Periodontal charting documentation",
        "IST temporary restorative placement",
        "Taking intraoral photographs",
        "Measuring blood pressure"
      ],
      correct: 1
    },
    {
      id: 54016,
      question: "What equipment is needed for rubber dam placement for sealants?",
      options: [
        "Amalgam carrier and condenser",
        "Ultrasonic scaler and tips",
        "Rubber dam, clamp, floss, frame, hole puncher, clamp forceps",
        "Anesthetic syringe and needles"
      ],
      correct: 2
    },
    {
      id: 54017,
      question: "What type of alternative rubber dam exists?",
      options: [
        "All-in-one frame and dam",
        "Disposable paper barriers",
        "Cotton roll holders only",
        "Gauze squares taped together"
      ],
      correct: 0
    },
    {
      id: 54018,
      question: "What additional items are required for the alternative rubber dam type?",
      options: [
        "Extra frames and punches",
        "Matrix bands and wedges",
        "Articulating paper and holder",
        "Clamp, forceps, and floss"
      ],
      correct: 3
    },
    {
      id: 54019,
      question: "How many different rubber dam frame types are commonly available?",
      options: [
        "Two frame types only",
        "Four frame types including autoclavable and stainless steel",
        "One universal type exclusively",
        "Six specialized frame designs"
      ],
      correct: 1
    },
    {
      id: 54020,
      question: "What material are some rubber dam frames made from?",
      options: [
        "Aluminum and copper alloys",
        "Disposable paper products",
        "Autoclavable plastic and stainless steel",
        "Titanium and gold compounds"
      ],
      correct: 2
    },
    {
      id: 54021,
      question: "What feature do some rubber dam frames have for radiographs?",
      options: [
        "Foldable design for x-ray film",
        "Radiopaque markers embedded",
        "Built-in lead shielding",
        "Removable metal components"
      ],
      correct: 0
    },
    {
      id: 54022,
      question: "What may be needed for IST placement?",
      options: [
        "Periodontal probe and explorer",
        "Rubber cup and prophy paste",
        "Fluoride tray and gel",
        "Tofflemire holder with matrix band and wedge"
      ],
      correct: 3
    },
    {
      id: 54023,
      question: "What is the tofflemire holder used for?",
      options: [
        "Holding the rubber dam clamp",
        "Holding matrix band during IST placement",
        "Grasping extraction forceps",
        "Stabilizing the suction device"
      ],
      correct: 1
    },
    {
      id: 54024,
      question: "What material is usually used for IST?",
      options: [
        "Composite resin material",
        "Glass ionomer cement",
        "Zinc-Oxide Eugenol",
        "Amalgam alloy mixture"
      ],
      correct: 2
    },
    {
      id: 54025,
      question: "What alternative IST material might some offices have?",
      options: [
        "Ready-mixed temporary material",
        "Permanent crown and bridge cement",
        "Orthodontic bonding adhesive",
        "Endodontic sealer paste"
      ],
      correct: 0
    },
    {
      id: 54026,
      question: "Where will students review rubber dam placement?",
      options: [
        "During clinical rotations only",
        "In online modules exclusively",
        "Through patient demonstrations alone",
        "In Materials Lab"
      ],
      correct: 3
    },
    {
      id: 54027,
      question: "What will students learn to assemble in Materials Lab?",
      options: [
        "Ultrasonic scaling units",
        "Tofflemire matrix system",
        "Autoclave sterilization equipment",
        "Digital radiography sensors"
      ],
      correct: 1
    },
    {
      id: 54028,
      question: "What will students learn to mix in Materials Lab?",
      options: [
        "Alginate impression material",
        "Prophylaxis polishing paste",
        "Temporary restoration material",
        "Topical anesthetic gel"
      ],
      correct: 2
    },
    {
      id: 54029,
      question: "What skill regarding temporary restorations is learned in Materials Lab?",
      options: [
        "Placing temporary restorations",
        "Removing permanent crowns",
        "Adjusting partial dentures",
        "Cementing permanent bridges"
      ],
      correct: 0
    },
    {
      id: 54030,
      question: "What does efficient team member use allow?",
      options: [
        "Reduced treatment quality standards",
        "Elimination of continuing education",
        "Decreased patient care coordination",
        "Every member to contribute expertise"
      ],
      correct: 3
    },
    {
      id: 54031,
      question: "Restorative therapy includes restoration of damaged teeth, defective restorations, esthetic appearance, and decayed areas.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 54032,
      question: "The restorative care cycle integrates only the dentist's role without dental hygienist involvement.",
      options: [
        "True",
        "False"
      ],
      correct: 1
    },
    {
      id: 54033,
      question: "In Ontario, dental hygienists can obtain a Restorative Dental Hygienist Diploma.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 54034,
      question: "Indirect restorations include porcelain crowns and gold inlays.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 54035,
      question: "Direct restorations include amalgams, resin-based composites, and direct gold.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 54036,
      question: "The purpose of dental isolation is to improve quality and comfort of restorative treatment.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 54037,
      question: "A disadvantage of rubber dam isolation is that it is time consuming.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 54038,
      question: "Latex allergy is a contraindication for rubber dam use.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 54039,
      question: "Rubber dam may be used for placement of pit and fissure sealants in dental hygiene.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 54040,
      question: "The alternative type of rubber dam is an all-in-one frame and dam.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 54041,
      question: "For IST placement, a tofflemire holder with matrix band and wedge may be needed.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 54042,
      question: "The material usually used for IST is Zinc-Oxide Eugenol.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    },
    {
      id: 54043,
      question: "Students will review rubber dam placement in Materials Lab.",
      options: [
        "True",
        "False"
      ],
      correct: 0
    }
  ]
,
  "1-1. Medical and Dental History": [
    {
      id: 55001,
      question: "What is the primary reason for completing a health history assessment at the start of every client appointment?",
      options: [
        "To fulfill legal documentation requirements only",
        "To identify existing health conditions that may influence clinical outcomes",
        "To determine the client's insurance coverage",
        "To establish the client's payment history",
      ],
      correct: 1
    },
    {
      id: 55002,
      question: "According to the ASA Physical Status Classification System, which classification indicates a patient with severe systemic disease that is a constant threat to life?",
      options: [
        "ASA II",
        "ASA III",
        "ASA IV",
        "ASA I",
      ],
      correct: 2
    },
    {
      id: 55004,
      question: "Which of the following describes client-centered interviewing?",
      options: [
        "A technique where clinicians focus only on medical symptoms",
        "A method that uses only closed-ended questions for efficiency",
        "A technique to elicit the client's emotions and personal health agenda to understand psychosocial context",
        "An approach that prioritizes the clinician's treatment plan over client concerns",
      ],
      correct: 2
    },
    {
      id: 55006,
      question: "What does MET stand for in relation to cardiovascular assessment?",
      options: [
        "Medical Emergency Treatment",
        "Metabolic Equivalents",
        "Maximum Exercise Tolerance",
        "Muscular Endurance Test",
      ],
      correct: 1
    },
    {
      id: 55007,
      question: "If a client can walk up a flight of stairs without symptomatic limitations, what MET level have they likely achieved?",
      options: [
        "Two MET level",
        "Three MET level",
        "Four MET level",
        "Five MET level",
      ],
      correct: 2
    },
    {
      id: 55008,
      question: "Which classification describes a normal healthy patient according to the ASA system?",
      options: [
        "ASA I",
        "ASA II",
        "ASA III",
        "ASA IV",
      ],
      correct: 0
    },
    {
      id: 55010,
      question: "Which of the following conditions does NOT require documentation in the Medical Alert Box?",
      options: [
        "Pre-medication requirements",
        "Type I or II Diabetes",
        "Routine dental cleanings",
        "Anaphylactic allergies requiring an EpiPen",
      ],
      correct: 2
    },
    {
      id: 55011,
      question: "What is the proper way to correct an error on a health history form?",
      options: [
        "Use white-out to cover the mistake",
        "Write over the mistake with correct information",
        "Line out the error, initial, and date it",
        "Start a new form from the beginning",
      ],
      correct: 2
    },
    {
      id: 55012,
      question: "According to PHIPA and PIPEDA, what type of information is protected?",
      options: [
        "Only financial information",
        "Personal health information including name, birth date, address, and S.I.N.",
        "Only medical diagnosis information",
        "Only dental treatment records",
      ],
      correct: 1
    },
    {
      id: 55013,
      question: "What is transient bacteremia?",
      options: [
        "A permanent bacterial infection in the bloodstream",
        "The release of bacteria into the bloodstream during dental procedures",
        "A bacterial infection of the gums",
        "A condition requiring immediate hospitalization",
      ],
      correct: 1
    },
    {
      id: 55014,
      question: "When should prophylactic antibiotic premedication be administered?",
      options: [
        "Immediately after the dental procedure",
        "2-3 hours before the dental procedure",
        "1/2 to 1 hour before the dental procedure",
        "The night before the dental procedure",
      ],
      correct: 2
    },
    {
      id: 55015,
      question: "What is infective endocarditis?",
      options: [
        "A minor gum infection",
        "A life-threatening infection of the tissue lining the heart",
        "An inflammation of the tooth pulp",
        "A temporary bacterial presence in saliva",
      ],
      correct: 1
    },
    {
      id: 55016,
      question: "Which organization developed the Physical Status Classification System?",
      options: [
        "American Dental Association",
        "World Health Organization",
        "American Society of Anesthesiologists",
        "Centers for Disease Control",
      ],
      correct: 2
    },
    {
      id: 55017,
      question: "What percentage of adults in the United States are functionally illiterate ?",
      options: [
        "1 in 5",
        "1 in 7",
        "1 in 10",
        "1 in 15",
      ],
      correct: 1
    },
    {
      id: 55018,
      question: "Which of the following is a purpose of the health history assessment?",
      options: [
        "To replace the need for clinical examination",
        "To understand client concerns, attitudes, and goals for the visit",
        "To determine the client's employment status",
        "To assess the client's dental insurance benefits",
      ],
      correct: 1
    },
    {
      id: 55019,
      question: "What type of questions should be used in client-centered interviewing to encourage discussion?",
      options: [
        "Yes/no questions only",
        "Leading questions",
        "Open-ended questions",
        "Multiple choice questions",
      ],
      correct: 2
    },
    {
      id: 55020,
      question: "Where should the health history interview be conducted to ensure confidentiality?",
      options: [
        "In the reception area with other patients present",
        "In a private setting, never in hearing range of others",
        "In the hallway between treatment rooms",
        "At the front desk during check-in",
      ],
      correct: 1
    },
    {
      id: 55021,
      question: "What is the rationale behind antibiotic prophylaxis premedication?",
      options: [
        "To treat existing infections in the mouth",
        "To prevent all types of bacterial infections",
        "To prevent transient bacteremia from developing into infective endocarditis",
        "To reduce pain during dental procedures",
      ],
      correct: 2
    },
    {
      id: 55024,
      question: "What does \"back channeling\" refer to in communication strategies?",
      options: [
        "Talking behind the client's back",
        "Using neutral, encouraging verbal and nonverbal responses to show listening and understanding",
        "Referring the client to another provider",
        "Recording the conversation for later review",
      ],
      correct: 1
    },
    {
      id: 55026,
      question: "What should be done if a client reveals a condition that may jeopardize safety during care?",
      options: [
        "Proceed with treatment as planned",
        "Cancel all future appointments permanently",
        "Contact the physician of record for consultation",
        "Refer the client to the emergency room immediately",
      ],
      correct: 2
    },
    {
      id: 55028,
      question: "What must be obtained before consulting with a client's physician?",
      options: [
        "Payment for the consultation",
        "Written and verbal informed consent from the client",
        "Approval from the clinic director only",
        "A second opinion from another dentist",
      ],
      correct: 1
    },
    {
      id: 55029,
      question: "How should drug write-ups be completed in clinic ?",
      options: [
        "Only for prescription medications",
        "For all medications including multivitamins like Centrum",
        "For all medications except multivitamins",
        "Only for medications that affect dental treatment",
      ],
      correct: 2
    },
    {
      id: 55031,
      question: "Which of the following conditions requires medical clearance according to the clinic manual?",
      options: [
        "Routine dental cleaning history",
        "Previous orthodontic treatment",
        "Active chemotherapy or radiation therapy",
        "History of dental fillings",
      ],
      correct: 2
    },
    {
      id: 55032,
      question: "What position should the client be in during the health history interview?",
      options: [
        "Lying flat in the dental chair",
        "Standing near the door",
        "Comfortably seated upright, at eye level with the clinician",
        "Seated in the waiting room",
      ],
      correct: 2
    },
    {
      id: 55033,
      question: "Which of the following is documented in the progress notes but NOT in the medical alert box?",
      options: [
        "Allergies requiring an EpiPen",
        "Type I Diabetes",
        "Vitals that need to be monitored",
        "Pre-medication requirements",
      ],
      correct: 2
    },
    {
      id: 55034,
      question: "What type of communication should clinicians observe during the health history process?",
      options: [
        "Only verbal communication",
        "Only written communication",
        "Written, verbal, and nonverbal communication",
        "Only nonverbal communication",
      ],
      correct: 2
    },
    {
      id: 55035,
      question: "What can medical issues do in relation to periodontal diseases?",
      options: [
        "Completely prevent periodontal diseases",
        "Have no effect on periodontal health",
        "Increase susceptibility to periodontal diseases",
        "Only affect tooth color, not periodontal health",
      ],
      correct: 2
    },
    {
      id: 55036,
      question: "Which legislation protects personal health information in Canada?",
      options: [
        "HIPAA only",
        "PHIPA and PIPEDA",
        "ADA regulations",
        "OSHA standards",
      ],
      correct: 1
    },
    {
      id: 55037,
      question: "What should students do before each clinical session ?",
      options: [
        "Only bring their instruments",
        "Review client charts and come prepared",
        "Wait for instructor assignments",
        "Complete paperwork during the appointment",
      ],
      correct: 1
    },
    {
      id: 55038,
      question: "What is the proper documentation format when a client takes antibiotic premedication?",
      options: [
        "Note that antibiotics were prescribed",
        "Document the dose, when taken, and time before appointment",
        "Only record the medication name",
        "Documentation is not required if client confirms taking it",
      ],
      correct: 1
    },
    {
      id: 55039,
      question: "Which of the following is an example of a condition that may have periodontal manifestations?",
      options: [
        "Common cold",
        "Seasonal allergies",
        "Leukemia",
        "Broken bone",
      ],
      correct: 2
    },
    {
      id: 55041,
      question: "According to ASA classification, a patient with mild systemic disease is classified as what?",
      options: [
        "ASA I",
        "ASA II",
        "ASA III",
        "ASA IV",
      ],
      correct: 1
    },
    {
      id: 55042,
      question: "What is the main purpose of documenting baseline information in the health history?",
      options: [
        "To create extra paperwork",
        "To compare with future assessments and track changes",
        "To satisfy insurance requirements only",
        "To limit treatment options",
      ],
      correct: 1
    },
    {
      id: 55043,
      question: "Which of the following demonstrates proper rapport building with clients?",
      options: [
        "Rushing through questions quickly",
        "Eye contact and active listening skills",
        "Completing forms without client interaction",
        "Focusing only on dental concerns",
      ],
      correct: 1
    },
    {
      id: 55044,
      question: "What aspect of assessment includes beliefs, religious experiences, and fellowship?",
      options: [
        "Physical assessment",
        "Emotional assessment",
        "Spiritual assessment",
        "Cognitive assessment",
      ],
      correct: 2
    },
    {
      id: 55045,
      question: "In the comprehensive patient health history diagram, what is included in the personal assessment?",
      options: [
        "Previous health problems",
        "Members of household and marital status",
        "Cognitive performance",
        "Religious experiences",
      ],
      correct: 1
    },
    {
      id: 55046,
      question: "Which assessment category includes recreational activities and cultural influences?",
      options: [
        "Physical assessment",
        "Emotional assessment",
        "Societal assessment",
        "Personal assessment",
      ],
      correct: 2
    },
    {
      id: 55047,
      question: "What component is part of the cognitive assessment in patient health history?",
      options: [
        "Body image and sexuality",
        "Marital status",
        "Problem solving and educational level",
        "Risk factors",
      ],
      correct: 2
    },
    {
      id: 55048,
      question: "What is included in the emotional assessment of patient health history?",
      options: [
        "Occupation and financial status",
        "Behavioral and emotional status",
        "Activity and coordination",
        "Communication patterns",
      ],
      correct: 1
    },
    {
      id: 55049,
      question: "Which of the following would be considered part of a comprehensive health history?",
      options: [
        "Dental history only",
        "Medical history only",
        "Demographic information, chief complaints, dental history, medical history, and social history",
        "Insurance information only",
      ],
      correct: 2
    },
    {
      id: 55050,
      question: "What does the physical assessment component evaluate regarding developmental stages?",
      options: [
        "Only current physical capabilities",
        "Effect of health status on developmental stage",
        "Future developmental milestones only",
        "Educational achievements",
      ],
      correct: 1
    },
    {
      id: 55051,
      question: "What type of medication side effects should be considered during medical history review?",
      options: [
        "Only pain-related side effects",
        "Oral and periodontal side effects",
        "Only cardiovascular side effects",
        "Side effects are not relevant to dental care",
      ],
      correct: 1
    },
    {
      id: 55052,
      question: "Which calcium channel blocker effect is relevant to dental hygiene care?",
      options: [
        "Increased tooth sensitivity",
        "Gingival overgrowth",
        "Tooth discoloration",
        "Reduced saliva production only",
      ],
      correct: 1
    },
    {
      id: 55053,
      question: "What can prescribed medications like phenytoin cause that is relevant to periodontal care?",
      options: [
        "Tooth decay",
        "Bad breath only",
        "Gingival overgrowth and periodontal side effects",
        "Increased cavity risk only",
      ],
      correct: 2
    },
    {
      id: 55054,
      question: "Where can medical clearance forms be found?",
      options: [
        "In the textbook only",
        "Online at the ADA website",
        "In the clinic manual",
        "They must be created by each student",
      ],
      correct: 2
    },
    {
      id: 55055,
      question: "What determines whether a client requires medical clearance in private practice?",
      options: [
        "Insurance company requirements only",
        "Client's preference",
        "At the practitioner's discretion and clinic policies",
        "Only government regulations",
      ],
      correct: 2
    },
    {
      id: 55056,
      question: "What should be verified before initiating dental procedures requiring antibiotic prophylaxis?",
      options: [
        "Only that the prescription was filled",
        "Whether the antibiotic was taken, correct dose, and timing",
        "Only the medication name",
        "The pharmacy where it was obtained",
      ],
      correct: 1
    },
    {
      id: 55057,
      question: "Which organization jointly suggested guidelines for prosthetic joint infections?",
      options: [
        "WHO and CDC",
        "American Dental Association and American Association of Orthopedic Surgeons",
        "FDA and AMA",
        "Canadian Dental Association and Health Canada",
      ],
      correct: 1
    },
    {
      id: 55058,
      question: "What is the current recommendation regarding antibiotic coverage for prosthetic joints?",
      options: [
        "Always required for any dental procedure",
        "Never required under any circumstances",
        "No conclusive evidence demonstrates need to routinely administer antibiotics",
        "Required only for extractions",
      ],
      correct: 2
    },
    {
      id: 55059,
      question: "When uncertainty exists about antibiotic prophylaxis for prosthetic joints, what is appropriate?",
      options: [
        "Always prescribe antibiotics to be safe",
        "Consultation between physician, specialist, and oral care team",
        "Proceed without antibiotics",
        "Refer the patient to emergency care",
      ],
      correct: 1
    },
    {
      id: 55060,
      question: "What example medication dosage is given for Amoxicillin premedication in the lecture?",
      options: [
        "1.0 g (2 capsules) taken orally",
        "2.0 g (4 capsules) taken orally",
        "3.0 g (6 capsules) taken orally",
        "500 mg (1 capsule) taken orally",
      ],
      correct: 1
    },
    {
      id: 55061,
      question: "Where should medical clearance forms be kept after being faxed?",
      options: [
        "Discarded after treatment",
        "Stored digitally only",
        "Kept in the client chart",
        "Returned to the physician",
      ],
      correct: 2
    },
    {
      id: 55062,
      question: "What ink colors are acceptable for completing health history forms as legal documents?",
      options: [
        "Red or green",
        "Blue or black",
        "Any color",
        "Pencil is preferred",
      ],
      correct: 1
    },
    {
      id: 55063,
      question: "What should never be used to correct errors on legal health history documents?",
      options: [
        "A single line through the error",
        "Initialing corrections",
        "White-out or writing over mistakes",
        "Dating the correction",
      ],
      correct: 2
    },
    {
      id: 55064,
      question: "How must written comments on health history forms be verified?",
      options: [
        "Witnessed by another staff member",
        "Notarized by a legal authority",
        "Initialed by the client",
        "Approved by the physician",
      ],
      correct: 2
    },
    {
      id: 55065,
      question: "What must the client or guardian do to verify accuracy of the health history?",
      options: [
        "Verbally confirm only",
        "Sign and date the form",
        "Email confirmation",
        "Provide identification",
      ],
      correct: 1
    },
    {
      id: 55066,
      question: "What is the dynamic nature of health history referring to?",
      options: [
        "It never changes once completed",
        "It may change at each appointment",
        "It only changes every 5 years",
        "It is only completed once in a lifetime",
      ],
      correct: 1
    },
    {
      id: 55067,
      question: "Which condition mentioned in the lecture can increase susceptibility to periodontal diseases?",
      options: [
        "Common cold",
        "Seasonal flu",
        "Diabetes and HIV",
        "Broken bones",
      ],
      correct: 2
    },
    {
      id: 55068,
      question: "What is one way that medical problems can manifest in the oral cavity?",
      options: [
        "They never affect oral health",
        "They only cause tooth decay",
        "They can have periodontal and other oral manifestations",
        "They only affect tongue color",
      ],
      correct: 2
    },
    {
      id: 55069,
      question: "What facilitates planning appropriate modifications to the care plan?",
      options: [
        "Ignoring potential barriers",
        "Early recognition of barriers to effective communication",
        "Assuming all clients communicate the same way",
        "Using only written communication",
      ],
      correct: 1
    },
    {
      id: 55071,
      question: "Why should health or personal issues requiring discussion be addressed in treatment areas?",
      options: [
        "For better lighting",
        "For confidentiality",
        "For convenience",
        "To save time",
      ],
      correct: 1
    },
    {
      id: 55072,
      question: "What is the ASA classification for a moribund patient not expected to survive without operation?",
      options: [
        "ASA III",
        "ASA IV",
        "ASA V",
        "ASA VI",
      ],
      correct: 2
    },
    {
      id: 55073,
      question: "Which ASA classification represents a declared brain-dead patient whose organs are being removed?",
      options: [
        "ASA IV",
        "ASA V",
        "ASA VI",
        "ASA VII",
      ],
      correct: 2
    },
    {
      id: 55074,
      question: "What adult example is given for ASA III classification?",
      options: [
        "Healthy, non-smoking patient",
        "Mild diseases without substantive functional limitations",
        "Poorly controlled diabetes or hypertension",
        "Recent MI or CVA",
      ],
      correct: 2
    },
    {
      id: 55075,
      question: "What obstetric example is provided for ASA II classification?",
      options: [
        "Uterine rupture",
        "Normal pregnancy",
        "Preeclampsia with severe features",
        "Peripartum cardiomyopathy",
      ],
      correct: 1
    },
    {
      id: 55076,
      question: "Which pediatric example represents ASA IV classification?",
      options: [
        "Healthy child with normal BMI",
        "Well-controlled asthma",
        "Symptomatic congenital cardiac abnormality",
        "Mild developmental delay",
      ],
      correct: 2
    },
    {
      id: 55077,
      question: "The health history assessment is only completed for new clients and never needs to be updated.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 55078,
      question: "A comprehensive medical history includes both written documentation and verbal interview with the client.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 55082,
      question: "MET stands for Medical Emergency Treatment in cardiovascular assessment.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 55083,
      question: "If a client has an ASA classification of IV or higher, they may not be able to receive elective dental treatment without medical consult.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 55085,
      question: "White-out is acceptable for correcting errors on health history forms.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 55086,
      question: "PHIPA and PIPEDA protect personal health information including name, birth date, and address.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 55087,
      question: "Transient bacteremia refers to a permanent bacterial infection requiring long-term antibiotic therapy.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 55088,
      question: "Prophylactic antibiotic premedication should be administered 1/2 to 1 hour before dental procedures.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 55089,
      question: "Infective endocarditis is a minor condition that resolves without treatment.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 55090,
      question: "Approximately 1 in 7 adults in the United States are functionally illiterate.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 55091,
      question: "Open-ended questions are recommended in client-centered interviewing to encourage discussion.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 55092,
      question: "The health history interview can be conducted in the reception area within hearing range of other patients.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 55094,
      question: "Drug write-ups must be completed for all medications including basic multivitamins like Centrum.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 55096,
      question: "Written and verbal informed consent must be obtained before consulting with a client's physician.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 55097,
      question: "The health history form is a legal document that must be completed in permanent blue or black ink.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 55098,
      question: "Medical clearance is never required for clients with active chemotherapy or radiation therapy.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 55099,
      question: "Back channeling is a communication strategy using neutral, encouraging responses to show the clinician is listening.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 55101,
      question: "The ASA Physical Status Classification System was developed by the American Dental Association.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 55102,
      question: "Medical issues such as diabetes and HIV can increase susceptibility to periodontal diseases.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 55103,
      question: "The client should be positioned lying flat during the health history interview for comfort.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    }
  ],
  "1-2. Vitals": [
    {
      id: 56001,
      question: "What are the four vital signs measured in clinical practice?",
      options: [
        "Temperature, pulse rate, respiration rate, and blood pressure",
        "Temperature, weight, height, and blood pressure",
        "Pulse rate, oxygen saturation, blood glucose, and respiration rate",
        "Blood pressure, cholesterol, heart rate, and body mass index",
      ],
      correct: 0
    },
    {
      id: 56002,
      question: "Which techniques are used to determine vital signs?",
      options: [
        "Observation, measurement, and calculation",
        "Inspection, palpation, and auscultation",
        "Visual assessment, manual testing, and electronic monitoring",
        "Physical examination, laboratory testing, and imaging",
      ],
      correct: 1
    },
    {
      id: 56003,
      question: "What is the normal body temperature range for most people?",
      options: [
        "95.0º to 99.0º F",
        "97.0º to 99.5º F",
        "96.8º to 100.4º F",
        "98.0º to 101.0º F",
      ],
      correct: 2
    },
    {
      id: 56004,
      question: "Which of the following factors can affect body temperature?",
      options: [
        "Exercise and time of day variations",
        "Blood type and eye color",
        "Hair color and shoe size",
        "Educational level and occupation",
      ],
      correct: 0
    },
    {
      id: 56005,
      question: "How many sites are commonly used for body temperature measurement?",
      options: [
        "Three sites",
        "Four sites",
        "Five sites",
        "Six sites",
      ],
      correct: 2
    },
    {
      id: 56006,
      question: "Which of the following is NOT a common site for temperature measurement?",
      options: [
        "Oral cavity",
        "Ear canal",
        "Forearm",
        "Forehead",
      ],
      correct: 2
    },
    {
      id: 56007,
      question: "What type of thermometer uses mercury enclosed in glass?",
      options: [
        "Digital thermometer",
        "Tympanic thermometer",
        "Mercury-in-glass thermometer",
        "Infrared thermometer",
      ],
      correct: 2
    },
    {
      id: 56008,
      question: "Why is body temperature not often evaluated on a regular basis in dental environments?",
      options: [
        "It is too expensive to measure",
        "Thermometers are not accurate enough",
        "It is not routinely needed for dental procedures",
        "Patients refuse temperature measurements",
      ],
      correct: 2
    },
    {
      id: 56009,
      question: "What does an elevated body temperature indicate?",
      options: [
        "The patient is dehydrated",
        "The body is fighting an infection",
        "The patient needs immediate surgery",
        "The blood pressure is elevated",
      ],
      correct: 1
    },
    {
      id: 56010,
      question: "What should be done if a fever is suspected in a patient scheduled for elective dental treatment?",
      options: [
        "Proceed with treatment immediately",
        "Give the patient antibiotics",
        "Reschedule the patient",
        "Reduce the treatment time",
      ],
      correct: 2
    },
    {
      id: 56011,
      question: "What does the pulse indicate about the body?",
      options: [
        "The efficiency of the digestive system",
        "The integrity of the cardiovascular system",
        "The health of the respiratory system",
        "The function of the nervous system",
      ],
      correct: 1
    },
    {
      id: 56012,
      question: "What is tachycardia?",
      options: [
        "A heart rate below 60 beats per minute",
        "An irregular heartbeat pattern",
        "A heart rate above 100 beats per minute",
        "A condition of low blood pressure",
      ],
      correct: 2
    },
    {
      id: 56013,
      question: "What is the normal response that can cause tachycardia?",
      options: [
        "Sleep or rest",
        "Stress or physical exercise",
        "Eating or drinking",
        "Reading or studying",
      ],
      correct: 1
    },
    {
      id: 56014,
      question: "What is bradycardia?",
      options: [
        "A heart rate below 60 beats per minute",
        "A heart rate above 100 beats per minute",
        "An irregular breathing pattern",
        "A condition of elevated blood pressure",
      ],
      correct: 0
    },
    {
      id: 56015,
      question: "Why might athletes have bradycardia at rest?",
      options: [
        "Due to poor cardiovascular health",
        "As a result of physical conditioning",
        "Because of underlying heart disease",
        "From excessive caffeine consumption",
      ],
      correct: 1
    },
    {
      id: 56016,
      question: "What is the most common site for measuring pulse?",
      options: [
        "Carotid artery in the neck",
        "Femoral artery in the leg",
        "Radial artery at the wrist",
        "Brachial artery in the arm",
      ],
      correct: 2
    },
    {
      id: 56017,
      question: "Where is the radial pulse located?",
      options: [
        "On the neck below the jaw",
        "On the thumb side of the inner wrist",
        "On the top of the foot",
        "On the inside of the elbow",
      ],
      correct: 1
    },
    {
      id: 56018,
      question: "Which fingers should the clinician use to feel for the pulse?",
      options: [
        "Thumb only",
        "Thumb and index finger",
        "Finger tips of first two fingers",
        "All four fingers together",
      ],
      correct: 2
    },
    {
      id: 56019,
      question: "What is an alternative site for pulse measurement?",
      options: [
        "Radial pulse",
        "Carotid pulse",
        "Temporal pulse",
        "Pedal pulse",
      ],
      correct: 1
    },
    {
      id: 56020,
      question: "What should be done if a patient has a pulse rate below 60 BPM or above 100 BPM?",
      options: [
        "Immediately call emergency services",
        "Evaluate patient for causative factors and refer if needed",
        "Ignore the finding as it is normal",
        "Prescribe medication to regulate heart rate",
      ],
      correct: 1
    },
    {
      id: 56021,
      question: "When should medical consultation with the patient's physician be conducted regarding pulse?",
      options: [
        "After every dental visit",
        "Only if the patient requests it",
        "If no cause for abnormal pulse can be determined",
        "When the patient has a history of dental work",
      ],
      correct: 2
    },
    {
      id: 56022,
      question: "What are occasional premature ventricular contractions (PVCs)?",
      options: [
        "Rare and always indicate serious heart disease",
        "Common and can be caused by various factors",
        "Only occur in elderly patients",
        "Are a type of respiratory disorder",
      ],
      correct: 1
    },
    {
      id: 56023,
      question: "Which of the following can cause premature ventricular contractions?",
      options: [
        "Proper hydration and rest",
        "Smoking, fatigue, and caffeine",
        "Regular exercise and healthy diet",
        "Low sodium intake and meditation",
      ],
      correct: 1
    },
    {
      id: 56024,
      question: "What may pulsus alternans indicate?",
      options: [
        "Normal cardiovascular function",
        "Respiratory distress",
        "Ventricular failure",
        "Kidney disease",
      ],
      correct: 2
    },
    {
      id: 56025,
      question: "How is respiration rate assessed?",
      options: [
        "By listening to breath sounds with a stethoscope",
        "By measuring oxygen saturation levels",
        "By counting the rise and fall of the patient's chest",
        "By asking the patient to report their breathing",
      ],
      correct: 2
    },
    {
      id: 56026,
      question: "What is the normal adult respiration rate range?",
      options: [
        "8-15 RPM",
        "12-20 RPM",
        "15-25 RPM",
        "20-30 RPM",
      ],
      correct: 1
    },
    {
      id: 56027,
      question: "What is the normal respiration rate range for children?",
      options: [
        "10-18 RPM",
        "15-22 RPM",
        "20-30 RPM",
        "25-35 RPM",
      ],
      correct: 2
    },
    {
      id: 56028,
      question: "What does advancing age produce in relation to respiration rate?",
      options: [
        "No changes in respiration rate",
        "Always increases respiration rate",
        "Variations in the respiration rate",
        "Complete cessation of breathing changes",
      ],
      correct: 2
    },
    {
      id: 56029,
      question: "What is tachypnea?",
      options: [
        "Slow breathing below 10 RPM",
        "Rapid breathing above 20 RPM",
        "Irregular breathing pattern",
        "Shallow breathing with pauses",
      ],
      correct: 1
    },
    {
      id: 56030,
      question: "What is bradypnea?",
      options: [
        "Rapid breathing above 25 RPM",
        "Normal breathing between 12-20 RPM",
        "Slow breathing that can occur with diabetic coma",
        "Irregular breathing with wheezing",
      ],
      correct: 2
    },
    {
      id: 56031,
      question: "What should the dental hygienist do if an abnormal respiratory rate is detected?",
      options: [
        "Prescribe respiratory medication",
        "Immediately start CPR",
        "Refer patient to physician of record",
        "Continue with dental treatment as planned",
      ],
      correct: 2
    },
    {
      id: 56032,
      question: "What is blood pressure?",
      options: [
        "The amount of oxygen in the blood",
        "The thickness of the blood vessels",
        "The force exerted by blood against arterial walls when the heart contracts",
        "The speed at which blood travels through veins",
      ],
      correct: 2
    },
    {
      id: 56033,
      question: "What does chronic hypertension cause to arterial walls?",
      options: [
        "Increased flexibility and elasticity",
        "Thickening and loss of elasticity",
        "Complete dissolution of the walls",
        "Improved blood flow and circulation",
      ],
      correct: 1
    },
    {
      id: 56034,
      question: "Which of the following is a consequence of chronic hypertension?",
      options: [
        "Improved cardiovascular health",
        "Enhanced kidney function",
        "Heart attack and stroke",
        "Increased energy levels",
      ],
      correct: 2
    },
    {
      id: 56035,
      question: "When does hypotension cause adverse effects?",
      options: [
        "In all cases of low blood pressure",
        "Only in elderly patients",
        "When patient is in shock or has condition that lowers BP",
        "During normal daily activities",
      ],
      correct: 2
    },
    {
      id: 56036,
      question: "What does systolic blood pressure measure?",
      options: [
        "Minimum pressure during cardiac relaxation",
        "Average pressure throughout the cardiac cycle",
        "Maximum pressure during cardiac ventricular contraction",
        "Pressure in the veins during blood return",
      ],
      correct: 2
    },
    {
      id: 56037,
      question: "When is the systolic blood pressure number recorded on the sphygmomanometer?",
      options: [
        "When the last heart sound is heard",
        "When the first heart sound is heard",
        "When no heart sounds are heard",
        "When heart sounds are loudest",
      ],
      correct: 1
    },
    {
      id: 56038,
      question: "What does diastolic blood pressure measure?",
      options: [
        "Maximum pressure during cardiac contraction",
        "Minimum pressure during cardiac ventricular relaxation",
        "Average pressure throughout the day",
        "Pressure in the arteries during exercise",
      ],
      correct: 1
    },
    {
      id: 56039,
      question: "When is the diastolic blood pressure number recorded?",
      options: [
        "When the first heart sound is heard",
        "When heart sounds are muffled",
        "When the last heart sound is heard",
        "When the pulse is strongest",
      ],
      correct: 2
    },
    {
      id: 56040,
      question: "Which of the following factors can affect blood pressure?",
      options: [
        "Age, race, and certain diseases",
        "Hair color and height",
        "Eye color and handedness",
        "Blood type and fingerprints",
      ],
      correct: 0
    },
    {
      id: 56041,
      question: "What lifestyle factors can affect blood pressure?",
      options: [
        "Reading habits and music preferences",
        "Tobacco, caffeine, and alcohol use",
        "Sleep position and pillow type",
        "Shoe size and clothing style",
      ],
      correct: 1
    },
    {
      id: 56042,
      question: "What is hypertension a major cause of?",
      options: [
        "Improved circulation",
        "Enhanced vision",
        "Stroke",
        "Better kidney function",
      ],
      correct: 2
    },
    {
      id: 56043,
      question: "Are patients with elevated blood pressure usually candidates for drug therapy?",
      options: [
        "Yes, they always receive immediate medication",
        "No, they are usually not candidates for drug therapy",
        "Only if they are under 30 years old",
        "Only during dental procedures",
      ],
      correct: 1
    },
    {
      id: 56044,
      question: "What should be obtained if a patient's blood pressure is unknown?",
      options: [
        "A complete blood count",
        "A chest X-ray",
        "A baseline blood pressure",
        "An electrocardiogram",
      ],
      correct: 2
    },
    {
      id: 56045,
      question: "What caution should be taken with uncontrolled hypertensive patients?",
      options: [
        "They should avoid all dental visits",
        "They should receive extra anesthesia",
        "Caution before any surgical procedure",
        "They should be treated without any concerns",
      ],
      correct: 2
    },
    {
      id: 56046,
      question: "What is a sphygmomanometer?",
      options: [
        "A device to measure body temperature",
        "A blood pressure cuff with pressure-measuring device",
        "An instrument to test hearing",
        "A tool to measure blood glucose",
      ],
      correct: 1
    },
    {
      id: 56047,
      question: "What does the sphygmomanometer consist of?",
      options: [
        "Only an inflatable cuff",
        "A manometer and an inflatable cuff",
        "A stethoscope and thermometer",
        "A digital display and timer",
      ],
      correct: 1
    },
    {
      id: 56048,
      question: "What is a stethoscope used for?",
      options: [
        "To measure blood pressure directly",
        "To take body temperature",
        "To amplify sound",
        "To count respirations automatically",
      ],
      correct: 2
    },
    {
      id: 56049,
      question: "What does the stethoscope consist of?",
      options: [
        "Only earpieces",
        "Only tubing",
        "Two earpieces, tubing, and a chestpiece",
        "A digital screen and battery",
      ],
      correct: 2
    },
    {
      id: 56050,
      question: "What is an electronic over-the-counter-type manometer used for?",
      options: [
        "For professional medical use only",
        "For home use to determine blood pressure automatically",
        "For measuring body temperature",
        "For checking pulse rate manually",
      ],
      correct: 1
    },
    {
      id: 56051,
      question: "Does the electronic manometer require a stethoscope?",
      options: [
        "Yes, it always requires a stethoscope",
        "Only for systolic readings",
        "No, it determines blood pressure automatically without one",
        "Only for diastolic readings",
      ],
      correct: 2
    },
    {
      id: 56052,
      question: "Which factor does NOT typically affect body temperature?",
      options: [
        "Smoking",
        "Stress",
        "Shoe size",
        "Infection",
      ],
      correct: 2
    },
    {
      id: 56053,
      question: "What effect does tachypnea have on body temperature?",
      options: [
        "It lowers body temperature",
        "It has no effect on temperature",
        "It can affect body temperature",
        "It only affects blood pressure",
      ],
      correct: 2
    },
    {
      id: 56054,
      question: "What can hot and cold liquids affect?",
      options: [
        "Blood pressure only",
        "Pulse rate only",
        "Body temperature",
        "Respiration rate only",
      ],
      correct: 2
    },
    {
      id: 56055,
      question: "Which type of thermometer is designed specifically for infants?",
      options: [
        "Mercury-in-glass thermometer",
        "Axillary electronic thermometer",
        "Pacifier thermometer",
        "Forehead strip thermometer",
      ],
      correct: 2
    },
    {
      id: 56056,
      question: "What is the location of the axilla for temperature measurement?",
      options: [
        "The ear canal",
        "The forehead",
        "The armpit",
        "The mouth",
      ],
      correct: 2
    },
    {
      id: 56057,
      question: "Which thermometer measures temperature at the tympanic membrane?",
      options: [
        "Oral thermometer",
        "Rectal thermometer",
        "Tympanic membrane thermometer",
        "Axillary thermometer",
      ],
      correct: 2
    },
    {
      id: 56058,
      question: "What type of thermometer is used only once and then discarded?",
      options: [
        "Mercury-in-glass thermometer",
        "Electronic digital thermometer",
        "Disposable single-use thermometer",
        "Tympanic membrane thermometer",
      ],
      correct: 2
    },
    {
      id: 56059,
      question: "Why should a thermometer be available in a dental environment?",
      options: [
        "To measure room temperature",
        "To sterilize instruments",
        "To check for elevated body temperature when suspected",
        "To calibrate other equipment",
      ],
      correct: 2
    },
    {
      id: 56060,
      question: "What time of day variations can affect body temperature?",
      options: [
        "Temperature remains constant throughout the day",
        "Temperature varies at different times of day",
        "Temperature only changes during sleep",
        "Time of day has no effect on temperature",
      ],
      correct: 1
    },
    {
      id: 56061,
      question: "How do hormonal imbalances affect body temperature?",
      options: [
        "They have no effect on temperature",
        "They only lower temperature",
        "They may affect body temperature",
        "They only affect blood pressure",
      ],
      correct: 2
    },
    {
      id: 56062,
      question: "What physiological event related to the female reproductive system can affect temperature?",
      options: [
        "Menstruation only",
        "Ovulation and menopause",
        "Pregnancy only",
        "Lactation only",
      ],
      correct: 1
    },
    {
      id: 56063,
      question: "How does the environment affect body temperature?",
      options: [
        "It has no effect on body temperature",
        "It can affect body temperature",
        "It only affects indoor temperature",
        "It only matters in extreme climates",
      ],
      correct: 1
    },
    {
      id: 56064,
      question: "How does age affect body temperature?",
      options: [
        "Age has no effect on temperature",
        "Temperature increases with age",
        "Age can affect body temperature",
        "Temperature only changes in infancy",
      ],
      correct: 2
    },
    {
      id: 56065,
      question: "Where is the carotid pulse located?",
      options: [
        "On the wrist",
        "On the side of the neck",
        "On the foot",
        "On the chest",
      ],
      correct: 1
    },
    {
      id: 56066,
      question: "What should NOT be used to feel for a pulse?",
      options: [
        "Index finger",
        "Middle finger",
        "Thumb",
        "Ring finger",
      ],
      correct: 2
    },
    {
      id: 56067,
      question: "What does pulse rate indicate about cardiac function?",
      options: [
        "The size of the heart",
        "The integrity of the cardiovascular system",
        "The color of the blood",
        "The thickness of arterial walls",
      ],
      correct: 1
    },
    {
      id: 56068,
      question: "At what pulse rate should a patient be evaluated for causative factors?",
      options: [
        "Between 60-100 BPM",
        "Below 60 BPM or above 100 BPM",
        "Only below 40 BPM",
        "Only above 120 BPM",
      ],
      correct: 1
    },
    {
      id: 56069,
      question: "The four vital signs are temperature, pulse rate, respiration rate, and blood pressure.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56070,
      question: "The normal body temperature range is the same for all people.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 56071,
      question: "Five sites are commonly used for body temperature measurement.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56072,
      question: "Body temperature is routinely evaluated on a regular basis in dental environments.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 56073,
      question: "An elevated body temperature indicates the body is fighting an infection.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56074,
      question: "Patients with suspected fever should be rescheduled for elective dental treatment.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56075,
      question: "Tachycardia is defined as a heart rate above 100 beats per minute.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56076,
      question: "Bradycardia is always a sign of poor cardiovascular health.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 56077,
      question: "Athletes may have bradycardia at rest as a result of physical conditioning.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56078,
      question: "The most common site for pulse measurement is the carotid artery.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 56079,
      question: "The radial pulse is located on the thumb side of the inner wrist.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56080,
      question: "The clinician's thumb should be used to feel for the pulse.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 56081,
      question: "Occasional premature ventricular contractions (PVCs) are always a sign of serious heart disease.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 56082,
      question: "Smoking and caffeine can cause premature ventricular contractions.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56083,
      question: "The normal adult respiration rate range is 12-20 RPM.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56084,
      question: "Children have the same respiration rate range as adults.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 56085,
      question: "Tachypnea is defined as rapid breathing above 20 RPM.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56086,
      question: "Bradypnea can occur with diabetic coma.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56087,
      question: "Blood pressure measures the force exerted by blood against arterial walls when the heart contracts.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56088,
      question: "Chronic hypertension causes increased flexibility in arterial walls.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 56089,
      question: "Hypotension always causes adverse effects regardless of the patient's condition.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 56090,
      question: "Systolic blood pressure measures maximum pressure during cardiac ventricular contraction.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56091,
      question: "The systolic number is recorded when the last heart sound is heard.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 56092,
      question: "Diastolic blood pressure measures minimum pressure during cardiac ventricular relaxation.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56093,
      question: "Age, race, and certain diseases can affect blood pressure.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56094,
      question: "Tobacco, caffeine, and alcohol use can affect blood pressure.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56095,
      question: "Hypertension is a major cause of stroke.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56096,
      question: "A sphygmomanometer is another name for a thermometer.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 56097,
      question: "A stethoscope is used to amplify sound during blood pressure measurement.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 56098,
      question: "Electronic over-the-counter manometers require the use of a stethoscope.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    }
  ],
  "2. Hard Tissue Assessment": [
    {
      id: 57001,
      question: "What is the primary goal of hard-tissue assessment in dental hygiene practice?",
      options: [
        "To determine the patient's oral hygiene habits and dietary preferences",
        "To recognize and document signs of dental caries, acquired tooth damage, and developmental anomalies",
        "To evaluate the patient's compliance with previous treatment recommendations",
        "To assess the patient's ability to maintain restorations independently",
      ],
      correct: 1
    },
    {
      id: 57002,
      question: "Dental charting is best defined as which of the following?",
      options: [
        "A numeric system for identifying teeth in the oral cavity",
        "A color-coded map showing areas of inflammation in periodontal tissues",
        "A graphic representation of the condition of the patient's teeth on a specific date",
        "A timeline showing the patient's history of dental procedures",
      ],
      correct: 2
    },
    {
      id: 57003,
      question: "Which of the following is NOT listed as an advantage of electronic charting systems?",
      options: [
        "Space efficiency and easy retrieval of patient records",
        "Integration of digital clinical and radiographic images",
        "Immediate implementation without significant learning curve or cost",
        "Convenient storage and accessibility of patient information",
      ],
      correct: 2
    },
    {
      id: 57004,
      question: "How many teeth are present in a complete primary dentition?",
      options: [
        "16 teeth with 4 in each quadrant",
        "20 teeth with 5 in each quadrant",
        "28 teeth with 7 in each quadrant",
        "32 teeth with 8 in each quadrant",
      ],
      correct: 1
    },
    {
      id: 57005,
      question: "A complete permanent dentition consists of how many teeth?",
      options: [
        "28 teeth with 7 in each quadrant",
        "20 teeth with 5 in each quadrant",
        "32 teeth with 8 in each quadrant",
        "24 teeth with 6 in each quadrant",
      ],
      correct: 2
    },
    {
      id: 57006,
      question: "When dividing a tooth root horizontally, which thirds are identified from top to bottom?",
      options: [
        "Occlusal third, middle third, and apical third",
        "Cervical third, middle third, and apical third",
        "Gingival third, central third, and root third",
        "Coronal third, middle third, and basal third",
      ],
      correct: 1
    },
    {
      id: 57007,
      question: "Which classification system divides the oral cavity into six sections for periodontal assessment?",
      options: [
        "Quadrant classification with four equal sections",
        "Sextant classification with anterior and posterior regions",
        "Octant classification with eight equal divisions",
        "Bilateral classification with left and right sections",
      ],
      correct: 1
    },
    {
      id: 57008,
      question: "What type of questioning should be used when beginning patient symptom assessment?",
      options: [
        "Closed-ended questions requiring yes or no answers",
        "Leading questions that suggest expected responses",
        "Open-ended questions encouraging detailed patient descriptions",
        "Multiple-choice questions with predetermined answer options",
      ],
      correct: 2
    },
    {
      id: 57009,
      question: "Which of the following is NOT a method used for tooth assessment and caries detection?",
      options: [
        "Direct visual examination with proper lighting",
        "Transillumination to detect proximal lesions",
        "Explorer assessment with sharp instruments",
        "Evaluation of patient-described symptoms",
      ],
      correct: 2
    },
    {
      id: 57010,
      question: "Dental caries is best described as which type of disease process?",
      options: [
        "A genetic disorder affecting enamel formation during tooth development",
        "An autoimmune condition causing demineralization of tooth structure",
        "A multifactorial infectious and transmissible disease involving bacterial action",
        "A nutritional deficiency resulting in weakened tooth structure",
      ],
      correct: 2
    },
    {
      id: 57011,
      question: "Which of the following sites is MOST susceptible to biofilm retention and caries development?",
      options: [
        "Smooth facial surfaces of anterior teeth",
        "Pits and fissures on occlusal surfaces",
        "Mid-buccal surfaces of posterior teeth",
        "Incisal edges of maxillary incisors",
      ],
      correct: 1
    },
    {
      id: 57012,
      question: "Early childhood caries is observed in children under what age?",
      options: [
        "Under 3 years of age",
        "Under 5 years of age",
        "Under 7 years of age",
        "Under 10 years of age",
      ],
      correct: 1
    },
    {
      id: 57013,
      question: "Which type of caries represents a slow progressive decay process requiring intervention?",
      options: [
        "Rampant caries with rapid destruction",
        "Arrested caries with remineralization",
        "Chronic caries with gradual progression",
        "Recurrent caries under restorations",
      ],
      correct: 2
    },
    {
      id: 57014,
      question: "Arrested caries is best characterized by which of the following?",
      options: [
        "New caries occurring under existing restorations",
        "Recalcified lesions resulting from remineralization when decay halts",
        "Rapid destruction requiring urgent intervention",
        "Initial white spot lesions requiring fluoride treatment",
      ],
      correct: 1
    },
    {
      id: 57015,
      question: "In Black's Classification System, where are Class I caries located?",
      options: [
        "On proximal surfaces of premolars and molars",
        "In pits and fissures of occlusal surfaces",
        "On proximal surfaces of incisors and canines",
        "In the cervical third of facial surfaces",
      ],
      correct: 1
    },
    {
      id: 57016,
      question: "Class II caries in Black's Classification System affects which tooth surfaces?",
      options: [
        "Occlusal surfaces of premolars and molars only",
        "Proximal surfaces of incisors and canines exclusively",
        "Proximal surfaces of premolars and molars",
        "Facial and lingual surfaces of all teeth",
      ],
      correct: 2
    },
    {
      id: 57017,
      question: "Root caries specifically involves which structures?",
      options: [
        "Only the enamel surface in the cervical region",
        "The tooth root, cementum, or cervical area of the tooth",
        "The dentin below existing occlusal restorations",
        "The pulp chamber following deep decay",
      ],
      correct: 1
    },
    {
      id: 57018,
      question: "What dental specialty manages prevention, diagnosis, and treatment of dental pulp and peri-radicular tissues?",
      options: [
        "Periodontics focusing on gingival and bone health",
        "Prosthodontics specializing in tooth replacement",
        "Endodontics treating pulp and root structures",
        "Orthodontics correcting tooth alignment",
      ],
      correct: 2
    },
    {
      id: 57019,
      question: "Which are the two most common causes of pulpal nerve damage?",
      options: [
        "Excessive force from occlusion and tooth grinding",
        "Bacterial infection and trauma to the tooth",
        "Chemical irritation and thermal sensitivity",
        "Genetic predisposition and aging processes",
      ],
      correct: 1
    },
    {
      id: 57020,
      question: "A tooth anomaly is best defined as which of the following?",
      options: [
        "Any acquired damage to tooth structure from external forces",
        "A developmental disorder from congenital, hereditary, or environmental factors",
        "Discoloration or staining of tooth surfaces",
        "Any restoration or prosthetic replacement",
      ],
      correct: 1
    },
    {
      id: 57021,
      question: "Dentinogenesis imperfecta is an example of which type of condition?",
      options: [
        "An acquired tooth damage condition from grinding",
        "A periodontal disease affecting supporting structures",
        "A tooth anomaly affecting dentin formation",
        "A dietary deficiency affecting enamel development",
      ],
      correct: 2
    },
    {
      id: 57022,
      question: "When should dentition charting be initially conducted and subsequently updated?",
      options: [
        "Only at the initial assessment appointment",
        "At the initial appointment and updated at each subsequent visit",
        "Annually regardless of patient visits",
        "Only when new restorations are placed",
      ],
      correct: 1
    },
    {
      id: 57023,
      question: "What is the recommended sequence for thorough dental charting?",
      options: [
        "A random approach focusing on obvious problems first",
        "Starting with posterior teeth and moving anteriorly",
        "Any consistent sequence ensuring all areas are checked systematically",
        "Beginning with the maxillary arch exclusively",
      ],
      correct: 2
    },
    {
      id: 57024,
      question: "In complexity classification, what defines a \"compound\" caries or restoration?",
      options: [
        "Involving a single tooth surface only",
        "Involving two tooth surfaces",
        "Involving three or more tooth surfaces",
        "Involving the entire crown of the tooth",
      ],
      correct: 1
    },
    {
      id: 57025,
      question: "Which method is NO LONGER recommended for caries detection due to potential enamel damage?",
      options: [
        "Visual assessment with proper drying",
        "Radiographic evaluation with bitewings",
        "Explorer assessment with sharp instruments",
        "Transillumination with fiber-optic light",
      ],
      correct: 2
    },
    {
      id: 57026,
      question: "Hyperdontia refers to which dental condition?",
      options: [
        "Fewer teeth than normal in the dentition",
        "More teeth than normal in the dentition",
        "Abnormally large teeth compared to normal size",
        "Fusion of two adjacent teeth",
      ],
      correct: 1
    },
    {
      id: 57027,
      question: "Mesiodens specifically refers to which type of supernumerary tooth?",
      options: [
        "An extra molar distal to third molars",
        "An extra tooth in the midline between maxillary central incisors",
        "An extra premolar in the mandibular arch",
        "An extra canine in any quadrant",
      ],
      correct: 1
    },
    {
      id: 57028,
      question: "Hypodontia is characterized by which condition?",
      options: [
        "Presence of extra teeth beyond normal number",
        "Abnormally small teeth throughout dentition",
        "Congenitally missing teeth or fewer than normal",
        "Premature loss of primary teeth",
      ],
      correct: 2
    },
    {
      id: 57029,
      question: "Macrodontia refers to which tooth characteristic?",
      options: [
        "Teeth that are abnormally large compared to normal size",
        "Teeth with developmental grooves and pits",
        "Teeth that are abnormally small",
        "Teeth with extra cusps or tubercles",
      ],
      correct: 0
    },
    {
      id: 57030,
      question: "What dental anomaly occurs when two tooth germs unite during development?",
      options: [
        "Gemination producing a bifid crown structure",
        "Fusion joining two separate teeth",
        "Dilaceration causing root angulation",
        "Concresence fusing roots by cementum",
      ],
      correct: 1
    },
    {
      id: 57031,
      question: "Dens in dente is characterized by which feature?",
      options: [
        "An enlarged pulp chamber with short roots",
        "An invagination of enamel into the tooth",
        "Multiple small cusps on occlusal surfaces",
        "External resorption of root structure",
      ],
      correct: 1
    },
    {
      id: 57032,
      question: "Dilaceration describes which tooth characteristic?",
      options: [
        "Abnormal curvature or angulation of the tooth root",
        "Extra cusps on the occlusal surface",
        "Enamel defects from fluoride exposure",
        "Enlarged pulp chambers with normal roots",
      ],
      correct: 0
    },
    {
      id: 57033,
      question: "Enamel hypoplasia results from which developmental issue?",
      options: [
        "Excessive fluoride during tooth development",
        "Incomplete or defective enamel formation",
        "Bacterial infection after eruption",
        "Mechanical trauma to erupted teeth",
      ],
      correct: 1
    },
    {
      id: 57034,
      question: "Dental fluorosis is caused by which factor during tooth development?",
      options: [
        "Vitamin D deficiency during childhood",
        "Bacterial infection of developing enamel",
        "Excessive fluoride ingestion during enamel formation",
        "Genetic inheritance from affected parents",
      ],
      correct: 2
    },
    {
      id: 57035,
      question: "Hutchinson incisors are associated with which condition?",
      options: [
        "Excessive fluoride exposure during development",
        "Nutritional deficiencies in early childhood",
        "Congenital syphilis affecting tooth formation",
        "Amelogenesis imperfecta inheritance",
      ],
      correct: 2
    },
    {
      id: 57036,
      question: "Mulberry molars display which characteristic appearance?",
      options: [
        "Smooth surfaces with white spot lesions",
        "Multiple small cusps resembling a mulberry",
        "Enlarged cusps with deep fissures",
        "Flattened occlusal surfaces without cusps",
      ],
      correct: 1
    },
    {
      id: 57037,
      question: "Peg lateral incisors are characterized by which feature?",
      options: [
        "Normal crown form with shortened roots",
        "Cone-shaped or peg-shaped lateral incisors",
        "Laterals larger than central incisors",
        "Missing lateral incisors bilaterally",
      ],
      correct: 1
    },
    {
      id: 57038,
      question: "Amelogenesis imperfecta is best described as which condition?",
      options: [
        "A hereditary condition affecting enamel formation and quality",
        "An acquired condition from childhood illness",
        "A nutritional deficiency affecting dentin",
        "A bacterial infection of developing teeth",
      ],
      correct: 0
    },
    {
      id: 57039,
      question: "Dens evaginatus is also referred to as which term?",
      options: [
        "Talon cusp on lingual surfaces",
        "Tuberculated cusp on occlusal surfaces",
        "Mulberry molar configuration",
        "Hutchinson incisor morphology",
      ],
      correct: 1
    },
    {
      id: 57040,
      question: "A talon cusp typically appears on which tooth surface?",
      options: [
        "On the occlusal surface of molars",
        "On the lingual surface of anterior teeth",
        "On the buccal surface of premolars",
        "On the incisal edge of incisors",
      ],
      correct: 1
    },
    {
      id: 57041,
      question: "Dentinogenesis imperfecta is characterized by which feature?",
      options: [
        "Defective enamel with normal dentin formation",
        "Discolored and weakened dentin structure",
        "Absent tooth roots with normal crowns",
        "Multiple supernumerary teeth formation",
      ],
      correct: 1
    },
    {
      id: 57042,
      question: "Dentin dysplasia affects which tooth structure primarily?",
      options: [
        "Enamel thickness and translucency exclusively",
        "Root development and dentin formation",
        "Cementum attachment to bone",
        "Pulp chamber size only",
      ],
      correct: 1
    },
    {
      id: 57043,
      question: "Taurodontism is characterized by which anatomical feature?",
      options: [
        "Multiple small roots with normal pulp chambers",
        "An enlarged pulp chamber with smaller-appearing roots",
        "Absent pulp chambers with solid dentin",
        "Extra cusps with deep developmental grooves",
      ],
      correct: 1
    },
    {
      id: 57044,
      question: "Occlusion is best defined as which relationship?",
      options: [
        "The space between teeth when jaws are slightly open",
        "The contact relationship between maxillary and mandibular teeth when fully closed",
        "The vertical dimension between upper and lower jaws",
        "The horizontal movement pattern during chewing",
      ],
      correct: 1
    },
    {
      id: 57045,
      question: "Centric occlusion specifically refers to which position?",
      options: [
        "The forward-most position of the mandible",
        "The relation of opposing occlusal surfaces when teeth contact",
        "The resting position with minimal muscle tension",
        "The lateral position during grinding movements",
      ],
      correct: 1
    },
    {
      id: 57046,
      question: "Centric relation describes which mandibular position?",
      options: [
        "When teeth are in maximum intercuspation",
        "When the condyles are in their most posterosuperior unstrained position",
        "When the mandible is protruded forward",
        "When the mandible is shifted laterally",
      ],
      correct: 1
    },
    {
      id: 57047,
      question: "Overjet measures which spatial relationship?",
      options: [
        "The vertical overlap of maxillary over mandibular incisors",
        "The horizontal distance between maxillary and mandibular incisors",
        "The space between adjacent teeth",
        "The distance from teeth to the lips",
      ],
      correct: 1
    },
    {
      id: 57048,
      question: "Overbite measures which spatial relationship?",
      options: [
        "The horizontal projection of upper teeth beyond lower teeth",
        "The vertical overlap of maxillary incisors over mandibular incisors",
        "The spacing between maxillary and mandibular molars",
        "The distance between canines bilaterally",
      ],
      correct: 1
    },
    {
      id: 57049,
      question: "In Class I malocclusion, which statement is accurate?",
      options: [
        "The molar relationship is normal with individual tooth malpositions",
        "The maxillary arch is significantly advanced relative to mandible",
        "The mandibular arch is positioned anterior to maxillary arch",
        "All teeth are properly aligned with no crowding",
      ],
      correct: 0
    },
    {
      id: 57050,
      question: "Class II malocclusion typically displays which facial profile?",
      options: [
        "A prognathic profile with protruding mandible",
        "A retrognathic profile with receding mandible",
        "A balanced profile with proper jaw relationship",
        "An asymmetric profile with lateral deviation",
      ],
      correct: 1
    },
    {
      id: 57051,
      question: "In Class II Division 1 malocclusion, the maxillary incisors exhibit which characteristic?",
      options: [
        "They are lingually inclined or retruded",
        "They protrude facially from the mandibular incisors",
        "They are in proper alignment with mandibular incisors",
        "They are congenitally missing bilaterally",
      ],
      correct: 1
    },
    {
      id: 57052,
      question: "Class II Division 2 malocclusion is characterized by which incisor position?",
      options: [
        "Maxillary central incisors protruding facially",
        "One or more maxillary central incisors lingually inclined",
        "Mandibular incisors protruding facially",
        "All incisors in edge-to-edge relationship",
      ],
      correct: 1
    },
    {
      id: 57053,
      question: "In Class III malocclusion, where is the mandibular first molar positioned relative to the maxillary first molar?",
      options: [
        "Distal to the maxillary first molar",
        "Directly aligned with the maxillary first molar",
        "Mesial to the maxillary first molar",
        "Rotated away from the maxillary first molar",
      ],
      correct: 2
    },
    {
      id: 57054,
      question: "A flush terminal plane in primary dentition indicates which relationship?",
      options: [
        "Mandibular second molar is mesial to maxillary second molar",
        "Primary maxillary and mandibular second molars occlude end-to-end",
        "Mandibular second molar is distal to maxillary second molar",
        "There is significant spacing between second molars",
      ],
      correct: 1
    },
    {
      id: 57055,
      question: "A mesial step in primary dentition occurs when which condition exists?",
      options: [
        "Maxillary second molar is mesial to mandibular second molar",
        "Primary mandibular second molar is mesial to maxillary second molar",
        "Both second molars occlude in end-to-end position",
        "Mandibular second molar is distal to maxillary second molar",
      ],
      correct: 1
    },
    {
      id: 57056,
      question: "Bruxism is best defined as which parafunctional habit?",
      options: [
        "Habitual thumb or finger sucking behavior",
        "Grinding or clenching of teeth unconsciously",
        "Tongue thrusting during swallowing",
        "Nail biting causing incisal wear",
      ],
      correct: 1
    },
    {
      id: 57057,
      question: "Primary trauma from occlusion affects which type of periodontium?",
      options: [
        "A periodontium weakened by previous disease",
        "A periodontium that has not been altered by disease",
        "A periodontium with severe bone loss",
        "A periodontium with gingival recession only",
      ],
      correct: 1
    },
    {
      id: 57058,
      question: "Secondary trauma from occlusion is characterized by which condition?",
      options: [
        "Excessive forces on healthy, disease-free periodontal tissues",
        "Normal or excessive forces on a periodontium weakened by disease",
        "Minimal forces causing mobility in healthy teeth",
        "Trauma only from external accidents or injuries",
      ],
      correct: 1
    },
    {
      id: 57059,
      question: "Which type of radiograph is most useful for detecting interproximal caries?",
      options: [
        "Panoramic radiographs showing entire dentition",
        "Bitewing radiographs showing crown and alveolar bone",
        "Periapical radiographs showing entire tooth and apex",
        "Occlusal radiographs showing cross-sectional view",
      ],
      correct: 1
    },
    {
      id: 57060,
      question: "Intraoral cameras (IOCs) are considered which type of diagnostic technology?",
      options: [
        "Traditional assessment methods used for decades",
        "Emerging technologies for enhanced caries detection",
        "Replacement for all radiographic imaging",
        "Tools exclusively for periodontal assessment",
      ],
      correct: 1
    },
    {
      id: 57061,
      question: "When conducting visual caries assessment, what technique improves detection accuracy?",
      options: [
        "Examining teeth only under ambient room lighting",
        "Drying the tooth surface with gauze or air",
        "Using a mirror without direct visualization",
        "Assessing teeth with saliva present",
      ],
      correct: 1
    },
    {
      id: 57062,
      question: "Smooth surface caries can be found on which tooth surfaces?",
      options: [
        "Only on occlusal surfaces of posterior teeth",
        "On facial, buccal, lingual, mesial, and distal surfaces",
        "Exclusively on proximal surfaces between teeth",
        "Only on incisal edges of anterior teeth",
      ],
      correct: 1
    },
    {
      id: 57063,
      question: "Proximal caries occurs at which specific location?",
      options: [
        "On occlusal pits and fissures",
        "Between teeth at the point of proximal contact",
        "On facial surfaces near the gingival margin",
        "On lingual surfaces of all teeth",
      ],
      correct: 1
    },
    {
      id: 57064,
      question: "An open bite is characterized by which occlusal relationship?",
      options: [
        "Excessive vertical overlap of anterior teeth",
        "Lack of vertical overlap with space between upper and lower teeth",
        "Horizontal overlap greater than 5mm",
        "Posterior teeth contacting with anterior spacing",
      ],
      correct: 1
    },
    {
      id: 57065,
      question: "A crossbite involves which tooth relationship?",
      options: [
        "All maxillary teeth positioned lingual to mandibular teeth",
        "One or more maxillary teeth positioned lingual to mandibular teeth",
        "Mandibular teeth positioned lingual to all maxillary teeth",
        "Edge-to-edge contact of maxillary and mandibular teeth",
      ],
      correct: 1
    },
    {
      id: 57066,
      question: "End-to-end bite describes which occlusal condition?",
      options: [
        "Maxillary teeth significantly overlapping mandibular teeth",
        "Maxillary and mandibular teeth meeting edge-to-edge",
        "No contact between maxillary and mandibular teeth",
        "Mandibular teeth positioned anterior to maxillary teeth",
      ],
      correct: 1
    },
    {
      id: 57067,
      question: "Crowding within the dental arch is classified as which type of malocclusion?",
      options: [
        "Class II skeletal malocclusion",
        "Class I malocclusion with individual tooth malposition",
        "Class III prognathic malocclusion",
        "Normal occlusion with proper alignment",
      ],
      correct: 1
    },
    {
      id: 57068,
      question: "Attrition is defined as tooth wear from which cause?",
      options: [
        "Chemical erosion from acidic substances",
        "Tooth-to-tooth contact during function or parafunction",
        "Abrasive action of external substances",
        "Developmental defects in enamel formation",
      ],
      correct: 1
    },
    {
      id: 57069,
      question: "Abrasion results from which mechanism of tooth damage?",
      options: [
        "Tooth-to-tooth grinding during sleep",
        "Mechanical wearing away by external abrasive substances",
        "Chemical dissolution from acids",
        "Bacterial demineralization of enamel",
      ],
      correct: 1
    },
    {
      id: 57070,
      question: "Erosion of tooth structure is caused by which factor?",
      options: [
        "Grinding teeth against each other",
        "Chemical action of acids dissolving tooth structure",
        "Abrasive toothbrushing technique",
        "Bacterial acid production in biofilm",
      ],
      correct: 1
    },
    {
      id: 57071,
      question: "Recurrent caries is best defined as which condition?",
      options: [
        "Initial caries on previously unaffected surfaces",
        "New caries occurring under or around existing restorations",
        "Caries that has been successfully arrested",
        "Caries affecting primary teeth in children",
      ],
      correct: 1
    },
    {
      id: 57072,
      question: "Rampant caries requires which type of intervention?",
      options: [
        "Routine preventive care and monitoring",
        "Urgent intervention due to sudden rapid destruction",
        "No treatment as it will self-arrest",
        "Annual evaluation with fluoride therapy",
      ],
      correct: 1
    },
    {
      id: 57073,
      question: "Class III caries in Black's Classification System affects which surfaces?",
      options: [
        "Occlusal surfaces of premolars and molars",
        "Proximal surfaces of incisors and canines not involving the incisal angle",
        "Cervical third of facial or lingual surfaces",
        "Proximal surfaces of premolars and molars",
      ],
      correct: 1
    },
    {
      id: 57074,
      question: "Class IV caries involves which tooth surfaces?",
      options: [
        "Occlusal pits and fissures of molars",
        "Proximal surfaces of incisors and canines involving the incisal angle",
        "Smooth facial surfaces of all teeth",
        "Root surfaces at the cementoenamel junction",
      ],
      correct: 1
    },
    {
      id: 57075,
      question: "Class V caries is located in which area?",
      options: [
        "Occlusal surfaces of posterior teeth",
        "Cervical third of facial or lingual surfaces",
        "Proximal surfaces between molars",
        "Incisal edges of anterior teeth",
      ],
      correct: 1
    },
    {
      id: 57076,
      question: "Class VI caries affects which tooth surfaces?",
      options: [
        "Proximal surfaces of premolars",
        "Incisal edges of anterior teeth and cusp tips of posterior teeth",
        "Cervical areas of all teeth",
        "Root surfaces below the CEJ",
      ],
      correct: 1
    },
    {
      id: 57077,
      question: "Abfraction lesions are thought to result from which causative factor?",
      options: [
        "Bacterial acid production at the gingival margin",
        "Occlusal stress causing cervical enamel microfractures",
        "Aggressive toothbrushing with abrasive dentifrice",
        "Dietary acids eroding cervical tooth structure",
      ],
      correct: 1
    },
    {
      id: 57078,
      question: "What is the recommended approach when a patient presents with dental symptoms?",
      options: [
        "Dismiss symptoms if not visible clinically",
        "Encourage detailed information about location, duration, and characteristics",
        "Immediately prescribe antibiotics for pain",
        "Refer to a specialist without assessment",
      ],
      correct: 1
    },
    {
      id: 57079,
      question: "Gemination in tooth development results in which appearance?",
      options: [
        "Two separate teeth joined at the roots",
        "A single tooth with a bifid or doubled crown",
        "A tooth with invaginated enamel",
        "Multiple small supernumerary teeth",
      ],
      correct: 1
    },
    {
      id: 57080,
      question: "Concresence is characterized by which condition?",
      options: [
        "Two teeth united by enamel during development",
        "Two teeth united by cementum, typically at the roots",
        "A single tooth with doubled crown structure",
        "Enamel invagination creating a tooth within a tooth",
      ],
      correct: 1
    },
    {
      id: 57081,
      question: "An increased overjet is commonly associated with which habit?",
      options: [
        "Tongue thrusting during swallowing",
        "Prolonged thumb or finger sucking",
        "Mouth breathing exclusively",
        "Bruxism or teeth grinding",
      ],
      correct: 1
    },
    {
      id: 57082,
      question: "The goal of hard-tissue assessment is to recognize and document signs of dental caries, acquired tooth damage, and developmental anomalies.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57083,
      question: "Electronic charting systems have no disadvantages and are inexpensive to implement.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 57084,
      question: "Primary dentition consists of 20 teeth with 5 in each quadrant.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57085,
      question: "Permanent dentition includes 28 teeth with 7 in each quadrant.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 57086,
      question: "Sextant classification divides the oral cavity into six sections for assessment purposes.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57087,
      question: "The crown of a tooth can be divided horizontally into gingival, middle, and incisal or occlusal thirds.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57088,
      question: "Patient symptom assessment should begin with closed-ended yes or no questions.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 57089,
      question: "Dental caries is a multifactorial infectious and transmissible disease involving bacterial action on fermentable carbohydrates.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57090,
      question: "Smooth facial surfaces of anterior teeth are the most susceptible sites for biofilm retention.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 57091,
      question: "Early childhood caries is observed in children under 5 years of age.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57092,
      question: "Arrested caries represents recalcified lesions resulting from remineralization when the caries process halts.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57093,
      question: "Explorer assessment with sharp instruments is currently recommended for caries detection.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 57094,
      question: "Root caries involves the tooth root, cementum, or cervical area of the tooth.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57095,
      question: "Endodontics is the dental specialty that manages prevention, diagnosis, and treatment of dental pulp and peri-radicular tissues.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57096,
      question: "The two most common causes of pulpal nerve damage are bacterial infection and trauma.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57097,
      question: "Dentition charting should only be conducted at the initial assessment appointment.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 57098,
      question: "Hyperdontia refers to having more teeth than normal in the dentition.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57099,
      question: "Mesiodens is an extra tooth located in the midline between maxillary central incisors.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57100,
      question: "Macrodontia refers to teeth that are abnormally small compared to normal size.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 57101,
      question: "Fusion occurs when two tooth germs unite during development.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57102,
      question: "Dens in dente is characterized by an invagination of enamel into the tooth.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57103,
      question: "Dental fluorosis is caused by excessive fluoride ingestion during enamel formation.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57104,
      question: "Hutchinson incisors are associated with congenital syphilis affecting tooth formation.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57105,
      question: "Amelogenesis imperfecta is an acquired condition from childhood illness.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 57106,
      question: "Taurodontism is characterized by an enlarged pulp chamber with smaller-appearing roots.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57107,
      question: "Overjet measures the vertical overlap of maxillary over mandibular incisors.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 57108,
      question: "In Class I malocclusion, the molar relationship is normal but individual teeth may be malpositioned.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57109,
      question: "Class II malocclusion typically displays a retrognathic facial profile.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57110,
      question: "In Class III malocclusion, the mandibular first molar is positioned mesial to the maxillary first molar.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57111,
      question: "A flush terminal plane indicates that primary maxillary and mandibular second molars occlude end-to-end.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57112,
      question: "Primary trauma from occlusion affects a periodontium that has been weakened by disease.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 57113,
      question: "Bitewing radiographs are most useful for detecting interproximal caries.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57114,
      question: "Drying the tooth surface with gauze or air improves visual caries detection accuracy.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57115,
      question: "Attrition results from tooth-to-tooth contact during function or parafunction.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57116,
      question: "Erosion is caused by mechanical wearing away from external abrasive substances.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 57117,
      question: "Recurrent caries is new caries occurring under or around existing restorations.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57118,
      question: "Rampant caries requires urgent intervention due to sudden rapid destruction of many teeth.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57119,
      question: "Black's Classification System Class VI caries affects incisal edges and cusp tips.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 57120,
      question: "Gemination results in two separate teeth joined at the roots.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 57121,
      question: "Prolonged thumb or finger sucking is commonly associated with increased overjet.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    }
  ],
  "3-1. Extraoral and Intraoral Clinical Assessment": [
    {
      id: 58001,
      question: "What is the primary purpose of conducting extraoral and intraoral assessments in dental hygiene practice?",
      options: [
        "To ensure thorough assessment of head and neck areas for client-specific care",
        "To complete insurance documentation requirements efficiently",
        "To fulfill continuing education requirements for dental professionals",
        "To establish baseline data for legal documentation purposes",
      ],
      correct: 0
    },
    {
      id: 58002,
      question: "A lesion is best defined as which of the following?",
      options: [
        "Any visible abnormality present in oral tissues",
        "A change in structure of an organ or part attributable to injury or disease",
        "A temporary condition requiring immediate intervention",
        "A normal variation in tissue appearance",
      ],
      correct: 1
    },
    {
      id: 58003,
      question: "An atypical finding during oral examination is characterized as which of the following?",
      options: [
        "A finding that could prove to be fatal",
        "A finding requiring immediate surgical intervention",
        "A variation from normal that may be benign",
        "A finding indicating advanced disease progression",
      ],
      correct: 2
    },
    {
      id: 58004,
      question: "Which of the following best describes an abnormal finding?",
      options: [
        "A minor variation in tissue color or texture",
        "A finding that could prove to be serious or possibly fatal",
        "Any finding that differs from textbook descriptions",
        "A temporary condition resolving within days",
      ],
      correct: 1
    },
    {
      id: 58005,
      question: "Extraoral and intraoral examinations may reveal signs of which systemic conditions?",
      options: [
        "Thyroid disorders, eating disorders, and nutritional deficiencies",
        "Only dental caries and periodontal disease",
        "Exclusively infectious diseases of bacterial origin",
        "Primarily cardiovascular and respiratory conditions",
      ],
      correct: 0
    },
    {
      id: 58006,
      question: "Which assessment skill involves using visual inspection to evaluate tissues?",
      options: [
        "Palpation for detecting tissue abnormalities",
        "Observation for identifying visible changes",
        "Auscultation for hearing internal sounds",
        "Olfaction for detecting unusual odors",
      ],
      correct: 1
    },
    {
      id: 58007,
      question: "Palpation as an assessment technique is best described as which method?",
      options: [
        "Listening to sounds produced by body structures",
        "Observing tissue color and surface characteristics",
        "Using touch to examine tissue characteristics",
        "Detecting odors associated with disease",
      ],
      correct: 2
    },
    {
      id: 58008,
      question: "Auscultation involves which assessment technique?",
      options: [
        "Visual examination of surface characteristics",
        "Listening to sounds within the body",
        "Feeling tissue texture and consistency",
        "Detecting characteristic odors",
      ],
      correct: 1
    },
    {
      id: 58009,
      question: "Olfaction as an assessment skill refers to which technique?",
      options: [
        "Detecting characteristic smells or odors",
        "Observing visual changes in tissues",
        "Palpating for tissue abnormalities",
        "Listening to joint sounds",
      ],
      correct: 0
    },
    {
      id: 58010,
      question: "Digital palpation is performed using which anatomical structures?",
      options: [
        "The entire palm of both hands",
        "A single finger or digit",
        "Two fingers from opposite hands",
        "The thumb and multiple fingers",
      ],
      correct: 1
    },
    {
      id: 58011,
      question: "Bidigital palpation involves which technique?",
      options: [
        "Using one finger from each hand simultaneously",
        "Using the entire palm for assessment",
        "Using two fingers from the same hand",
        "Using thumbs from both hands bilaterally",
      ],
      correct: 2
    },
    {
      id: 58012,
      question: "Manual palpation utilizes which part of the clinician's hand?",
      options: [
        "Only the fingertips for precision",
        "The entire palm and fingers of one hand",
        "Two fingers placed opposite each other",
        "Both hands working simultaneously",
      ],
      correct: 1
    },
    {
      id: 58013,
      question: "Bimanual palpation is characterized by which technique?",
      options: [
        "Using fingers from the same hand",
        "Using both hands to examine tissue between them",
        "Using one hand externally and observation internally",
        "Using alternating hands for comparison",
      ],
      correct: 1
    },
    {
      id: 58014,
      question: "Bilateral palpation involves examining which areas?",
      options: [
        "Multiple sites on the same side simultaneously",
        "Corresponding structures on opposite sides for comparison",
        "Internal and external surfaces simultaneously",
        "Anterior and posterior regions sequentially",
      ],
      correct: 1
    },
    {
      id: 58015,
      question: "Circular compression as a palpation method is used to assess which characteristic?",
      options: [
        "Surface texture by rubbing in circles",
        "Tissue depth by pressing in circular motions",
        "Temperature variations across regions",
        "Mobility of underlying structures",
      ],
      correct: 1
    },
    {
      id: 58016,
      question: "During extraoral assessment, normal facial and head findings include which characteristics?",
      options: [
        "Asymmetry with variations in skin tone",
        "Symmetry with continuous, firm skin",
        "Visible scarring from childhood injuries",
        "Multiple moles and freckles distributed irregularly",
      ],
      correct: 1
    },
    {
      id: 58017,
      question: "Which of the following would be considered an atypical finding during extraoral examination?",
      options: [
        "Needle marks indicating drug use",
        "Moles, freckles, and minor scars",
        "Symmetric facial features",
        "Continuous skin without lesions",
      ],
      correct: 1
    },
    {
      id: 58018,
      question: "What is the recommended sequence for conducting an extraoral examination?",
      options: [
        "Starting with lymph nodes then moving to facial features",
        "Beginning with overall appraisal, then face, skin, eyes, nodes, glands, TMJ, and lips",
        "Examining only areas where patient reports concerns",
        "Starting with TMJ, then glands, followed by facial assessment",
      ],
      correct: 1
    },
    {
      id: 58019,
      question: "The frontal region examination includes assessment of which anatomical area?",
      options: [
        "The forehead and anterior scalp region",
        "The cheeks and lateral facial areas",
        "The chin and lower jaw region",
        "The nose and surrounding structures",
      ],
      correct: 0
    },
    {
      id: 58020,
      question: "Examination of the temporal and auricular regions includes assessment of which structures?",
      options: [
        "The forehead and eyes exclusively",
        "The temples and ear areas",
        "The chin and lower jaw",
        "The nose and upper lip",
      ],
      correct: 1
    },
    {
      id: 58021,
      question: "The buccal region refers to which facial area?",
      options: [
        "The forehead and temporal regions",
        "The area around the eyes",
        "The cheek areas on lateral face",
        "The chin and lower jaw",
      ],
      correct: 2
    },
    {
      id: 58022,
      question: "The mental region includes which anatomical landmark?",
      options: [
        "The forehead and frontal bone area",
        "The cheeks and lateral face",
        "The chin and lower mandible",
        "The nose and nasal structures",
      ],
      correct: 2
    },
    {
      id: 58023,
      question: "The submandibular and submental triangles contain which structures?",
      options: [
        "Parotid glands and facial lymph nodes exclusively",
        "Submandibular and sublingual salivary glands with associated lymph nodes",
        "Only lymph nodes without glandular tissue",
        "Thyroid gland and cervical muscles",
      ],
      correct: 1
    },
    {
      id: 58024,
      question: "The anterior and posterior cervical triangles contain which major muscle?",
      options: [
        "Masseter muscle and associated nodes",
        "Digastric muscle and facial structures",
        "Sternocleidomastoid muscle and associated lymph nodes",
        "Temporalis muscle and parotid gland",
      ],
      correct: 2
    },
    {
      id: 58025,
      question: "The anterior midline cervical region includes which structures?",
      options: [
        "Submandibular glands and lymph nodes",
        "Parotid glands and facial structures",
        "Hyoid bone, thyroid cartilage, thyroid gland, and larynx",
        "Sternocleidomastoid muscles and cervical nodes",
      ],
      correct: 2
    },
    {
      id: 58026,
      question: "Palpable lymph nodes during examination may indicate which condition?",
      options: [
        "Always indicate metastatic cancer requiring immediate treatment",
        "May pinpoint where a disease process is active",
        "Are always normal findings requiring no concern",
        "Only indicate temporary viral infections",
      ],
      correct: 1
    },
    {
      id: 58027,
      question: "What is the significance of enlarged lymph nodes during assessment?",
      options: [
        "They only indicate localized infection never spreading",
        "They help determine whether disease has become widespread",
        "They are always benign and require no follow-up",
        "They indicate only allergic reactions to medications",
      ],
      correct: 1
    },
    {
      id: 58028,
      question: "The temporomandibular joint should be assessed for which characteristics?",
      options: [
        "Color changes and surface texture only",
        "Sounds, range of motion, and pain upon movement",
        "Temperature variations exclusively",
        "Only visual symmetry without palpation",
      ],
      correct: 1
    },
    {
      id: 58029,
      question: "During intraoral examination, which structures should be assessed first?",
      options: [
        "Hard and soft palate exclusively",
        "Tongue and floor of mouth",
        "Lips and intraoral mucosa",
        "Tonsillar areas and pharynx",
      ],
      correct: 2
    },
    {
      id: 58030,
      question: "Oral mucosa is classified into how many main types?",
      options: [
        "Two types: attached and unattached",
        "Three types: masticatory, lining, and specialized",
        "Four types: keratinized, non-keratinized, attached, and free",
        "Five types based on location and function",
      ],
      correct: 1
    },
    {
      id: 58031,
      question: "Masticatory mucosa is found in which oral locations?",
      options: [
        "Lips, cheeks, and floor of mouth",
        "Gingiva and hard palate",
        "Tongue dorsum exclusively",
        "Soft palate and oropharynx",
      ],
      correct: 1
    },
    {
      id: 58032,
      question: "Lining mucosa is characterized by which features?",
      options: [
        "Heavily keratinized and firmly attached to bone",
        "Non-keratinized and loosely attached, allowing movement",
        "Contains specialized taste receptors",
        "Found only on the tongue surface",
      ],
      correct: 1
    },
    {
      id: 58033,
      question: "Specialized mucosa is found on which structure?",
      options: [
        "The hard palate and attached gingiva",
        "The buccal mucosa and lips",
        "The dorsal surface of the tongue",
        "The floor of mouth and vestibule",
      ],
      correct: 2
    },
    {
      id: 58034,
      question: "The vermilion border is found on which structure?",
      options: [
        "The junction between gingiva and alveolar mucosa",
        "The junction between palatal and pharyngeal tissues",
        "The transition zone between lip skin and mucosa",
        "The border between tongue and floor of mouth",
      ],
      correct: 2
    },
    {
      id: 58035,
      question: "The labial commissure refers to which anatomical landmark?",
      options: [
        "The center of the upper lip",
        "The corner where upper and lower lips meet",
        "The junction of lip and facial skin",
        "The midline of the lower lip",
      ],
      correct: 1
    },
    {
      id: 58036,
      question: "The mucocutaneous junction is best described as which structure?",
      options: [
        "The border between keratinized and non-keratinized tissue",
        "The transition between skin and mucous membrane",
        "The junction between hard and soft palate",
        "The border between gingiva and teeth",
      ],
      correct: 1
    },
    {
      id: 58037,
      question: "The philtrum is located in which area?",
      options: [
        "The vertical groove in the center of the upper lip",
        "The depression in the center of the chin",
        "The fold between cheek and gingiva",
        "The groove on the tongue dorsum",
      ],
      correct: 0
    },
    {
      id: 58038,
      question: "The hard palate is characterized by which features?",
      options: [
        "Movable tissue with muscle underneath",
        "Firm, immovable tissue covering bone",
        "Highly vascular and soft consistency",
        "Contains tonsils and lymphoid tissue",
      ],
      correct: 1
    },
    {
      id: 58039,
      question: "The soft palate differs from the hard palate in which characteristic?",
      options: [
        "It contains bone for structural support",
        "It is immovable and firmly attached",
        "It is movable and contains muscle",
        "It is covered with keratinized epithelium",
      ],
      correct: 2
    },
    {
      id: 58040,
      question: "The uvula is located in which anatomical region?",
      options: [
        "Hanging from the posterior soft palate",
        "On the anterior hard palate",
        "At the junction of cheek and gingiva",
        "On the floor of mouth",
      ],
      correct: 0
    },
    {
      id: 58041,
      question: "The palatine tonsils are located in which area?",
      options: [
        "On the hard palate near the midline",
        "On the lateral walls between faucial pillars",
        "On the floor of mouth bilaterally",
        "On the dorsum of the tongue",
      ],
      correct: 1
    },
    {
      id: 58042,
      question: "The fauces refer to which anatomical structure?",
      options: [
        "The opening between oral cavity and pharynx",
        "The grooves on the tongue surface",
        "The fold between cheek and gingiva",
        "The junction of hard and soft palate",
      ],
      correct: 0
    },
    {
      id: 58043,
      question: "Which structures are known as the anterior and posterior faucial pillars?",
      options: [
        "The lateral borders of the tongue",
        "The folds of tissue surrounding the tonsils",
        "The ridges on the hard palate",
        "The folds in the floor of mouth",
      ],
      correct: 1
    },
    {
      id: 58044,
      question: "The tongue is divided into how many main anatomical regions?",
      options: [
        "Two regions: anterior and posterior",
        "Three regions: apex, body, and base",
        "Four regions: tip, sides, center, and back",
        "Five regions based on papillae distribution",
      ],
      correct: 1
    },
    {
      id: 58045,
      question: "The median lingual sulcus is found on which tongue surface?",
      options: [
        "A groove running down the center of the dorsal surface",
        "The fold on the ventral surface",
        "The lateral borders bilaterally",
        "The posterior third near the base",
      ],
      correct: 0
    },
    {
      id: 58046,
      question: "Circumvallate papillae are located in which tongue region?",
      options: [
        "Scattered across the entire dorsal surface",
        "In a V-shaped row on the posterior dorsum",
        "On the lateral borders bilaterally",
        "On the ventral surface and tip",
      ],
      correct: 1
    },
    {
      id: 58047,
      question: "Filiform papillae are characterized by which features?",
      options: [
        "Large, mushroom-shaped with taste buds",
        "Small, thread-like covering most of dorsum",
        "Located in a V-pattern on posterior tongue",
        "Found only on lateral tongue borders",
      ],
      correct: 1
    },
    {
      id: 58048,
      question: "Fungiform papillae appear as which structures?",
      options: [
        "Small thread-like projections covering the tongue",
        "Large papillae in V-formation posteriorly",
        "Mushroom-shaped papillae scattered on dorsum",
        "Leaf-like structures on lateral borders",
      ],
      correct: 2
    },
    {
      id: 58049,
      question: "Foliate papillae are located in which tongue region?",
      options: [
        "Scattered across the entire dorsal surface",
        "On the lateral posterior borders",
        "In a V-shaped pattern posteriorly",
        "On the ventral surface exclusively",
      ],
      correct: 1
    },
    {
      id: 58050,
      question: "The lingual frenum is found in which location?",
      options: [
        "A fold on the dorsal surface of tongue",
        "A fold connecting ventral tongue to floor of mouth",
        "The groove between tongue and cheek",
        "The attachment between tongue and soft palate",
      ],
      correct: 1
    },
    {
      id: 58051,
      question: "The sublingual caruncles are located in which area?",
      options: [
        "On the dorsal surface of the tongue",
        "On either side of the lingual frenum in floor of mouth",
        "On the lateral borders of the tongue",
        "On the hard palate near midline",
      ],
      correct: 1
    },
    {
      id: 58052,
      question: "The plica sublingualis refers to which structure?",
      options: [
        "The groove on the dorsal tongue",
        "The fold on floor of mouth lateral to frenum",
        "The attachment of the tongue base",
        "The tissue connecting lip to gingiva",
      ],
      correct: 1
    },
    {
      id: 58053,
      question: "The parotid papilla is located in which area?",
      options: [
        "On the hard palate near the midline",
        "On the buccal mucosa opposite the maxillary second molar",
        "On the floor of mouth near lingual frenum",
        "On the soft palate near the uvula",
      ],
      correct: 1
    },
    {
      id: 58054,
      question: "Stensen's duct is the opening for which salivary gland?",
      options: [
        "The submandibular gland",
        "The sublingual gland",
        "The parotid gland",
        "The minor salivary glands",
      ],
      correct: 2
    },
    {
      id: 58055,
      question: "Wharton's duct is the opening for which salivary gland?",
      options: [
        "The parotid gland",
        "The submandibular gland",
        "The sublingual gland",
        "The minor palatine glands",
      ],
      correct: 1
    },
    {
      id: 58056,
      question: "The mucobuccal fold is located in which area?",
      options: [
        "The junction between buccal mucosa and gingiva",
        "The fold between tongue and floor of mouth",
        "The tissue connecting lip to alveolar process",
        "The groove on the tongue dorsum",
      ],
      correct: 0
    },
    {
      id: 58057,
      question: "The alveolar mucosa is characterized by which features?",
      options: [
        "Firmly attached, keratinized tissue covering bone",
        "Loosely attached, non-keratinized movable tissue",
        "Contains taste buds and specialized receptors",
        "Forms the junction between teeth and gingiva",
      ],
      correct: 1
    },
    {
      id: 58058,
      question: "The retromolar pad is located in which region?",
      options: [
        "Behind the maxillary third molar area",
        "Behind the mandibular third molar area",
        "On the hard palate posteriorly",
        "On the floor of mouth",
      ],
      correct: 1
    },
    {
      id: 58059,
      question: "More than what percentage of head and neck cancers originate in the oral cavity?",
      options: [
        "More than 50% of cases",
        "More than 65% of cases",
        "More than 75% of cases",
        "More than 85% of cases",
      ],
      correct: 2
    },
    {
      id: 58060,
      question: "Recent increases in pharyngeal cancer cases are related to which infection?",
      options: [
        "Hepatitis B virus infection",
        "Epstein-Barr virus infection",
        "Human papillomavirus (HPV) infection",
        "Cytomegalovirus infection",
      ],
      correct: 2
    },
    {
      id: 58061,
      question: "Which are the primary risk factors for oral and oropharyngeal cancer?",
      options: [
        "Poor oral hygiene and vitamin deficiencies",
        "Tobacco use, alcohol abuse, and HPV infection",
        "Diabetes and cardiovascular disease",
        "Autoimmune disorders and genetic factors",
      ],
      correct: 1
    },
    {
      id: 58062,
      question: "What percentage of oral squamous cell carcinoma occurs on the lower lip?",
      options: [
        "18% of cases",
        "28% of cases",
        "38% of cases",
        "48% of cases",
      ],
      correct: 2
    },
    {
      id: 58063,
      question: "What percentage of oral squamous cell carcinoma occurs on the lateral border of the tongue?",
      options: [
        "10% of cases",
        "20% of cases",
        "30% of cases",
        "40% of cases",
      ],
      correct: 2
    },
    {
      id: 58064,
      question: "What percentage of oral squamous cell carcinoma occurs on the floor of the mouth?",
      options: [
        "8% of cases",
        "11% of cases",
        "14% of cases",
        "17% of cases",
      ],
      correct: 2
    },
    {
      id: 58065,
      question: "The soft palate complex accounts for what percentage of oral squamous cell carcinoma?",
      options: [
        "5% of cases",
        "8% of cases",
        "11% of cases",
        "14% of cases",
      ],
      correct: 2
    },
    {
      id: 58066,
      question: "Which of the following is the most common type of skin cancer?",
      options: [
        "Melanoma with potential for metastasis",
        "Basal cell carcinoma",
        "Squamous cell carcinoma",
        "Merkel cell carcinoma",
      ],
      correct: 1
    },
    {
      id: 58067,
      question: "Carcinoma in situ is best described as which cancer stage?",
      options: [
        "Advanced cancer with metastasis",
        "The earliest form of cancer",
        "Cancer that has invaded deep tissues",
        "Cancer that is untreatable",
      ],
      correct: 1
    },
    {
      id: 58068,
      question: "Melanoma is characterized as which type of skin cancer?",
      options: [
        "The most common but least dangerous form",
        "Less common but possibly fatal form",
        "Only affects elderly populations",
        "Never occurs in the oral cavity",
      ],
      correct: 1
    },
    {
      id: 58069,
      question: "A lesion that does not show healing within what timeframe should raise concern?",
      options: [
        "Within a 3-day window",
        "Within a 1-week window",
        "Within a 2-week window",
        "Within a 1-month window",
      ],
      correct: 2
    },
    {
      id: 58070,
      question: "Chronicity as a cancer progression indicator refers to which characteristic?",
      options: [
        "Rapid growth over days",
        "Persistent duration over time",
        "Intermittent appearance and disappearance",
        "Seasonal variation in symptoms",
      ],
      correct: 1
    },
    {
      id: 58071,
      question: "Erythroplakia is characterized by which appearance?",
      options: [
        "A white patch that cannot be scraped off",
        "A red patch or lesion",
        "A mixed red and white lesion",
        "A pigmented brown or black lesion",
      ],
      correct: 1
    },
    {
      id: 58072,
      question: "Erythroleukoplakia is characterized by which appearance?",
      options: [
        "Only white patches without red areas",
        "Only red patches without white areas",
        "Mixed red and white patches",
        "Brown or black pigmented areas",
      ],
      correct: 2
    },
    {
      id: 58073,
      question: "Leukoplakia is characterized by which appearance?",
      options: [
        "A red patch on mucosa",
        "A white patch that cannot be rubbed off",
        "A mixed red and white lesion",
        "A pigmented lesion",
      ],
      correct: 1
    },
    {
      id: 58074,
      question: "Induration of a lesion refers to which characteristic?",
      options: [
        "Soft, compressible consistency",
        "Hardness or firmness of tissue",
        "Fluid-filled appearance",
        "Smooth surface texture",
      ],
      correct: 1
    },
    {
      id: 58075,
      question: "Fixation of a lesion indicates which characteristic?",
      options: [
        "High mobility with palpation",
        "Attachment to underlying structures limiting movement",
        "Fluid-filled and fluctuant",
        "Easily displaced with pressure",
      ],
      correct: 1
    },
    {
      id: 58076,
      question: "Lymphadenopathy refers to which condition?",
      options: [
        "Normal, non-palpable lymph nodes",
        "Disease or enlargement of lymph nodes",
        "Absence of lymphoid tissue",
        "Decreased lymph node function",
      ],
      correct: 1
    },
    {
      id: 58077,
      question: "Patient self-examination for oral cancer should include review of which factors?",
      options: [
        "Only visible lesions on lips",
        "Risk factors and common symptoms",
        "Exclusively dental restoration condition",
        "Only areas of previous dental treatment",
      ],
      correct: 1
    },
    {
      id: 58078,
      question: "Documentation of significant findings should include which specific descriptive items?",
      options: [
        "Only the location and basic color",
        "Location, size, shape, color, texture, consistency, and symptoms",
        "Only abnormal findings requiring immediate referral",
        "Exclusively findings that appear malignant",
      ],
      correct: 1
    },
    {
      id: 58079,
      question: "Soft consistency of a lesion is compared to which normal tissue?",
      options: [
        "Cartilage or bone structure",
        "Adipose tissue or loose connective tissue",
        "Enamel or calcified material",
        "Muscle or firm glandular tissue",
      ],
      correct: 1
    },
    {
      id: 58080,
      question: "Firm consistency of a lesion is compared to which normal tissue?",
      options: [
        "Loose connective tissue",
        "Cartilage",
        "Bone or enamel",
        "Adipose tissue",
      ],
      correct: 1
    },
    {
      id: 58081,
      question: "Hard consistency of a lesion indicates which composition?",
      options: [
        "Primarily cellular tissue",
        "Contains bone or calcified material",
        "Composed of fluid-filled spaces",
        "Made of loose connective tissue",
      ],
      correct: 1
    },
    {
      id: 58082,
      question: "Lesions are categorized into how many main morphologic categories?",
      options: [
        "Two categories: normal and abnormal",
        "Three categories: elevated, depressed, and flat",
        "Four categories based on color variations",
        "Five categories based on size",
      ],
      correct: 1
    },
    {
      id: 58083,
      question: "Elevated lesions are characterized by which feature?",
      options: [
        "Below the normal plane of mucosa",
        "Above the normal plane of mucosa",
        "At the same level as surrounding tissue",
        "Visible only with transillumination",
      ],
      correct: 1
    },
    {
      id: 58084,
      question: "Blisterform elevated lesions contain which material?",
      options: [
        "Solid tissue with no fluid",
        "Fluid with transparent appearance",
        "Only blood or hemorrhagic material",
        "Calcified deposits",
      ],
      correct: 1
    },
    {
      id: 58085,
      question: "A vesicle is defined as a blisterform lesion of what size?",
      options: [
        "Larger than 10mm in diameter",
        "5mm or less in diameter",
        "Between 6-10mm in diameter",
        "Greater than 15mm in diameter",
      ],
      correct: 1
    },
    {
      id: 58086,
      question: "A bulla is defined as a blisterform lesion of what size?",
      options: [
        "Less than 3mm in diameter",
        "3-5mm in diameter",
        "Greater than 5mm in diameter",
        "Exactly 5mm in diameter",
      ],
      correct: 2
    },
    {
      id: 58087,
      question: "A pustule contains which type of fluid?",
      options: [
        "Clear serous fluid only",
        "Pus with yellowish color",
        "Blood or serosanguinous fluid",
        "Lymphatic fluid",
      ],
      correct: 1
    },
    {
      id: 58088,
      question: "A papule is characterized by which features?",
      options: [
        "Larger than 10mm, soft consistency",
        "5mm or less in diameter, solid lesion",
        "Greater than 20mm, fluid-filled",
        "Any size, containing pus",
      ],
      correct: 1
    },
    {
      id: 58089,
      question: "A nodule is characterized by which features?",
      options: [
        "3mm or less in diameter",
        "Greater than 5mm but less than 2cm in diameter",
        "Larger than 5cm in diameter",
        "Must be fluid-filled",
      ],
      correct: 1
    },
    {
      id: 58090,
      question: "A tumor is characterized by which features?",
      options: [
        "1cm or less in diameter",
        "2cm or greater in diameter",
        "Must be malignant",
        "Always less than 5mm",
      ],
      correct: 1
    },
    {
      id: 58091,
      question: "A plaque is characterized by which features?",
      options: [
        "Deep lesion extending into tissues",
        "Slightly raised with broad, flat top",
        "Highly elevated above surrounding tissue",
        "Always less than 2mm in diameter",
      ],
      correct: 1
    },
    {
      id: 58092,
      question: "Pedunculated describes which lesion characteristic?",
      options: [
        "Flat base attachment",
        "On a stem or stalk",
        "Embedded in surrounding tissue",
        "Free-floating without attachment",
      ],
      correct: 1
    },
    {
      id: 58093,
      question: "Sessile describes which lesion characteristic?",
      options: [
        "On a narrow stalk",
        "Broad base containing greatest diameter",
        "Suspended from above",
        "Completely mobile",
      ],
      correct: 1
    },
    {
      id: 58094,
      question: "An ulcer is characterized by which feature?",
      options: [
        "Elevated above surrounding tissue",
        "Loss of continuity of epithelium",
        "Flat lesion with color change",
        "Fluid-filled elevation",
      ],
      correct: 1
    },
    {
      id: 58095,
      question: "An erosion differs from an ulcer in which characteristic?",
      options: [
        "Erosion is deeper than ulcer",
        "Erosion is shallow and doesn't extend through epithelium",
        "Erosion is always larger than ulcer",
        "Erosion contains fluid while ulcer does not",
      ],
      correct: 1
    },
    {
      id: 58096,
      question: "A macule is characterized by which features?",
      options: [
        "Elevated and palpable above surface",
        "Flat, circumscribed, identified by color",
        "Depressed below surrounding tissue",
        "Contains fluid beneath surface",
      ],
      correct: 1
    },
    {
      id: 58097,
      question: "Crater as a surface texture descriptor indicates which feature?",
      options: [
        "Smooth, even surface",
        "Central depression",
        "Raised, wartlike appearance",
        "Hard covering layer",
      ],
      correct: 1
    },
    {
      id: 58098,
      question: "Crust as a surface texture descriptor indicates which feature?",
      options: [
        "Smooth, intact surface",
        "Hard covering of dried serum, pus, or blood",
        "Soft, compressible layer",
        "Rough papillary projections",
      ],
      correct: 1
    },
    {
      id: 58099,
      question: "Papillary surface texture is characterized by which feature?",
      options: [
        "Smooth, flat appearance",
        "Rough surface with small elevated projections",
        "Central depression",
        "Hard, calcified covering",
      ],
      correct: 1
    },
    {
      id: 58100,
      question: "Pseudomembrane is characterized by which feature?",
      options: [
        "Firm, attached tissue layer",
        "Loose membranous layer of exudate from inflammation",
        "Calcified surface covering",
        "Smooth, intact epithelium",
      ],
      correct: 1
    },
    {
      id: 58101,
      question: "Verrucous surface texture is described as which appearance?",
      options: [
        "Smooth with no irregularities",
        "Rough, wartlike surface with irregular folds",
        "Flat with color change only",
        "Central depression",
      ],
      correct: 1
    },
    {
      id: 58102,
      question: "Clinical recommendations for oral lesion evaluation include which practice?",
      options: [
        "Examining only patients who report symptoms",
        "Updated histories and examinations for all adult patients",
        "Examining only high-risk patients",
        "Limiting examinations to annual visits",
      ],
      correct: 1
    },
    {
      id: 58103,
      question: "When should suspicious lesions in adult patients be biopsied?",
      options: [
        "Only if patient requests biopsy",
        "When lesions appear suspicious for malignancy",
        "Never, as biopsy is too invasive",
        "Only after 6 months of observation",
      ],
      correct: 1
    },
    {
      id: 58104,
      question: "Cytologic adjuncts may be performed in which situation?",
      options: [
        "As routine screening for all patients",
        "When patient refuses biopsy or referral",
        "As replacement for biopsy in all cases",
        "Only for lesions smaller than 2mm",
      ],
      correct: 1
    },
    {
      id: 58105,
      question: "A biopsy is defined as which procedure?",
      options: [
        "Visual examination of tissue under magnification",
        "Removal and microscopic examination of tissue for diagnosis",
        "Chemical testing of tissue fluids",
        "Photographic documentation of lesions",
      ],
      correct: 1
    },
    {
      id: 58106,
      question: "Follow-up for innocuous lesions in adult patients should include which approach?",
      options: [
        "Immediate surgical removal of all lesions",
        "Monitoring lesions at regular intervals",
        "Ignoring lesions unless patient complains",
        "Treating all lesions with antibiotics",
      ],
      correct: 1
    },
    {
      id: 58107,
      question: "Documentation of oral examination should include which information?",
      options: [
        "Only abnormal findings requiring referral",
        "Details of examination, recommendations, lifestyle habits, and progress notes",
        "Exclusively findings that appear malignant",
        "Only information requested by insurance companies",
      ],
      correct: 1
    },
    {
      id: 58108,
      question: "The purpose of extraoral and intraoral assessment is to ensure thorough examination of head and neck areas to provide client-specific care.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58109,
      question: "A lesion indicates a change in structure of an organ or part attributable to injury or disease.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58110,
      question: "An atypical finding could prove to be a serious or possibly fatal condition.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 58111,
      question: "Extraoral and intraoral examinations may reveal signs of thyroid disorders, eating disorders, and nutritional deficiencies.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58112,
      question: "Observation is an assessment skill that involves using touch to examine tissues.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 58113,
      question: "Palpation involves using the sense of touch to assess tissue characteristics.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58114,
      question: "Auscultation involves detecting characteristic smells or odors during examination.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 58115,
      question: "Bimanual palpation uses both hands to examine tissue between them.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58116,
      question: "Normal facial and head findings include symmetry with continuous, firm skin.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58117,
      question: "Needle marks from drug use would be considered an atypical finding.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 58118,
      question: "The sequence of extraoral examination begins with overall appraisal of the patient.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58119,
      question: "The submandibular triangle contains the submandibular and sublingual salivary glands with associated lymph nodes.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58120,
      question: "Palpable lymph nodes may pinpoint where a disease process is active.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58121,
      question: "The intraoral examination should begin with assessment of the hard and soft palate.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 58122,
      question: "Oral mucosa is classified into three types: masticatory, lining, and specialized.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58123,
      question: "Masticatory mucosa is found on the gingiva and hard palate.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58124,
      question: "Specialized mucosa is found on the dorsal surface of the tongue.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58125,
      question: "More than 75% of head and neck cancers originate in the oral cavity.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58126,
      question: "Recent increases in pharyngeal cancer are related to HPV infection.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58127,
      question: "The lower lip accounts for 38% of oral squamous cell carcinoma cases.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58128,
      question: "The lateral border of the tongue accounts for 30% of oral squamous cell carcinoma cases.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58129,
      question: "Basal cell carcinoma is the most common type of skin cancer.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58130,
      question: "Melanoma is a less common but possibly fatal form of skin cancer.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58131,
      question: "A lesion that does not show healing within a 2-week window should raise concern.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58132,
      question: "Erythroplakia is characterized by a white patch that cannot be scraped off.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 58133,
      question: "Leukoplakia is characterized by a white patch that cannot be rubbed off.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58134,
      question: "Induration refers to hardness or firmness of tissue.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58135,
      question: "Lymphadenopathy refers to disease or enlargement of lymph nodes.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58136,
      question: "Lesions are categorized into three main morphologic categories: elevated, depressed, and flat.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58137,
      question: "A vesicle is defined as a blisterform lesion 5mm or less in diameter.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58138,
      question: "A bulla is defined as a blisterform lesion greater than 5mm in diameter.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58139,
      question: "A pustule contains clear serous fluid.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 58140,
      question: "A nodule is characterized as greater than 5mm but less than 2cm in diameter.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58141,
      question: "A tumor is characterized as 2cm or greater in diameter.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58142,
      question: "An erosion is shallow and does not extend through epithelium to underlying tissue.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58143,
      question: "A macule is flat, circumscribed, and identified by color.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58144,
      question: "A biopsy involves removal and microscopic examination of tissue for diagnosis.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58145,
      question: "Suspicious lesions in adult patients should be biopsied when they appear potentially malignant.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 58146,
      question: "Documentation should include details of the oral examination, recommendations, lifestyle habits, and progress notes.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    }
  ],
  "5-1. Soft Deposits, Biofilm, Calculus and Stain": [
    {
      id: 59001,
      question: "What is the primary component of the oral microbiome that forms dental biofilm?",
      options: [
        "Food debris and epithelial cells only",
        "Microorganisms, their genetic makeup, and oral cavity environments",
        "Calcified deposits and salivary proteins exclusively",
        "Materia alba and acquired pellicle components",
      ],
      correct: 1
    },
    {
      id: 59002,
      question: "Which stage of biofilm formation involves the initial attachment of bacteria to the acquired pellicle?",
      options: [
        "Stage 3 - Matrix formation and structural development",
        "Stage 5 - Full maturation with complex architecture",
        "Stage 4 - Biofilm growth and three-dimensional expansion",
        "Stage 1 - Formation and initial bacterial adhesion",
      ],
      correct: 3
    },
    {
      id: 59003,
      question: "During which time period does dental biofilm undergo the transition from primarily gram-positive cocci to more diverse bacterial populations?",
      options: [
        "Days 6-10 when filamentous bacteria become prominent",
        "Days 1-2 when initial colonization occurs",
        "Days 10-21 when mature biofilm establishes",
        "Days 2-4 when bacterial diversity increases",
      ],
      correct: 3
    },
    {
      id: 59004,
      question: "What distinguishes supragingival biofilm from subgingival biofilm in terms of location?",
      options: [
        "Subgingival forms below the gingival margin in the sulcus",
        "Supragingival forms within the periodontal pocket only",
        "Subgingival appears only on root surfaces after recession",
        "Supragingival develops exclusively on lingual tooth surfaces",
      ],
      correct: 0
    },
    {
      id: 59005,
      question: "Which inorganic elements are the major components found in dental biofilm composition?",
      options: [
        "Sodium and potassium for cellular metabolism",
        "Fluoride and trace minerals for remineralization",
        "Magnesium and chloride for structural support",
        "Calcium and phosphorus as primary minerals",
      ],
      correct: 3
    },
    {
      id: 59006,
      question: "What organic components constitute the structural matrix of dental biofilm?",
      options: [
        "Minerals and inorganic crystalline structures exclusively",
        "Carbohydrates and proteins forming the biofilm matrix",
        "Lipids and nucleic acids providing energy storage",
        "Enzymes and metabolic byproducts only",
      ],
      correct: 1
    },
    {
      id: 59007,
      question: "Where does biofilm accumulate most heavily on tooth surfaces according to clinical distribution patterns?",
      options: [
        "On smooth buccal surfaces with high saliva flow",
        "In areas exposed to strong masticatory forces",
        "In protected areas like interproximal spaces and gingival thirds",
        "On incisal edges and occlusal surfaces primarily",
      ],
      correct: 2
    },
    {
      id: 59008,
      question: "What is the primary cariogenic microorganism associated with dental caries development in biofilm?",
      options: [
        "Porphyromonas gingivalis producing destructive enzymes",
        "Actinomyces species forming initial colonization",
        "Streptococcus mutans metabolizing sugars to acid",
        "Fusobacterium nucleatum creating inflammatory responses",
      ],
      correct: 2
    },
    {
      id: 59009,
      question: "How does the pH of biofilm change after exposure to fermentable carbohydrates?",
      options: [
        "pH increases to alkaline levels promoting remineralization",
        "pH remains neutral with no significant changes",
        "pH drops to acidic levels causing demineralization",
        "pH fluctuates randomly without predictable patterns",
      ],
      correct: 2
    },
    {
      id: 59010,
      question: "What dietary factor has the most significant effect on cariogenic biofilm development?",
      options: [
        "High protein intake stimulating bacterial metabolism",
        "Frequent consumption of fermentable carbohydrates",
        "Adequate vitamin intake supporting oral health",
        "Increased fiber consumption promoting mechanical cleansing",
      ],
      correct: 1
    },
    {
      id: 59011,
      question: "What is materia alba in terms of clinical appearance?",
      options: [
        "Calcified deposits firmly attached to tooth surfaces",
        "Intrinsic stains within the tooth structure itself",
        "Soft, white, loosely adherent accumulation of debris",
        "Transparent pellicle layer invisible to naked eye",
      ],
      correct: 2
    },
    {
      id: 59012,
      question: "How can materia alba be most effectively removed from tooth surfaces?",
      options: [
        "Requires professional scaling with specialized instruments",
        "Can be removed with water spray or rinsing alone",
        "Needs chemical dissolution with antimicrobial agents",
        "Necessitates ultrasonic debridement in clinical settings",
      ],
      correct: 1
    },
    {
      id: 59013,
      question: "What is the primary difference between supragingival and subgingival calculus in terms of location?",
      options: [
        "Subgingival calculus forms exclusively on anterior teeth",
        "Supragingival calculus appears above the gingival margin",
        "Subgingival deposits only occur with severe periodontitis",
        "Supragingival calculus develops only on posterior molars",
      ],
      correct: 1
    },
    {
      id: 59014,
      question: "Where is supragingival calculus most frequently found in the oral cavity?",
      options: [
        "On the buccal surfaces of maxillary anterior teeth",
        "On palatal surfaces of mandibular posterior teeth",
        "On lingual surfaces of mandibular anterior teeth near salivary ducts",
        "On facial surfaces of all teeth uniformly distributed",
      ],
      correct: 2
    },
    {
      id: 59015,
      question: "What is the primary inorganic component of calculus composition?",
      options: [
        "Organic proteins and carbohydrate matrix materials",
        "Calcium phosphate in crystalline forms",
        "Sodium chloride and trace mineral elements",
        "Fluoride compounds and metallic ions",
      ],
      correct: 1
    },
    {
      id: 59016,
      question: "Which trace elements can be found in dental calculus composition?",
      options: [
        "Only calcium and phosphorus in significant amounts",
        "Various elements including sodium, magnesium, and potassium",
        "Exclusively iron and copper from dietary sources",
        "Carbon and nitrogen from bacterial metabolism only",
      ],
      correct: 1
    },
    {
      id: 59017,
      question: "How does fluoride incorporation affect calculus formation and properties?",
      options: [
        "Fluoride has no measurable effect on calculus",
        "Fluoride increases calculus solubility and removal ease",
        "Fluoride can be incorporated into calculus crystalline structure",
        "Fluoride completely prevents all calculus formation",
      ],
      correct: 2
    },
    {
      id: 59018,
      question: "What organic content is found within calculus deposits?",
      options: [
        "Only inorganic crystalline minerals without organic matter",
        "Proteins, carbohydrates, and bacterial components",
        "Exclusively dead bacterial cells without other materials",
        "Pure salivary glycoproteins forming the entire structure",
      ],
      correct: 1
    },
    {
      id: 59019,
      question: "What is the process by which dental biofilm transforms into calcified calculus?",
      options: [
        "Demineralization removing calcium from tooth structure",
        "Mineralization through calcium and phosphate deposition",
        "Chemical bleaching altering the biofilm composition",
        "Bacterial fermentation producing acidic byproducts",
      ],
      correct: 1
    },
    {
      id: 59020,
      question: "What is the typical structure of mature calculus deposits?",
      options: [
        "Homogeneous smooth surface without irregularities",
        "Soft, easily compressible material lacking organization",
        "Layered structure with rough, irregular surfaces",
        "Crystalline structure identical to tooth enamel",
      ],
      correct: 2
    },
    {
      id: 59021,
      question: "How quickly can new calculus formation occur after professional removal?",
      options: [
        "Several months are required before any formation begins",
        "Formation can begin within days of thorough removal",
        "New calculus only forms after years of accumulation",
        "Calculus never reforms once completely removed",
      ],
      correct: 1
    },
    {
      id: 59022,
      question: "What is the primary mechanism by which calculus attaches to tooth surfaces via acquired pellicle?",
      options: [
        "Chemical bonding through covalent molecular connections",
        "Mechanical interlocking within surface irregularities only",
        "Attachment through the organic pellicle layer interface",
        "Magnetic attraction between mineral components",
      ],
      correct: 2
    },
    {
      id: 59023,
      question: "How does calculus attach to teeth through minute surface irregularities?",
      options: [
        "Through smooth surface adhesion without penetration",
        "By chemical dissolution of the enamel surface",
        "Through mechanical locking into undercuts and roughness",
        "By complete integration into the tooth structure",
      ],
      correct: 2
    },
    {
      id: 59024,
      question: "What occurs when calcified intercellular matrix contacts the tooth surface directly?",
      options: [
        "The tooth surface dissolves creating deeper pockets",
        "Direct attachment forms between calculus and tooth",
        "A protective barrier prevents any attachment",
        "The calculus immediately detaches from the surface",
      ],
      correct: 1
    },
    {
      id: 59025,
      question: "What is the current understanding regarding subgingival calculus's role in periodontal disease?",
      options: [
        "Calculus directly causes all periodontal tissue destruction",
        "Microorganisms in biofilm layer perpetuate inflammation",
        "Calculus has no relationship to periodontal conditions",
        "Only supragingival calculus affects periodontal health",
      ],
      correct: 1
    },
    {
      id: 59026,
      question: "Why is daily biofilm control essential for preventing periodontal disease?",
      options: [
        "Biofilm has no impact on periodontal health",
        "Biofilm microorganisms maintain inflammatory states",
        "Only professional cleaning can control biofilm",
        "Biofilm only affects dental caries, not periodontitis",
      ],
      correct: 1
    },
    {
      id: 59027,
      question: "What is the most effective method for supragingival calculus examination?",
      options: [
        "Radiographic imaging provides the only detection method",
        "Visual examination with proper lighting and drying",
        "Palpation alone without visual inspection",
        "Chemical disclosing solutions reveal all deposits",
      ],
      correct: 1
    },
    {
      id: 59028,
      question: "How is subgingival calculus most effectively detected during examination?",
      options: [
        "Through visual examination of visible tooth surfaces only",
        "Using radiographs as the sole detection method",
        "Through careful tactile exploration with instruments",
        "By relying on patient-reported symptoms exclusively",
      ],
      correct: 2
    },
    {
      id: 59029,
      question: "What is the most important personal preventive measure for calculus control?",
      options: [
        "Annual professional prophylaxis appointments only",
        "Dietary modifications eliminating all carbohydrates",
        "Consistent daily dental biofilm removal",
        "Use of anticalculus products without brushing",
      ],
      correct: 2
    },
    {
      id: 59030,
      question: "How frequently should professional continuing care be provided for optimal calculus prevention?",
      options: [
        "Every five years for routine maintenance",
        "Only when visible calculus accumulation occurs",
        "Regular intervals based on individual patient needs",
        "Once in a lifetime after initial dental treatment",
      ],
      correct: 2
    },
    {
      id: 59031,
      question: "What role do anticalculus dentifrices play in calculus prevention?",
      options: [
        "They completely eliminate the need for mechanical removal",
        "They can help reduce calculus formation rates",
        "They have no effect on calculus development",
        "They replace the need for professional care",
      ],
      correct: 1
    },
    {
      id: 59032,
      question: "How do dental stains and discolorations adhere to tooth surfaces?",
      options: [
        "They only form within the internal tooth structure",
        "They can adhere directly to tooth surfaces",
        "They never attach to natural tooth surfaces",
        "They require calculus presence for attachment",
      ],
      correct: 1
    },
    {
      id: 59033,
      question: "What are the two broad categories of extrinsic dental stains?",
      options: [
        "Permanent and temporary stain classifications",
        "Anterior and posterior location-based categories",
        "Direct extrinsic and indirect extrinsic stains",
        "Natural and artificial stain type divisions",
      ],
      correct: 2
    },
    {
      id: 59034,
      question: "What characterizes the clinical appearance of yellow dental stain?",
      options: [
        "Dark black linear deposits at gingival margins",
        "Greenish discoloration on facial anterior surfaces",
        "Yellowish discoloration often associated with biofilm",
        "Orange deposits from chromogenic bacteria",
      ],
      correct: 2
    },
    {
      id: 59035,
      question: "Where is yellow stain typically distributed on tooth surfaces?",
      options: [
        "Exclusively on lingual surfaces of mandibular teeth",
        "On areas prone to biofilm accumulation",
        "Only on newly erupted permanent teeth",
        "Uniformly across all tooth surfaces regardless of hygiene",
      ],
      correct: 1
    },
    {
      id: 59036,
      question: "What is the primary etiology of yellow dental stain formation?",
      options: [
        "Metallic salts from industrial exposure",
        "Intrinsic developmental enamel defects",
        "Poor oral hygiene and biofilm accumulation",
        "Systemic tetracycline medication usage",
      ],
      correct: 2
    },
    {
      id: 59037,
      question: "What clinical features distinguish green stain from other extrinsic stains?",
      options: [
        "Linear black deposits along the gingival margin",
        "Yellow diffuse coloration covering entire tooth",
        "Greenish discoloration typically on facial surfaces",
        "Brown staining from tobacco products",
      ],
      correct: 2
    },
    {
      id: 59038,
      question: "On which tooth surfaces does green stain most commonly appear?",
      options: [
        "Lingual surfaces of mandibular posterior teeth",
        "Facial surfaces of maxillary anterior teeth",
        "Occlusal surfaces of all posterior teeth",
        "Interproximal areas between all teeth",
      ],
      correct: 1
    },
    {
      id: 59039,
      question: "What is the composition of green dental stain?",
      options: [
        "Purely inorganic mineral deposits only",
        "Chromogenic bacteria and debris",
        "Metallic compounds from medications",
        "Intrinsic enamel developmental defects",
      ],
      correct: 1
    },
    {
      id: 59040,
      question: "In which patient population does green stain most frequently occur?",
      options: [
        "Elderly patients with extensive restorations",
        "Children and young patients",
        "Middle-aged adults with periodontitis",
        "Only in patients with systemic diseases",
      ],
      correct: 1
    },
    {
      id: 59041,
      question: "What is characteristic about green stain recurrence patterns?",
      options: [
        "Green stain never recurs once removed",
        "Green stain may recur after removal",
        "Recurrence only happens in primary dentition",
        "Recurrence is impossible with good hygiene",
      ],
      correct: 1
    },
    {
      id: 59042,
      question: "What is black-line stain also commonly called in dental terminology?",
      options: [
        "Chlorogenic stain or bacterial pigmentation",
        "Nasmyth's membrane or developmental defect",
        "Melanotic stain or intrinsic discoloration",
        "Pigmented dental biofilm or brown pellicle",
      ],
      correct: 0
    },
    {
      id: 59043,
      question: "What are the clinical features of black-line stain appearance?",
      options: [
        "Diffuse yellowish coverage over entire crown",
        "Thin dark line following gingival contour",
        "Green discoloration on facial surfaces",
        "Brown patches scattered randomly",
      ],
      correct: 1
    },
    {
      id: 59044,
      question: "Where is black-line stain typically distributed on teeth?",
      options: [
        "Occlusal pits and fissures exclusively",
        "Throughout the entire tooth surface uniformly",
        "Along the gingival third in a linear pattern",
        "Only on newly erupted permanent molars",
      ],
      correct: 2
    },
    {
      id: 59045,
      question: "What composes black-line stain at the microscopic level?",
      options: [
        "Intrinsic dentin discoloration from trauma",
        "Metallic deposits from systemic medications",
        "Bacterial deposits with inorganic elements",
        "Developmental enamel hypoplasia defects",
      ],
      correct: 2
    },
    {
      id: 59046,
      question: "How frequently does black-line stain tend to recur after professional removal?",
      options: [
        "Black-line stain commonly recurs after removal",
        "Recurrence never occurs once removed",
        "Only recurs in patients with poor hygiene",
        "Recurrence happens only in primary teeth",
      ],
      correct: 0
    },
    {
      id: 59047,
      question: "What predisposing factors are associated with black-line stain formation?",
      options: [
        "High caries rate and frequent sugar consumption",
        "Good oral hygiene and low caries incidence",
        "Systemic antibiotic use during tooth development",
        "Excessive fluoride intake causing fluorosis",
      ],
      correct: 1
    },
    {
      id: 59048,
      question: "What clinical features characterize tobacco stain appearance?",
      options: [
        "Green discoloration on anterior facial surfaces",
        "Black linear deposits at gingival margins",
        "Dark brown to black discoloration patterns",
        "Yellow diffuse coverage from biofilm",
      ],
      correct: 2
    },
    {
      id: 59049,
      question: "How is tobacco stain typically distributed on tooth surfaces?",
      options: [
        "Exclusively on lingual surfaces hidden from view",
        "Primarily on facial surfaces of anterior teeth",
        "Can affect any tooth surface exposed to tobacco",
        "Only on interproximal areas between teeth",
      ],
      correct: 2
    },
    {
      id: 59050,
      question: "What comprises the composition of tobacco-related dental stains?",
      options: [
        "Chromogenic bacteria producing green pigments",
        "Tar and other tobacco combustion products",
        "Intrinsic dentin discoloration from medications",
        "Metallic compounds from industrial exposure",
      ],
      correct: 1
    },
    {
      id: 59051,
      question: "What predisposing factors increase tobacco stain severity?",
      options: [
        "Excellent oral hygiene and frequent brushing",
        "Low exposure to tobacco products",
        "Heavy tobacco use and poor oral hygiene",
        "Regular professional dental cleanings",
      ],
      correct: 2
    },
    {
      id: 59052,
      question: "What causes brown pellicle stain formation on teeth?",
      options: [
        "Chromogenic bacteria and salivary proteins",
        "Systemic tetracycline during tooth development",
        "Intrinsic genetic enamel defects",
        "Industrial metallic dust exposure",
      ],
      correct: 0
    },
    {
      id: 59053,
      question: "How can stannous fluoride contribute to dental staining?",
      options: [
        "It prevents all forms of extrinsic staining",
        "It causes brown staining in some patients",
        "It only produces green discoloration",
        "It has no relationship to dental stains",
      ],
      correct: 1
    },
    {
      id: 59054,
      question: "What staining can result from antimicrobial agent usage?",
      options: [
        "Bright yellow fluorescent discoloration",
        "Green staining on facial surfaces",
        "Brown discoloration patterns",
        "Black-line stain formation",
      ],
      correct: 2
    },
    {
      id: 59055,
      question: "What causes swimmer stain in individuals who frequently swim?",
      options: [
        "Bacterial colonization from pool water",
        "Chlorine exposure in swimming pools",
        "Intrinsic enamel developmental defects",
        "Tobacco product usage",
      ],
      correct: 1
    },
    {
      id: 59056,
      question: "What is the clinical appearance of orange and red stains?",
      options: [
        "Black linear deposits at margins",
        "Green discoloration on anterior teeth",
        "Orange or reddish coloration",
        "Brown patches from tobacco",
      ],
      correct: 2
    },
    {
      id: 59057,
      question: "Where do orange and red stains typically appear on tooth surfaces?",
      options: [
        "Exclusively on lingual posterior surfaces",
        "Primarily at the gingival third region",
        "Only on occlusal surfaces",
        "Uniformly across all surfaces",
      ],
      correct: 1
    },
    {
      id: 59058,
      question: "What is the etiology of orange and red dental stains?",
      options: [
        "Intrinsic medication-induced discoloration",
        "Chromogenic bacteria producing pigments",
        "Metallic industrial dust exposure",
        "Developmental enamel hypoplasia",
      ],
      correct: 1
    },
    {
      id: 59059,
      question: "How do metallic stains develop from industrial exposure?",
      options: [
        "Through systemic medication absorption",
        "From inhaling or contacting metal-containing dust",
        "From intrinsic tooth development defects",
        "Through dietary supplement consumption",
      ],
      correct: 1
    },
    {
      id: 59060,
      question: "What metallic substances in drugs can cause dental staining?",
      options: [
        "Calcium and phosphorus supplements only",
        "Vitamin complexes without minerals",
        "Iron, copper, or other metallic compounds",
        "Protein-based pharmaceutical preparations",
      ],
      correct: 2
    },
    {
      id: 59061,
      question: "What causes pulpless or traumatized teeth to change color?",
      options: [
        "External bacterial pigment deposition",
        "Blood breakdown products within tooth structure",
        "Surface staining from poor hygiene",
        "Developmental enamel defects",
      ],
      correct: 1
    },
    {
      id: 59062,
      question: "How do hereditary genetic factors cause intrinsic tooth discoloration?",
      options: [
        "Through external bacterial colonization patterns",
        "By affecting tooth structure development",
        "Only through dietary influences",
        "Through trauma during tooth eruption",
      ],
      correct: 1
    },
    {
      id: 59063,
      question: "What is enamel hypoplasia and how does it affect tooth appearance?",
      options: [
        "Excessive enamel formation causing white spots",
        "Normal enamel development without defects",
        "Defective enamel formation causing discoloration",
        "Surface staining from external sources",
      ],
      correct: 2
    },
    {
      id: 59064,
      question: "What causes dental fluorosis discoloration?",
      options: [
        "Deficient fluoride intake during development",
        "External fluoride application to erupted teeth",
        "Excessive fluoride intake during tooth development",
        "Bacterial pigment production on surfaces",
      ],
      correct: 2
    },
    {
      id: 59065,
      question: "How does tetracycline cause intrinsic tooth staining?",
      options: [
        "Through surface deposition on erupted teeth",
        "By incorporating into developing tooth structure",
        "Through bacterial pigment enhancement",
        "By affecting only adult permanent teeth",
      ],
      correct: 1
    },
    {
      id: 59066,
      question: "What distinguishes minocycline staining from other tetracycline stains?",
      options: [
        "It only affects primary teeth in children",
        "It can cause staining even in adult teeth",
        "It produces only yellow discoloration",
        "It never causes any dental discoloration",
      ],
      correct: 1
    },
    {
      id: 59067,
      question: "How can silver amalgam restorations cause tooth discoloration?",
      options: [
        "Through surface bacterial stain accumulation",
        "By corroding and staining adjacent tooth structure",
        "Through systemic medication effects",
        "By preventing all forms of staining",
      ],
      correct: 1
    },
    {
      id: 59068,
      question: "What staining can result from endodontic therapy procedures?",
      options: [
        "External green staining on facial surfaces",
        "Internal discoloration from filling materials",
        "Yellow surface deposits from bacteria",
        "Black-line stain at gingival margins",
      ],
      correct: 1
    },
    {
      id: 59069,
      question: "What should be documented regarding biofilm and debris?",
      options: [
        "Only the presence or absence noted",
        "Clinical appearance and extent of deposits",
        "Patient's dietary preferences exclusively",
        "Future treatment cost estimates",
      ],
      correct: 1
    },
    {
      id: 59070,
      question: "What calculus documentation is essential in patient records?",
      options: [
        "Only if visible to the naked eye",
        "Location, extent, and type of deposits",
        "General statement of presence only",
        "No documentation is necessary",
      ],
      correct: 1
    },
    {
      id: 59071,
      question: "What stain documentation should be included in clinical records?",
      options: [
        "Color, type, extent, and location details",
        "Only if patient requests cosmetic treatment",
        "General notation without specific details",
        "Documentation is optional for stains",
      ],
      correct: 0
    },
    {
      id: 59072,
      question: "What should patients be taught about biofilm location and properties?",
      options: [
        "Biofilm is harmless and needs no removal",
        "Biofilm forms naturally and requires regular removal",
        "Biofilm only affects children's teeth",
        "Biofilm cannot be controlled by patients",
      ],
      correct: 1
    },
    {
      id: 59073,
      question: "Why should patients learn about personal oral care effects?",
      options: [
        "Professional care eliminates need for home care",
        "Home care has minimal impact on oral health",
        "Personal care directly impacts biofilm control",
        "Oral care procedures are unnecessary",
      ],
      correct: 2
    },
    {
      id: 59074,
      question: "What biofilm control procedures should be taught to patients?",
      options: [
        "Only annual professional cleaning is needed",
        "Daily mechanical removal techniques",
        "Biofilm control is impossible at home",
        "Chemical control alone without brushing",
      ],
      correct: 1
    },
    {
      id: 59075,
      question: "Why should patients understand cariogenic foodstuffs in their diet?",
      options: [
        "Diet has no relationship to dental caries",
        "Only sugar-free foods prevent caries",
        "Frequent fermentable carbohydrates increase caries risk",
        "All foods equally promote dental health",
      ],
      correct: 2
    },
    {
      id: 59076,
      question: "What should patients know about calculus formation?",
      options: [
        "Calculus forms spontaneously without cause",
        "Calculus develops from mineralized biofilm",
        "Calculus only occurs in elderly patients",
        "Calculus formation cannot be prevented",
      ],
      correct: 1
    },
    {
      id: 59077,
      question: "Why should the etiology of individual dental stains be explained?",
      options: [
        "All stains have identical causes",
        "Understanding etiology helps with prevention",
        "Stain etiology is too complex for patients",
        "Stain causes are irrelevant to treatment",
      ],
      correct: 1
    },
    {
      id: 59078,
      question: "What advantages of smoking cessation should be discussed regarding dental stains?",
      options: [
        "Smoking cessation has no dental benefits",
        "Cessation reduces tobacco stain formation",
        "Smoking only affects systemic health",
        "Dental stains are unaffected by smoking",
      ],
      correct: 1
    },
    {
      id: 59079,
      question: "Why should patients be informed about tetracycline effects?",
      options: [
        "Tetracycline has no dental side effects",
        "Tetracyclines can cause intrinsic tooth staining",
        "Only topical tetracycline affects teeth",
        "Tetracycline effects are reversible",
      ],
      correct: 1
    },
    {
      id: 59080,
      question: "Why should patients select ADA or CDA approved products?",
      options: [
        "Approved products guarantee perfect results",
        "Approval indicates safety and efficacy standards",
        "Non-approved products work equally well",
        "Product approval is unnecessary",
      ],
      correct: 1
    },
    {
      id: 59081,
      question: "The acquired enamel pellicle forms immediately after tooth cleaning and is composed of salivary proteins.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 59082,
      question: "Dental biofilm formation progresses through five distinct stages from initial formation to full maturation.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 59083,
      question: "Supragingival biofilm is located below the gingival margin within the periodontal sulcus.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 59084,
      question: "Materia alba is a hard, calcified deposit that requires professional instrumentation for removal.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 59085,
      question: "Food debris contributes to unsanitary oral conditions and can initiate dental caries development.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 59086,
      question: "Subgingival calculus is typically lighter in color than supragingival calculus.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 59087,
      question: "Fluoride can be incorporated into the crystalline structure of dental calculus.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 59088,
      question: "Calculus can attach to teeth through mechanical locking into surface irregularities.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 59089,
      question: "The microorganisms in the biofilm layer are responsible for perpetuating periodontal inflammation.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 59090,
      question: "Extrinsic stains are always located on the external surface of teeth and can be removed by polishing.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 59091,
      question: "Green stain occurs most frequently in elderly patients with extensive dental restorations.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 59092,
      question: "Black-line stain is associated with good oral hygiene and low caries incidence.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 59093,
      question: "Tetracycline staining is an extrinsic stain that forms on the tooth surface after eruption.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 59094,
      question: "Dental fluorosis is caused by excessive fluoride intake during tooth development.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 59095,
      question: "Silver amalgam restorations can cause intrinsic discoloration of adjacent tooth structure.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    }
  ],
  "5-2. Assessment of Stains and Deposit": [
    {
      id: 60001,
      question: "What is the definition of a biofilm in the oral environment?",
      options: [
        "Simple bacterial colonies loosely attached to surfaces",
        "Mineralized deposits forming exclusively on tooth enamel",
        "Complex, highly organized, three-dimensional communal arrangement of microorganisms",
        "Loose collection of food debris and epithelial cells",
      ],
      correct: 2
    },
    {
      id: 60002,
      question: "What characterizes oral biofilm specifically?",
      options: [
        "Dense, transparent, nonmineralized bacterial mass in gel-like matrix",
        "Visible white calcified deposits on tooth surfaces",
        "Loose yellow material easily removed by rinsing",
        "Hard, mineralized deposits below the gingival margin",
      ],
      correct: 0
    },
    {
      id: 60003,
      question: "What type of bacteria are typically associated with supragingival oral biofilm?",
      options: [
        "Gram-negative anaerobic spirochetes with high motility",
        "Gram-positive aerobic rods and cocci with few motile species",
        "Gram-negative facultative bacilli with flagella",
        "Gram-positive anaerobic filaments with extensive motility",
      ],
      correct: 1
    },
    {
      id: 60004,
      question: "What is the current understanding of subgingival microorganisms and periodontal disease?",
      options: [
        "Specific bacteria definitively cause all periodontal disease",
        "No bacteria are associated with periodontal disease",
        "Research continues determining if bacteria or biofilm community is responsible",
        "Only gram-positive bacteria contribute to periodontal disease",
      ],
      correct: 2
    },
    {
      id: 60005,
      question: "What is the first stage in oral biofilm formation?",
      options: [
        "Bacterial growth and maturation with matrix development",
        "Dispersion of mature biofilm into the environment",
        "Colonization by secondary bacterial species",
        "Pellicle formation on the tooth surface",
      ],
      correct: 3
    },
    {
      id: 60006,
      question: "What occurs during the colonization stage of biofilm formation?",
      options: [
        "Complete mineralization of the bacterial deposits",
        "Bacteria attach and multiply on the pellicle",
        "Biofilm disperses to colonize new surfaces",
        "Pellicle forms from salivary glycoproteins",
      ],
      correct: 1
    },
    {
      id: 60007,
      question: "What happens during the bacterial growth and maturation stage?",
      options: [
        "Initial pellicle adheres to clean tooth surfaces",
        "Early colonizers detach and disperse elsewhere",
        "Biofilm develops complex three-dimensional structure",
        "All bacteria die and become calcified deposits",
      ],
      correct: 2
    },
    {
      id: 60008,
      question: "What is the final stage of oral biofilm formation?",
      options: [
        "Pellicle formation from salivary components",
        "Initial bacterial colonization and attachment",
        "Matrix formation and structural development",
        "Dispersion of bacteria to new locations",
      ],
      correct: 3
    },
    {
      id: 60009,
      question: "What is materia alba in clinical terminology?",
      options: [
        "Calcified deposits firmly bonded to enamel",
        "Loosely attached collection of debris, cells, and microorganisms",
        "Transparent biofilm invisible without disclosing agents",
        "Mineralized deposits below the gingival margin",
      ],
      correct: 1
    },
    {
      id: 60010,
      question: "What colors can materia alba appear as clinically?",
      options: [
        "Black, brown, or dark green coloration",
        "White, yellow, or grayish mass",
        "Red, orange, or pink deposits",
        "Blue, purple, or violet accumulation",
      ],
      correct: 1
    },
    {
      id: 60011,
      question: "What composes food debris in the oral cavity?",
      options: [
        "Mineralized bacterial colonies with calcium salts",
        "Organized biofilm matrix with bacterial populations",
        "Unstructured food particles remaining after eating",
        "Calcified deposits on subgingival tooth surfaces",
      ],
      correct: 2
    },
    {
      id: 60012,
      question: "What must be assessed regarding a patient's oral self-care management?",
      options: [
        "Only the dental professional's treatment preferences",
        "Patient's ability to manage oral self-care practices",
        "Only the cost of oral hygiene products",
        "Exclusively the frequency of professional cleanings",
      ],
      correct: 1
    },
    {
      id: 60013,
      question: "What methods should be used to assess patient oral self-care practices?",
      options: [
        "Only reviewing written surveys without observation",
        "Assuming competence based on patient appearance",
        "Question patient and directly observe techniques",
        "Relying solely on previous dental records",
      ],
      correct: 2
    },
    {
      id: 60014,
      question: "What should be evaluated as part of oral self-care assessment?",
      options: [
        "Patient's income level and insurance coverage",
        "Only the dentist's treatment recommendations",
        "Patient's oral hygiene status and dental history",
        "Exclusively the patient's dietary preferences",
      ],
      correct: 2
    },
    {
      id: 60015,
      question: "What position should the patient be placed in for oral deposit assessment?",
      options: [
        "Upright seated position with head forward",
        "Supine position with proper lighting",
        "Standing position for self-examination",
        "Side-lying position for comfort",
      ],
      correct: 1
    },
    {
      id: 60016,
      question: "How should supragingival tooth surfaces be prepared for deposit assessment?",
      options: [
        "Keep moist with saliva for better visibility",
        "Dry with compressed air one sextant at a time",
        "Coat with petroleum jelly for examination",
        "Leave undisturbed without any preparation",
      ],
      correct: 1
    },
    {
      id: 60017,
      question: "What should be identified on dried tooth surfaces during assessment?",
      options: [
        "Only the amount of saliva present",
        "Surfaces with supragingival calculus and stain",
        "Exclusively the color of tooth enamel",
        "Only restored teeth and crowns",
      ],
      correct: 1
    },
    {
      id: 60018,
      question: "When should a disclosing agent be applied during assessment?",
      options: [
        "Before any oral examination begins",
        "Only at the end of all procedures",
        "After identifying calculus and before examining biofilm",
        "Never during professional assessments",
      ],
      correct: 2
    },
    {
      id: 60019,
      question: "What tool is used to examine tooth surfaces after disclosing agent application?",
      options: [
        "Periodontal probe for pocket measurements",
        "Mouth mirror to view stained biofilm",
        "Scaler to remove all visible deposits",
        "Cotton pliers to hold gauze",
      ],
      correct: 1
    },
    {
      id: 60020,
      question: "What should be recorded after identifying oral biofilm?",
      options: [
        "Only the patient's subjective complaints",
        "Biofilm location and extent in patient record",
        "Exclusively the cost of treatment",
        "Only the dental hygienist's opinions",
      ],
      correct: 1
    },
    {
      id: 60021,
      question: "What instrument combination is used to explore for subgingival calculus?",
      options: [
        "Scaler and dental floss only",
        "Suction and compressed air exclusively",
        "Periodontal explorer and mouth mirror",
        "Prophy angle and polishing cup",
      ],
      correct: 2
    },
    {
      id: 60022,
      question: "Where should subgingival calculus findings be documented?",
      options: [
        "Only in the dental hygienist's personal notes",
        "Exclusively on financial billing statements",
        "In the official patient record",
        "Only on temporary scratch paper",
      ],
      correct: 2
    },
    {
      id: 60023,
      question: "What should be done after completing the deposit assessment?",
      options: [
        "Immediately begin scaling without discussion",
        "Dismiss the patient without explanation",
        "Communicate findings to the patient",
        "Only inform the dentist privately",
      ],
      correct: 2
    },
    {
      id: 60024,
      question: "Where must services rendered be documented?",
      options: [
        "Only on the appointment scheduling book",
        "Exclusively in the insurance claim form",
        "In the patient record appropriately",
        "Only in the office financial ledger",
      ],
      correct: 2
    },
    {
      id: 60025,
      question: "How does oral biofilm appear clinically before staining?",
      options: [
        "As bright white chalky deposits on enamel",
        "As a transparent film forming within minutes",
        "As dark brown calcified material",
        "As red inflamed tissue only",
      ],
      correct: 1
    },
    {
      id: 60026,
      question: "How can the presence of oral biofilm be assessed?",
      options: [
        "Only through radiographic imaging techniques",
        "By passing explorer over surfaces or using disclosing agents",
        "Exclusively by patient self-reporting symptoms",
        "Through laboratory culture testing only",
      ],
      correct: 1
    },
    {
      id: 60027,
      question: "What is another name for disclosing agents?",
      options: [
        "Mineralizing solutions or calcifying compounds",
        "Disclosants or biofilm revealing agents",
        "Whitening agents or bleaching solutions",
        "Anesthetic solutions or numbing gels",
      ],
      correct: 1
    },
    {
      id: 60028,
      question: "What is the purpose of using disclosing agents?",
      options: [
        "To permanently stain teeth for identification",
        "To make oral biofilm clinically visible",
        "To remove calculus deposits chemically",
        "To whiten teeth and remove stains",
      ],
      correct: 1
    },
    {
      id: 60029,
      question: "When should disclosing agents be applied during patient assessment?",
      options: [
        "Before beginning any oral examination",
        "During the middle of scaling procedures",
        "After oral and periodontal assessment",
        "Only at the final recall appointment",
      ],
      correct: 2
    },
    {
      id: 60030,
      question: "What should be done after applying disclosant to tooth surfaces?",
      options: [
        "Leave it on teeth for 24 hours",
        "Expectorate or suction excess from mouth",
        "Immediately rinse with hot water",
        "Apply additional layers for darker color",
      ],
      correct: 1
    },
    {
      id: 60031,
      question: "What should the patient be provided after disclosant application?",
      options: [
        "Only verbal description without visual aid",
        "Written instructions to take home",
        "Hand mirror to view stained deposits",
        "Photographs to mail later",
      ],
      correct: 2
    },
    {
      id: 60032,
      question: "What is the dental hygienist's role after patient views stained biofilm?",
      options: [
        "Immediately dismiss patient without discussion",
        "Assist in identifying deposits and correlate findings",
        "Only collect payment for services",
        "Avoid any discussion of findings",
      ],
      correct: 1
    },
    {
      id: 60033,
      question: "How is oral biofilm classified by location?",
      options: [
        "By color intensity and staining patterns",
        "By supragingival or subgingival position",
        "By patient age and demographics",
        "By treatment cost and insurance coverage",
      ],
      correct: 1
    },
    {
      id: 60034,
      question: "How is the amount of oral biofilm described in assessment?",
      options: [
        "Using exact micrometer measurements only",
        "By cubic centimeter volume calculations",
        "As light, moderate, or heavy accumulations",
        "By bacterial species count exclusively",
      ],
      correct: 2
    },
    {
      id: 60035,
      question: "What determines if biofilm extent is generalized or localized?",
      options: [
        "The specific color intensity observed",
        "Whether it involves more or less than one-third dentition",
        "The patient's age and gender",
        "The cost of treatment required",
      ],
      correct: 1
    },
    {
      id: 60036,
      question: "What is dental calculus also commonly called?",
      options: [
        "Biofilm or pellicle deposits",
        "Materia alba or food debris",
        "Tartar or mineralized deposits",
        "Disclosant or staining agent",
      ],
      correct: 2
    },
    {
      id: 60037,
      question: "What mineralizes oral biofilm to form dental calculus?",
      options: [
        "Sodium and potassium from cellular metabolism",
        "Calcium and phosphate salts from saliva",
        "Iron and copper from dietary sources",
        "Fluoride and chloride from water supply",
      ],
      correct: 1
    },
    {
      id: 60038,
      question: "Why does the dental hygienist remove calculus from teeth?",
      options: [
        "Only for cosmetic appearance improvement",
        "To ensure biologically acceptable tooth surfaces",
        "Exclusively to increase treatment revenue",
        "Only because patients request removal",
      ],
      correct: 1
    },
    {
      id: 60039,
      question: "How is dental calculus classified similar to biofilm?",
      options: [
        "By color, texture, and hardness only",
        "By location, amount, and extent",
        "By patient age and socioeconomic status",
        "By treatment time and difficulty",
      ],
      correct: 1
    },
    {
      id: 60040,
      question: "Is calculus composition similar in supragingival and subgingival deposits?",
      options: [
        "Yes, composition is similar in both types",
        "No, they have completely different compositions",
        "Only the color differs between types",
        "Only the texture differs between types",
      ],
      correct: 0
    },
    {
      id: 60041,
      question: "Where does supragingival calculus form in relation to gingival tissue?",
      options: [
        "Below the free gingival margin",
        "Above the free gingival margin",
        "Within the gingival connective tissue",
        "Inside the periodontal ligament space",
      ],
      correct: 1
    },
    {
      id: 60042,
      question: "Where does subgingival calculus form in relation to gingival tissue?",
      options: [
        "On the facial surfaces only",
        "Within the enamel structure itself",
        "Below the free gingival margin",
        "Above the mucogingival junction",
      ],
      correct: 2
    },
    {
      id: 60043,
      question: "What are exogenous stains in dental terminology?",
      options: [
        "Stains incorporated within the tooth structure",
        "Stains originating from sources outside the tooth",
        "Stains from developmental defects only",
        "Stains forming only during tooth development",
      ],
      correct: 1
    },
    {
      id: 60044,
      question: "What are endogenous stains in dental classification?",
      options: [
        "Stains applied externally during adulthood",
        "Stains from external dietary sources",
        "Stains originating from within the tooth",
        "Stains from surface bacterial accumulation",
      ],
      correct: 2
    },
    {
      id: 60045,
      question: "What characterizes intrinsic dental stains?",
      options: [
        "Easily removed by routine brushing and flossing",
        "Incorporated within tooth structure, not removable by scaling",
        "Form only on the outer enamel surface",
        "Always appear as yellow or brown color",
      ],
      correct: 1
    },
    {
      id: 60046,
      question: "How can intrinsic stains be managed if scaling cannot remove them?",
      options: [
        "They cannot be improved by any method",
        "Only surgical extraction is possible",
        "Alternative methods can improve appearance",
        "Antibiotics will eliminate the staining",
      ],
      correct: 2
    },
    {
      id: 60047,
      question: "What characterizes extrinsic dental stains?",
      options: [
        "Permanently bonded within the tooth structure",
        "Occur on tooth surface, typically removed by polishing",
        "Form during tooth development in childhood",
        "Cannot be removed by any known method",
      ],
      correct: 1
    },
    {
      id: 60048,
      question: "Why is assessment of dental deposits essential?",
      options: [
        "Only to increase dental office revenue",
        "For effective care planning and disease prevention",
        "Exclusively for insurance documentation purposes",
        "Only to satisfy regulatory requirements",
      ],
      correct: 1
    },
    {
      id: 60049,
      question: "When should dental deposits be assessed to establish a baseline?",
      options: [
        "Only at the final treatment appointment",
        "During initial visit and reassessed subsequently",
        "Exclusively when patients report problems",
        "Only when insurance requires documentation",
      ],
      correct: 1
    },
    {
      id: 60050,
      question: "What does light help increase during deposit assessment?",
      options: [
        "Patient anxiety and discomfort levels",
        "Treatment time and procedure cost",
        "Visual detection of deposits",
        "Bacterial growth and biofilm formation",
      ],
      correct: 2
    },
    {
      id: 60051,
      question: "How does compressed air aid in deposit detection?",
      options: [
        "It mineralizes biofilm into visible calculus",
        "It helps detect supragingival and subgingival deposits",
        "It permanently removes all visible deposits",
        "It changes the color of stains",
      ],
      correct: 1
    },
    {
      id: 60052,
      question: "What functions does a mouth mirror provide during assessment?",
      options: [
        "Only magnification of tooth structures",
        "Indirect vision, illumination, transillumination, and retraction",
        "Exclusively patient entertainment during procedures",
        "Only to reflect light onto surfaces",
      ],
      correct: 1
    },
    {
      id: 60053,
      question: "What instrument is specifically used for tactile calculus detection?",
      options: [
        "Dental mirror for indirect visualization",
        "Suction device for moisture control",
        "Periodontal explorer for subgingival exploration",
        "Cotton pliers for gauze placement",
      ],
      correct: 2
    },
    {
      id: 60054,
      question: "What is gauze used for during deposit assessment?",
      options: [
        "Only to polish tooth surfaces",
        "To dry surfaces and retract tissues",
        "Exclusively to apply disclosing solutions",
        "Only for patient comfort",
      ],
      correct: 1
    },
    {
      id: 60055,
      question: "What role does disclosing solution serve in assessment?",
      options: [
        "To permanently stain teeth for identification",
        "To make oral biofilm visible for evaluation",
        "To remove calculus chemically",
        "To bleach intrinsic stains",
      ],
      correct: 1
    },
    {
      id: 60056,
      question: "How is the location of deposits described in assessment?",
      options: [
        "By the patient's age and medical history",
        "As forming supragingivally or subgingivally",
        "By the calendar date of formation",
        "As forming in morning or evening",
      ],
      correct: 1
    },
    {
      id: 60057,
      question: "How is the amount of deposits quantified in oral hygiene assessment?",
      options: [
        "In exact milligrams using precision scales",
        "As none present, light, moderate, or heavy",
        "By counting individual bacterial colonies",
        "In cubic millimeters using volumetric analysis",
      ],
      correct: 1
    },
    {
      id: 60058,
      question: "What does \"generalized\" mean when describing deposit extent?",
      options: [
        "Involving less than one-quarter of dentition",
        "Involving more than one-third of dentition",
        "Present on anterior teeth exclusively",
        "Limited to one or two teeth only",
      ],
      correct: 1
    },
    {
      id: 60059,
      question: "What does \"localized\" mean when describing deposit extent?",
      options: [
        "Present throughout the entire oral cavity",
        "Involving more than half the dentition",
        "Involving less than one-third of dentition",
        "Affecting all posterior teeth bilaterally",
      ],
      correct: 2
    },
    {
      id: 60060,
      question: "What is a dental index used for in oral hygiene assessment?",
      options: [
        "Only to diagnose specific bacterial species",
        "To convert clinical observations into numeric values",
        "Exclusively to determine treatment fees",
        "Only to schedule future appointments",
      ],
      correct: 1
    },
    {
      id: 60061,
      question: "What can numeric values from indices be used for?",
      options: [
        "Only for office record keeping purposes",
        "To be quantified, summarized, analyzed, and interpreted",
        "Exclusively for insurance billing codes",
        "Only for patient entertainment",
      ],
      correct: 1
    },
    {
      id: 60062,
      question: "What is one purpose of establishing a baseline with oral hygiene indices?",
      options: [
        "To predict future lottery numbers",
        "To establish initial status for an individual",
        "To determine the patient's income level",
        "To calculate office profitability",
      ],
      correct: 1
    },
    {
      id: 60063,
      question: "How can oral hygiene indices be used for populations?",
      options: [
        "Only for individual patient education",
        "To survey oral hygiene status within populations",
        "Exclusively for dental school admissions",
        "Only for marketing purposes",
      ],
      correct: 1
    },
    {
      id: 60064,
      question: "What can indices help evaluate in research and practice?",
      options: [
        "Only the dentist's clinical skills",
        "Interventions, drugs, or devices effectiveness",
        "Exclusively patient satisfaction scores",
        "Only office appointment scheduling",
      ],
      correct: 1
    },
    {
      id: 60065,
      question: "Why is maintaining records of oral hygiene status important?",
      options: [
        "Only to satisfy insurance requirements",
        "As an important part of assessment",
        "Exclusively for legal protection only",
        "Only to increase office revenue",
      ],
      correct: 1
    },
    {
      id: 60066,
      question: "What should be documented regarding oral hygiene products?",
      options: [
        "Only the brand names patients prefer",
        "Products used and previous instruction given",
        "Exclusively the cost of products",
        "Only advertising slogans for products",
      ],
      correct: 1
    },
    {
      id: 60067,
      question: "What comparison should be made using documented plaque scores?",
      options: [
        "Between different patients in the practice",
        "Patient's current and previous scores",
        "Only against national average statistics",
        "Between different dental offices",
      ],
      correct: 1
    },
    {
      id: 60068,
      question: "Oral biofilm is a complex, highly organized, three-dimensional communal arrangement of microorganisms that adhere to surfaces where moisture and nutrients are available.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 60069,
      question: "Supragingival microorganisms typically include gram-positive aerobic rods and cocci with very few motile species.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 60070,
      question: "The four stages of oral biofilm formation are pellicle formation, colonization, bacterial growth and maturation, and dispersion.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 60071,
      question: "Materia alba is a hard, calcified deposit that requires professional scaling instruments for removal.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 60072,
      question: "Food debris consists of unstructured particles that remain in the mouth after eating.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 60073,
      question: "Assessing a patient's ability to manage oral self-care practices involves only questioning the patient without any direct observation.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 60074,
      question: "During oral deposit assessment, the patient should be placed in a supine position with a properly positioned light source.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 60075,
      question: "Disclosing agents should be applied before conducting the oral and periodontal assessment.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 60076,
      question: "Oral biofilm appears clinically as a transparent film that begins to form within minutes after a surface has been cleaned.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 60077,
      question: "Dental calculus is oral biofilm that has been mineralized by calcium and phosphate salts from saliva.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 60078,
      question: "The composition of supragingival and subgingival calculus is completely different with no similarities.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 60079,
      question: "Exogenous stains originate from sources outside of the tooth structure.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 60080,
      question: "Intrinsic stains are incorporated within the tooth structure and cannot be removed by scaling or polishing procedures.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 60081,
      question: "Assessment of dental deposits and stains is essential only for cosmetic purposes and has no role in disease prevention.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 60082,
      question: "Deposits should be assessed during the initial visit to establish a baseline and then reassessed at subsequent visits.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 60083,
      question: "Compressed air aids in the detection of both supragingival and subgingival soft and hard deposits.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 60084,
      question: "A mouth mirror provides only indirect vision and has no other functions during oral assessment.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 60085,
      question: "The extent of deposits is described as generalized when involving more than one-third of the dentition.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 60086,
      question: "A dental index is a data collection instrument that converts clinical observations into numeric values that can be quantified and analyzed.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 60087,
      question: "Record keeping of a patient's oral hygiene status is unnecessary if the patient has good oral hygiene.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    }
  ],
  "6-2. Dental Hygiene Diagnosis": [
    {
      id: 61001,
      question: "What is the definition of diagnosis in the context of dental hygiene practice?",
      options: [
        "A treatment plan for oral health conditions only",
        "The identification of a condition based on analysis of cause and characteristics",
        "A prescription for medications to treat dental problems",
        "An assessment tool used exclusively by dentists",
      ],
      correct: 1
    },
    {
      id: 61002,
      question: "Which factor is relevant to both nursing and dental hygiene diagnoses?",
      options: [
        "Prescription authority for controlled substances",
        "Surgical intervention capabilities",
        "Social determinants of health",
        "Hospital admitting privileges",
      ],
      correct: 2
    },
    {
      id: 61003,
      question: "What does a dental hygiene diagnosis consider when modifying oral hygiene instructions?",
      options: [
        "The patient's insurance coverage limits",
        "The actual cognitive abilities of patients",
        "The dentist's preferred treatment methods",
        "The cost of dental hygiene products",
      ],
      correct: 1
    },
    {
      id: 61004,
      question: "What does the dental hygiene diagnosis provide as its primary function?",
      options: [
        "Authorization for surgical procedures",
        "Prescription for antibiotics",
        "Basis for dental hygiene care plan",
        "Medical diagnosis of systemic conditions",
      ],
      correct: 2
    },
    {
      id: 61005,
      question: "According to the ADHA Diagnosis White Paper, what has been the progression of dental hygiene practice?",
      options: [
        "Expansion has been rapid in all states",
        "Direct access expansion has led to expanded scope of practice",
        "Diagnosis is now standard in all practice acts",
        "Scope of practice has remained unchanged",
      ],
      correct: 1
    },
    {
      id: 61006,
      question: "What has been the rate of expansion for dental hygiene diagnosis in practice acts?",
      options: [
        "Rapid and comprehensive across all states",
        "Moderate with full implementation expected soon",
        "Slow despite increased direct access",
        "Complete with no further changes needed",
      ],
      correct: 2
    },
    {
      id: 61007,
      question: "What is the first step in the Dental Hygiene Diagnostic Process in Action?",
      options: [
        "Formulate the dental hygiene diagnosis",
        "Communicate findings to other healthcare providers",
        "Analyze and interpret all assessment data",
        "Determine patient needs for treatment",
      ],
      correct: 2
    },
    {
      id: 61008,
      question: "After analyzing assessment data, what is the next step in the diagnostic process?",
      options: [
        "Begin treatment immediately without consultation",
        "Discuss findings and present goals to the client",
        "Refer the patient to a specialist",
        "Document findings without patient involvement",
      ],
      correct: 1
    },
    {
      id: 61009,
      question: "How many human needs are identified in the Human Needs Model related to dental hygiene?",
      options: [
        "Five human needs",
        "Six human needs",
        "Seven human needs",
        "Eight human needs",
      ],
      correct: 3
    },
    {
      id: 61010,
      question: "Which of the following is NOT one of the eight human needs in the Human Needs Model?",
      options: [
        "Protection from health risks",
        "Financial security and insurance coverage",
        "Freedom from fear/stress",
        "Wholesome facial image",
      ],
      correct: 1
    },
    {
      id: 61011,
      question: "What does \"biologically sound and functional dentition\" represent in the Human Needs Model?",
      options: [
        "Having perfect white teeth",
        "One of the eight human needs in dental hygiene",
        "A cosmetic dental goal only",
        "An optional treatment outcome",
      ],
      correct: 1
    },
    {
      id: 61012,
      question: "In dental hygiene diagnosis, what must be specified after determining an unmet need?",
      options: [
        "The patient's financial payment plan",
        "The etiology or cause of the unmet need",
        "The dentist's treatment preferences",
        "The insurance reimbursement code",
      ],
      correct: 1
    },
    {
      id: 61013,
      question: "What is required as evidence for an unmet need in dental hygiene diagnosis?",
      options: [
        "Patient's verbal complaints only",
        "Insurance authorization forms",
        "Signs, symptoms, or documented evidence",
        "Referral from another healthcare provider",
      ],
      correct: 2
    },
    {
      id: 61014,
      question: "How many of the eight human needs were unmet in Case Study 22.1?",
      options: [
        "Three human needs were unmet",
        "Four human needs were unmet",
        "Five human needs were unmet",
        "Six human needs were unmet",
      ],
      correct: 2
    },
    {
      id: 61015,
      question: "In the case study, what was the patient's blood pressure reading?",
      options: [
        "120/80 mm Hg",
        "115/74 mm Hg",
        "110/70 mm Hg",
        "125/85 mm Hg",
      ],
      correct: 1
    },
    {
      id: 61016,
      question: "What medical condition was the case study patient diagnosed with that affects mood?",
      options: [
        "Hypothyroidism",
        "Diabetes mellitus",
        "Bipolar disorder",
        "Hypertension",
      ],
      correct: 2
    },
    {
      id: 61017,
      question: "What is a known contraindication of Lamictal relevant to dental hygiene?",
      options: [
        "Gingival hyperplasia",
        "Xerostomia (dry mouth)",
        "Tooth discoloration",
        "Enamel hypoplasia",
      ],
      correct: 1
    },
    {
      id: 61018,
      question: "What was the purpose of Levothyroxine in the case study patient's medication regimen?",
      options: [
        "To treat bipolar disorder",
        "To manage hypertension",
        "For birth control",
        "To treat hypothyroidism",
      ],
      correct: 3
    },
    {
      id: 61019,
      question: "What clinical finding was observed in the mandibular anterior sextant of the case study patient?",
      options: [
        "Mild inflammation with healthy tissue",
        "Localized severe inflammation",
        "Complete absence of inflammation",
        "Moderate inflammation similar to other areas",
      ],
      correct: 1
    },
    {
      id: 61020,
      question: "Which teeth were missing in the case study patient?",
      options: [
        "Teeth 18, 28, 38, and 48",
        "Teeth 1, 16, 17, and 32",
        "Teeth 8, 9, 24, and 25",
        "Teeth 2, 15, 18, and 31",
      ],
      correct: 0
    },
    {
      id: 61021,
      question: "What was the Plaque Index (PI) percentage for the case study patient?",
      options: [
        "75% plaque coverage",
        "85% plaque coverage",
        "100% plaque coverage",
        "50% plaque coverage",
      ],
      correct: 2
    },
    {
      id: 61022,
      question: "What was the Bleeding Index (BI) for the case study patient?",
      options: [
        "17% bleeding on probing",
        "25% bleeding on probing",
        "30% bleeding on probing",
        "10% bleeding on probing",
      ],
      correct: 0
    },
    {
      id: 61023,
      question: "What mobility classification was observed on teeth 31 and 41 in the case study?",
      options: [
        "Class I mobility",
        "Class II mobility",
        "Class III mobility",
        "No mobility detected",
      ],
      correct: 1
    },
    {
      id: 61024,
      question: "What was the range of attachment loss observed in the case study patient?",
      options: [
        "1 to 4 mm attachment loss",
        "2 to 5 mm attachment loss",
        "3 to 7 mm attachment loss",
        "4 to 8 mm attachment loss",
      ],
      correct: 2
    },
    {
      id: 61025,
      question: "What type of bone loss was generalized throughout the case study patient's mouth?",
      options: [
        "Mild bone loss generalized",
        "Moderate bone loss generalized",
        "Severe bone loss generalized",
        "No bone loss detected",
      ],
      correct: 1
    },
    {
      id: 61026,
      question: "What was the case study patient's occupation?",
      options: [
        "Dental hygienist in private practice",
        "Medical doctor in family practice",
        "Registered nurse in mental health and pediatrics",
        "Pharmacist in hospital setting",
      ],
      correct: 2
    },
    {
      id: 61027,
      question: "What was identified as a financial concern for the case study patient?",
      options: [
        "High insurance deductibles",
        "No dental insurance; must pay out of pocket",
        "Loss of employment benefits",
        "Medical bankruptcy from previous treatment",
      ],
      correct: 1
    },
    {
      id: 61028,
      question: "What must dental hygiene diagnoses always be based on?",
      options: [
        "A single obvious symptom",
        "The dentist's preliminary assessment",
        "A cluster of significant information",
        "Patient's self-reported concerns only",
      ],
      correct: 2
    },
    {
      id: 61029,
      question: "What does gathering complete data help prevent in dental hygiene diagnosis?",
      options: [
        "Patient dissatisfaction with treatment",
        "Formulation of an incorrect diagnosis",
        "Excessive treatment time",
        "Insurance claim denials",
      ],
      correct: 1
    },
    {
      id: 61030,
      question: "What does the dental hygiene diagnosis help clarify regarding professional roles?",
      options: [
        "The hierarchy between dentists and hygienists",
        "The role of dental hygienist and scope of practice",
        "The patient's responsibilities in treatment",
        "The insurance company's coverage decisions",
      ],
      correct: 1
    },
    {
      id: 61031,
      question: "What is oral health-related quality of life (OHRQL)?",
      options: [
        "A single-dimension measure of tooth health only",
        "A multidimensional construct reflecting comfort and social interaction",
        "An insurance reimbursement category",
        "A cosmetic dentistry outcome measure",
      ],
      correct: 1
    },
    {
      id: 61032,
      question: "What does the dental hygiene process assessment focus on according to OHRQL?",
      options: [
        "Financial variables only",
        "Biological variables exclusively",
        "Biopsychosocial variables",
        "Social media presence",
      ],
      correct: 2
    },
    {
      id: 61033,
      question: "What is motivational interviewing defined as in patient education?",
      options: [
        "A directive approach to force behavior change",
        "A collaborative, person-centered form of guiding for change",
        "An interrogation technique for treatment compliance",
        "A sales method for expensive treatments",
      ],
      correct: 1
    },
    {
      id: 61034,
      question: "Which organization offers a 1.5-hour online course on motivational interviewing?",
      options: [
        "American Dental Association (ADA)",
        "Centers for Disease Control (CDC)",
        "National Institute on Drug Abuse (NIDA)",
        "World Health Organization (WHO)",
      ],
      correct: 2
    },
    {
      id: 61035,
      question: "After analyzing data, what are the two possible conclusions a dental hygienist reaches?",
      options: [
        "Patient needs surgery or patient needs medication",
        "Patient requires treatment or has risk factors needing prevention",
        "Patient needs cosmetic work or orthodontic treatment",
        "Patient needs extraction or restoration",
      ],
      correct: 1
    },
    {
      id: 61036,
      question: "When a patient has risk factors but no actual problem, what is the diagnosis targeted toward?",
      options: [
        "Immediate surgical intervention",
        "Actions aimed at alleviating risks, not treatment",
        "Aggressive scaling and root planing",
        "Antibiotic therapy protocols",
      ],
      correct: 1
    },
    {
      id: 61037,
      question: "What color is the clinic form used for dental hygiene diagnosis?",
      options: [
        "White in color",
        "Yellow in color",
        "Blue in color",
        "Green in color",
      ],
      correct: 2
    },
    {
      id: 61038,
      question: "When must the clinic form be requested from the instructor?",
      options: [
        "At the beginning of every semester",
        "During the initial patient assessment",
        "When ready to proceed with diagnosis",
        "After treatment is completed",
      ],
      correct: 2
    },
    {
      id: 61039,
      question: "What is the care plan based on?",
      options: [
        "The dentist's treatment preferences only",
        "Information documented in the Dental Hygiene Diagnoses",
        "Insurance coverage limitations",
        "The patient's financial resources",
      ],
      correct: 1
    },
    {
      id: 61040,
      question: "What does the care plan identify for the patient?",
      options: [
        "The cost of each procedure",
        "The number of appointments needed",
        "The specific instruments to be used",
        "The brand of products to purchase",
      ],
      correct: 1
    },
    {
      id: 61041,
      question: "When can DHDs and goals be written in Semesters III and IV?",
      options: [
        "Only during clinical appointment times",
        "Never outside of clinic hours",
        "Outside appointment times if discussed and documented with client",
        "Only with instructor present in the clinic",
      ],
      correct: 2
    },
    {
      id: 61042,
      question: "When must DHDs be evaluated with the client?",
      options: [
        "Outside of clinical time in writing only",
        "By the instructor without patient presence",
        "With the client in the chair during appointment",
        "Through email communication after appointment",
      ],
      correct: 2
    },
    {
      id: 61043,
      question: "What must be created after the DHD and goals have been evaluated?",
      options: [
        "A financial payment arrangement",
        "A treatment plan",
        "An insurance claim form",
        "A referral letter",
      ],
      correct: 1
    },
    {
      id: 61044,
      question: "What should NOT be written when determining recare intervals?",
      options: [
        "A specific single timeframe like 3 months",
        "A range like \"4-6 weeks/3 months\"",
        "A 6-month interval",
        "A 12-month interval",
      ],
      correct: 1
    },
    {
      id: 61045,
      question: "When must all notes be documented in relation to instructor review?",
      options: [
        "After the instructor leaves the unit",
        "Within 24 hours of the appointment",
        "Prior to instructor coming to the unit",
        "At the end of the clinic session",
      ],
      correct: 2
    },
    {
      id: 61046,
      question: "What must be addressed when presenting the treatment plan to the client?",
      options: [
        "Only the benefits of treatment",
        "The risks and benefits of treatment",
        "Only the cost of treatment",
        "The timeframe exclusively",
      ],
      correct: 1
    },
    {
      id: 61047,
      question: "What form must the client sign after accepting the treatment plan?",
      options: [
        "The insurance claim form",
        "The financial agreement form",
        "The consent form",
        "The medical history update form",
      ],
      correct: 2
    },
    {
      id: 61048,
      question: "What must be documented after the client signs the consent form?",
      options: [
        "Only the date and time",
        "The signature in the chart with review sign-up",
        "The insurance information",
        "The payment method selected",
      ],
      correct: 1
    },
    {
      id: 61049,
      question: "What can proceed after the instructor has seen the client's signature?",
      options: [
        "Immediate scaling procedures",
        "Oral Hygiene Education",
        "Radiograph exposure",
        "Anesthesia administration",
      ],
      correct: 1
    },
    {
      id: 61050,
      question: "What must be documented after completing Oral Hygiene Education?",
      options: [
        "Only the topics discussed",
        "The time spent and what was discussed",
        "Just the patient's questions",
        "Only the materials provided",
      ],
      correct: 1
    },
    {
      id: 61051,
      question: "What does the dental hygiene diagnosis facilitate among professionals?",
      options: [
        "Competition for patients",
        "Communication among oral health professionals",
        "Separation of duties and responsibilities",
        "Independent practice without collaboration",
      ],
      correct: 1
    },
    {
      id: 61052,
      question: "What measurement does the dental hygiene diagnosis provide?",
      options: [
        "Financial performance metrics",
        "Clinical outcomes measurement",
        "Patient satisfaction scores only",
        "Insurance reimbursement rates",
      ],
      correct: 1
    },
    {
      id: 61053,
      question: "What aspect of dental hygiene does the diagnosis help define?",
      options: [
        "The salary range for dental hygienists",
        "The scope and domain of dental hygiene practice",
        "The educational requirements for licensure",
        "The insurance billing procedures",
      ],
      correct: 1
    },
    {
      id: 61054,
      question: "In the case study, what was the patient's pulse rate?",
      options: [
        "72 bpm (beats per minute)",
        "78 bpm (beats per minute)",
        "82 bpm (beats per minute)",
        "88 bpm (beats per minute)",
      ],
      correct: 1
    },
    {
      id: 61055,
      question: "What was the respiratory rate for the case study patient?",
      options: [
        "12 rpm (respirations per minute)",
        "15 rpm (respirations per minute)",
        "18 rpm (respirations per minute)",
        "20 rpm (respirations per minute)",
      ],
      correct: 1
    },
    {
      id: 61056,
      question: "What characteristic described the interdental papilla in the case study?",
      options: [
        "Pink, firm, and stippled tissue",
        "Red and blunted papilla",
        "Pale and edematous papilla",
        "Normal coral pink papilla",
      ],
      correct: 1
    },
    {
      id: 61057,
      question: "What was the range of generalized pocket depths in the case study patient?",
      options: [
        "1-3 mm generalized pockets",
        "2-4 mm generalized pockets",
        "3-5 mm generalized pockets",
        "4-6 mm generalized pockets",
      ],
      correct: 1
    },
    {
      id: 61058,
      question: "What was the deeper pocket depth range in the mandibular anterior area?",
      options: [
        "4-6 mm in anterior area",
        "5-7 mm in anterior area",
        "6-8 mm in anterior area",
        "7-9 mm in anterior area",
      ],
      correct: 1
    },
    {
      id: 61059,
      question: "What was the range of generalized recession observed?",
      options: [
        "0-2 mm recession",
        "1-3 mm recession",
        "2-4 mm recession",
        "3-5 mm recession",
      ],
      correct: 1
    },
    {
      id: 61060,
      question: "How long ago had the case study patient seen a medical doctor?",
      options: [
        "More than two years ago",
        "Less than one year ago",
        "Exactly one year ago",
        "More than five years ago",
      ],
      correct: 1
    },
    {
      id: 61061,
      question: "What restorative material was found on the buccal surfaces of teeth 37, 46, and 47?",
      options: [
        "Composite restorations",
        "Gold inlays",
        "Amalgam restorations",
        "Ceramic crowns",
      ],
      correct: 2
    },
    {
      id: 61062,
      question: "On which teeth were caries detected in the case study patient?",
      options: [
        "Teeth 11, 21, 26, 31",
        "Teeth 16, 12, 37, 44, 45",
        "Teeth 6, 8, 14, 22, 30",
        "Teeth 3, 19, 28, 32",
      ],
      correct: 1
    },
    {
      id: 61063,
      question: "What type of bone loss was observed in the mandibular anterior area specifically?",
      options: [
        "Mild bone loss localized",
        "Moderate bone loss localized",
        "Severe bone loss localized",
        "No bone loss in this area",
      ],
      correct: 2
    },
    {
      id: 61064,
      question: "What described the patient's home environment in the case study?",
      options: [
        "Lives alone in an apartment",
        "Healthy home with boyfriend and son",
        "Lives with extended family members",
        "Recently divorced living situation",
      ],
      correct: 1
    },
    {
      id: 61065,
      question: "What recent milestone had the case study patient achieved regarding health values?",
      options: [
        "Completed a fitness program successfully",
        "Recently learned to value her own health",
        "Obtained comprehensive health insurance",
        "Changed to a healthier career",
      ],
      correct: 1
    },
    {
      id: 61066,
      question: "What was identified as easy for the case study patient to access?",
      options: [
        "Affordable health insurance options",
        "Dental and medical care services",
        "Transportation to appointments",
        "Financial assistance programs",
      ],
      correct: 1
    },
    {
      id: 61067,
      question: "What education level was recently completed by the case study patient?",
      options: [
        "High school diploma",
        "Associate's degree",
        "College graduation",
        "Master's degree program",
      ],
      correct: 2
    },
    {
      id: 61068,
      question: "What finding was noted about the free gingival margin in the case study?",
      options: [
        "Red and inflamed throughout",
        "Generalized pink appearance",
        "White and keratinized",
        "Cyanotic and edematous",
      ],
      correct: 1
    },
    {
      id: 61069,
      question: "Dental hygiene diagnosis is the same as a medical diagnosis performed by physicians.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 61070,
      question: "Social determinants of health are relevant to both nursing and dental hygiene diagnoses.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 61071,
      question: "The expansion of practice acts to include dental hygiene diagnosis has progressed rapidly in all states.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 61072,
      question: "There are eight human needs in the Human Needs Model related to dental hygiene.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 61073,
      question: "Freedom from pain is one of the eight human needs in the Human Needs Model.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 61074,
      question: "The dental hygiene diagnosis determines only the biological needs of patients.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 61075,
      question: "After determining an unmet need, the dental hygienist must specify the etiology or cause.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 61076,
      question: "The case study patient had a Plaque Index of 100%.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 61077,
      question: "The case study patient's Bleeding Index was 30%.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 61078,
      question: "Lamictal can cause xerostomia as a side effect.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 61079,
      question: "The case study patient had Class III mobility on teeth 31 and 41.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 61080,
      question: "The clinic form for dental hygiene diagnosis is blue in color.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 61081,
      question: "DHDs can be written at any time without discussing goals with the client.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 61082,
      question: "The care plan is created before the dental hygiene diagnosis is completed.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 61083,
      question: "When determining recare intervals, it is acceptable to write \"4-6 weeks/3 months.\"",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 61084,
      question: "Oral Hygiene Education can begin before the instructor reviews the client's consent signature.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 61085,
      question: "Dental hygiene diagnoses should be based on a cluster of significant information rather than a single symptom.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 61086,
      question: "The dental hygiene diagnosis helps clarify the role and scope of dental hygiene practice.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 61087,
      question: "Motivational interviewing is a directive approach to force patient behavior change.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 61088,
      question: "OHRQL stands for oral health-related quality of life.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 61089,
      question: "The dental hygiene process revolves around assessment of biopsychosocial variables.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 61090,
      question: "If a patient has risk factors but no actual problem, treatment should still be initiated immediately.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 61091,
      question: "The care plan identifies the number of appointments the client needs.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 61092,
      question: "All notes must be documented after the instructor reviews the unit.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 61093,
      question: "The treatment plan presentation must address both risks and benefits of proposed treatment.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 61094,
      question: "The case study patient was a registered nurse working in mental health and pediatrics.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 61095,
      question: "The case study patient had dental insurance coverage for treatment.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 61096,
      question: "The ADHA Diagnosis White Paper provides guidance on dental hygiene diagnosis and scope of practice.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    }
  ],
  "13. Pit Fissure Sealants": [
    {
      id: 62001,
      question: "What is a pit and fissure sealant?",
      options: [
        "A fluoride treatment applied to all tooth surfaces",
        "A thin plastic resinous coating acting as a physical barrier",
        "A permanent restoration for decayed tooth structure",
        "An antibiotic coating to eliminate oral bacteria",
      ],
      correct: 1
    },
    {
      id: 62002,
      question: "Approximately what percentage of dental caries occurs in pits and fissures of permanent teeth?",
      options: [
        "70% of dental caries",
        "80% of dental caries",
        "90% of dental caries",
        "95% of dental caries",
      ],
      correct: 2
    },
    {
      id: 62003,
      question: "Which teeth are most susceptible to pit and fissure caries?",
      options: [
        "Incisors are most susceptible",
        "Canines are most susceptible",
        "Premolars are most susceptible",
        "Molars are most susceptible",
      ],
      correct: 3
    },
    {
      id: 62004,
      question: "What should the dental hygienist assess as part of the dental hygiene process of care?",
      options: [
        "The patient's insurance coverage limits",
        "The patient's caries risk assessment",
        "The dentist's treatment preferences only",
        "The patient's family dental history exclusively",
      ],
      correct: 1
    },
    {
      id: 62005,
      question: "What ICDAS code is assigned to sound occlusal surfaces recommended for sealant placement?",
      options: [
        "ICDAS code of 0",
        "ICDAS code of 1",
        "ICDAS code of 2",
        "ICDAS code of 3",
      ],
      correct: 0
    },
    {
      id: 62006,
      question: "What must be presented when discussing sealant placement with the client or guardian?",
      options: [
        "Only the cost of the procedure",
        "All factors including indications and contraindications",
        "Only the benefits without mentioning risks",
        "Just the time required for placement",
      ],
      correct: 1
    },
    {
      id: 62007,
      question: "What should be explained to clients about sealant durability?",
      options: [
        "Sealants are permanent and never need replacement",
        "Sealants last exactly five years guaranteed",
        "Sealants may chip, break, or wear down over time",
        "Sealants become stronger with age and use",
      ],
      correct: 2
    },
    {
      id: 62008,
      question: "When is sealant placement contraindicated?",
      options: [
        "When the patient has excellent oral hygiene",
        "When there is radiographic evidence of proximal caries",
        "When the patient is under 18 years old",
        "When the tooth has been previously restored",
      ],
      correct: 1
    },
    {
      id: 62009,
      question: "What must be done if radiographic evidence of proximal caries is found?",
      options: [
        "Place the sealant immediately to prevent spread",
        "Monitor the caries for six months first",
        "Refer patient to dentist for tooth restoration",
        "Apply fluoride varnish instead of sealant",
      ],
      correct: 2
    },
    {
      id: 62010,
      question: "On which teeth are sealants usually placed?",
      options: [
        "All anterior teeth in the mouth",
        "Primary incisors and canines only",
        "First and second molars typically",
        "Third molars exclusively",
      ],
      correct: 2
    },
    {
      id: 62011,
      question: "What must be ensured prior to sealant placement?",
      options: [
        "That the patient has fasted for 6 hours",
        "That there are no caries present and radiographs taken",
        "That local anesthesia has been administered",
        "That prophylaxis paste has dried completely",
      ],
      correct: 1
    },
    {
      id: 62012,
      question: "What does sealant retention refer to?",
      options: [
        "The patient's ability to remember oral hygiene",
        "The cost-effectiveness of the treatment",
        "The ability of sealants to remain on tooth surface",
        "The insurance company's coverage approval",
      ],
      correct: 2
    },
    {
      id: 62013,
      question: "What must be done to the tooth surface before sealant placement?",
      options: [
        "The surface must be polished with fluoride only",
        "The surface must be etched and primer applied",
        "The surface must be painted with iodine",
        "The surface must be coated with eugenol",
      ],
      correct: 1
    },
    {
      id: 62014,
      question: "What is the most common reason for sealant failure?",
      options: [
        "Patient's poor oral hygiene habits",
        "Using incorrect curing light wavelength",
        "Salivary contamination during placement",
        "Excessive tooth enamel thickness",
      ],
      correct: 2
    },
    {
      id: 62015,
      question: "How can sealant material be classified by type?",
      options: [
        "Natural and synthetic materials",
        "Glass ionomer and resin materials",
        "Organic and inorganic compounds",
        "Temporary and permanent varieties",
      ],
      correct: 1
    },
    {
      id: 62016,
      question: "How can sealants be classified by polymerization method?",
      options: [
        "Fast-setting and slow-setting",
        "Heat-activated and pressure-activated",
        "Autopolymerized and photopolymerized",
        "Chemical-cure and dual-cure only",
      ],
      correct: 2
    },
    {
      id: 62017,
      question: "How can sealants be classified by filler content?",
      options: [
        "Filled and unfilled sealants",
        "High-viscosity and low-viscosity",
        "Colored and colorless varieties",
        "Fluoridated and non-fluoridated",
      ],
      correct: 0
    },
    {
      id: 62018,
      question: "How many types of sealant materials are there?",
      options: [
        "Two types of materials",
        "Three types of materials",
        "Four types of materials",
        "Five types of materials",
      ],
      correct: 2
    },
    {
      id: 62019,
      question: "Which type of sealant has fluoride-releasing properties effective in controlling caries progression?",
      options: [
        "Pure resin-based sealants",
        "Polyacid-modified resin sealants",
        "Glass ionomer cements only",
        "Resin-modified glass ionomer sealants",
      ],
      correct: 3
    },
    {
      id: 62020,
      question: "What is polymerization in the context of sealants?",
      options: [
        "The process by which sealants dissolve",
        "The process by which sealants harden",
        "The process of applying etching solution",
        "The process of checking occlusion",
      ],
      correct: 1
    },
    {
      id: 62021,
      question: "What do autopolymerization sealants contain?",
      options: [
        "A fluoride gel and bonding agent",
        "Universal liquid monomer and catalyst",
        "Light-sensitive compounds only",
        "Heat-activated polymers exclusively",
      ],
      correct: 1
    },
    {
      id: 62022,
      question: "When does polymerization start in autopolymerized sealants?",
      options: [
        "When exposed to ultraviolet light",
        "When the material reaches body temperature",
        "As soon as mixing begins",
        "After 5 minutes of air exposure",
      ],
      correct: 2
    },
    {
      id: 62023,
      question: "Where are autopolymerized sealants commonly used?",
      options: [
        "In hospital operating rooms",
        "In private practice settings exclusively",
        "In school-based sealant programs",
        "In emergency dental clinics only",
      ],
      correct: 2
    },
    {
      id: 62024,
      question: "How do photopolymerized sealants harden?",
      options: [
        "Through exposure to room air oxygen",
        "When exposed to light-curing unit",
        "Through chemical reaction with saliva",
        "When mixed with a catalyst powder",
      ],
      correct: 1
    },
    {
      id: 62025,
      question: "What is the typical curing time for photopolymerized sealants?",
      options: [
        "5-10 seconds",
        "20-30 seconds",
        "45-60 seconds",
        "2-3 minutes",
      ],
      correct: 1
    },
    {
      id: 62026,
      question: "What colors are sealants available in?",
      options: [
        "Clear, tinted, opaque, and white",
        "Yellow, green, blue, and red",
        "Only clear and white options",
        "Natural tooth color exclusively",
      ],
      correct: 0
    },
    {
      id: 62027,
      question: "Why are colored sealants beneficial for clinicians?",
      options: [
        "They are more durable than clear sealants",
        "They bond better to tooth structure",
        "They are easier to see during application and reevaluation",
        "They release more fluoride than clear varieties",
      ],
      correct: 2
    },
    {
      id: 62028,
      question: "What should lack of follow-up ability in school-based programs do?",
      options: [
        "Prevent all sealant placement in schools",
        "Not preclude sealant placement",
        "Require parental presence at placement",
        "Mandate dentist supervision only",
      ],
      correct: 1
    },
    {
      id: 62029,
      question: "What does current evidence suggest about BPA in sealants?",
      options: [
        "BPA causes significant health risks in all patients",
        "BPA should never be used in dental materials",
        "Trace amounts of BPA do not place patients at risk",
        "BPA accumulates dangerously over time",
      ],
      correct: 2
    },
    {
      id: 62031,
      question: "Who is responsible for obtaining informed consent prior to sealant placement?",
      options: [
        "The dental assistant exclusively",
        "The receptionist at check-in",
        "The dental hygienist",
        "Only the dentist can obtain consent",
      ],
      correct: 2
    },
    {
      id: 62032,
      question: "What must patients understand about sealants?",
      options: [
        "Sealants are permanent dental restorations",
        "Sealants are not permanent",
        "Sealants never require reevaluation",
        "Sealants eliminate the need for brushing",
      ],
      correct: 1
    },
    {
      id: 62033,
      question: "When must sealant integrity be reassessed?",
      options: [
        "Only when the patient complains",
        "Every five years regardless of condition",
        "At each re-care visit",
        "Only if visible defects appear",
      ],
      correct: 2
    },
    {
      id: 62034,
      question: "What should be done if sealants are missing or defective?",
      options: [
        "Wait until the next annual visit",
        "Replace them at the re-care appointment",
        "Leave them as they provide partial protection",
        "Extract the affected tooth immediately",
      ],
      correct: 1
    },
    {
      id: 62035,
      question: "What are sealants NOT a replacement for?",
      options: [
        "Regular dental examinations",
        "Caries preventive procedures",
        "Orthodontic treatment planning",
        "Periodontal maintenance therapy",
      ],
      correct: 1
    },
    {
      id: 62036,
      question: "What should patients wear during sealant placement?",
      options: [
        "Surgical masks for infection control",
        "Tinted safety glasses for protection",
        "Hearing protection devices",
        "Sterile gloves on both hands",
      ],
      correct: 1
    },
    {
      id: 62037,
      question: "What is effective for tooth isolation when working on several teeth in a quadrant?",
      options: [
        "Cotton rolls placed around all teeth",
        "Gauze squares in the vestibule",
        "Rubber dam isolation",
        "Saliva ejector alone",
      ],
      correct: 2
    },
    {
      id: 62038,
      question: "Why is it critical that etchant does not touch soft tissues?",
      options: [
        "It will stain the gingiva permanently",
        "It can cause an acid burn",
        "It will numb the soft tissues",
        "It activates herpes virus outbreaks",
      ],
      correct: 1
    },
    {
      id: 62039,
      question: "What should be avoided when handling sealant material?",
      options: [
        "Using tinted materials instead of clear",
        "Over-manipulating the material",
        "Applying material too slowly",
        "Using cotton roll isolation",
      ],
      correct: 1
    },
    {
      id: 62040,
      question: "What is the first step in sealant application?",
      options: [
        "Apply the etchant directly to dry tooth",
        "Place rubber dam for complete isolation",
        "Mix pumice with water, use HVE",
        "Light-cure the tooth surface first",
      ],
      correct: 2
    },
    {
      id: 62041,
      question: "Is isolation required when applying pumice in step 1?",
      options: [
        "Yes, rubber dam is mandatory",
        "No isolation is required for pumice",
        "Yes, dry angles must be placed",
        "Yes, cotton rolls are essential",
      ],
      correct: 1
    },
    {
      id: 62042,
      question: "What should be done after applying pumice?",
      options: [
        "Immediately apply the sealant material",
        "Wash the area with water and dry",
        "Apply etchant without rinsing",
        "Check occlusion with articulating paper",
      ],
      correct: 1
    },
    {
      id: 62043,
      question: "Where should the dry angle be placed during isolation?",
      options: [
        "Under the tongue in all cases",
        "On the side that you are working",
        "On the opposite side of the mouth",
        "Between the maxillary and mandibular teeth",
      ],
      correct: 1
    },
    {
      id: 62044,
      question: "When working on mandibular teeth, what additional isolation is needed?",
      options: [
        "A throat pack behind the molars",
        "A cheek retractor on the buccal side",
        "Cotton roll on the tongue side",
        "Gauze wrapped around the tooth",
      ],
      correct: 2
    },
    {
      id: 62045,
      question: "What appearance should an etched tooth have?",
      options: [
        "Shiny and translucent appearance",
        "Yellow and smooth surface",
        "Chalky white appearance",
        "Gray and rough texture",
      ],
      correct: 2
    },
    {
      id: 62046,
      question: "What should be done after etching and before applying sealant?",
      options: [
        "Apply bonding agent immediately without rinsing",
        "Remove cotton roll and replace with dry one if mandibular",
        "Wait 5 minutes for etching to continue",
        "Apply fluoride varnish over the etch",
      ],
      correct: 1
    },
    {
      id: 62047,
      question: "Why must the area be redried before sealant material placement?",
      options: [
        "To remove any moisture contamination",
        "To warm the tooth surface",
        "To activate the etching solution",
        "To harden the primer layer",
      ],
      correct: 0
    },
    {
      id: 62048,
      question: "How long should the curing light be used per tooth?",
      options: [
        "5-10 seconds per tooth",
        "10-15 seconds per tooth",
        "20-30 seconds per tooth",
        "45-60 seconds per tooth",
      ],
      correct: 2
    },
    {
      id: 62049,
      question: "What interval settings might the curing light have?",
      options: [
        "5-second intervals",
        "10-second intervals",
        "15-second intervals",
        "30-second intervals",
      ],
      correct: 1
    },
    {
      id: 62050,
      question: "What should be checked after sealant placement using an explorer?",
      options: [
        "The depth of the pits and fissures",
        "The hardness of the underlying enamel",
        "Sealant integrity ensuring grooves covered with no air voids",
        "The patient's ability to bite comfortably",
      ],
      correct: 2
    },
    {
      id: 62051,
      question: "What areas must be ensured to be covered by the sealant?",
      options: [
        "Only the central occlusal fossa",
        "All grooves including buccal and lingual where relevant",
        "The proximal contact areas only",
        "The entire occlusal table to cusps",
      ],
      correct: 1
    },
    {
      id: 62052,
      question: "What is used to check the patient's bite after sealant placement?",
      options: [
        "Wax bite registration material",
        "Articulating paper using holder",
        "Carbon paper without holder",
        "Digital occlusal analysis system",
      ],
      correct: 1
    },
    {
      id: 62053,
      question: "What do dots on the teeth from articulating paper represent?",
      options: [
        "Areas of tooth decay",
        "Normal biting areas of the client",
        "Defects in the sealant material",
        "Areas requiring additional etching",
      ],
      correct: 1
    },
    {
      id: 62054,
      question: "What should be done if blue dots appear on the sealant?",
      options: [
        "Leave them as they will wear naturally",
        "Remove them through bite adjustment",
        "Apply additional sealant over them",
        "Refer immediately to orthodontist",
      ],
      correct: 1
    },
    {
      id: 62055,
      question: "What is used to remove excess sealant material during bite adjustment?",
      options: [
        "A sharp scaler instrument",
        "A round bur",
        "Sandpaper discs",
        "A diamond finishing bur",
      ],
      correct: 1
    },
    {
      id: 62057,
      question: "What safety equipment must the patient wear during sealant placement?",
      options: [
        "Face mask and surgical cap",
        "Tinted safety glasses",
        "Protective apron only",
        "Ear protection devices",
      ],
      correct: 1
    },
    {
      id: 62058,
      question: "What safety equipment must the operator wear?",
      options: [
        "Double gloves and shoe covers",
        "Face shield for protection",
        "Surgical gown and cap",
        "N95 respirator mask",
      ],
      correct: 1
    },
    {
      id: 62059,
      question: "What must students have at chairside during sealant placement?",
      options: [
        "Extra anesthetic cartridges",
        "Bite registration materials",
        "HVE and saliva ejectors",
        "Emergency medication kit",
      ],
      correct: 2
    },
    {
      id: 62060,
      question: "Which teeth should receive sealant application according to indications?",
      options: [
        "All primary teeth in young children",
        "Sound and non-cavitated pits and fissures",
        "Teeth with existing large restorations",
        "Teeth with active carious lesions",
      ],
      correct: 1
    },
    {
      id: 62061,
      question: "What must be identified when determining sealant need?",
      options: [
        "The patient's insurance coverage limits",
        "The caries risk of the client",
        "The dentist's schedule availability",
        "The cost of materials to be used",
      ],
      correct: 1
    },
    {
      id: 62062,
      question: "What factors indicate high caries risk for sealant consideration?",
      options: [
        "Perfect oral hygiene and no restorations",
        "History of restorations or caries",
        "Fluoridated water consumption only",
        "Professional cleanings every 3 months",
      ],
      correct: 1
    },
    {
      id: 62063,
      question: "What must be taken prior to determining teeth for sealant application?",
      options: [
        "Intraoral photographs only",
        "Impressions for study models",
        "Radiographs must be taken",
        "Saliva pH measurements",
      ],
      correct: 2
    },
    {
      id: 62064,
      question: "Pit and fissure sealants are thick, ceramic coatings applied to teeth.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 62065,
      question: "Approximately 90% of dental caries occurs in pits and fissures of permanent teeth.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 62066,
      question: "Sound occlusal surfaces recommended for sealant placement are assigned an ICDAS code of 0.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 62067,
      question: "Sealants are permanent and never need to be replaced.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 62068,
      question: "If there is radiographic evidence of proximal caries, sealant placement is contraindicated.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 62069,
      question: "Salivary contamination during placement is the most common reason for sealant failure.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 62070,
      question: "Sealants can be classified by type as glass ionomer and resin.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 62071,
      question: "There are six types of sealant materials available.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 62072,
      question: "Photopolymerized sealants harden when exposed to a light-curing unit.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 62073,
      question: "The typical curing time for photopolymerized sealants is 20-30 seconds.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 62074,
      question: "Current evidence suggests that trace amounts of BPA in sealants place patients at significant risk.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 62076,
      question: "Sealant integrity must be reassessed at each re-care visit.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 62077,
      question: "Rubber dam is effective for tooth isolation when working on several teeth in a quadrant.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 62078,
      question: "Etchant touching soft tissues can cause an acid burn.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 62079,
      question: "No isolation is required when applying pumice in the first step of sealant placement.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 62080,
      question: "An etched tooth should have a chalky white appearance.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 62081,
      question: "The curing light is used for 45-60 seconds per tooth.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 62083,
      question: "Sealants are a replacement for caries preventive procedures.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    }
  ],
  "3-2. Soft Tissue": [
    {
      id: 70001,
      question: "What is the outer surface characteristic of the free gingiva in healthy tissue?",
      options: [
        "Smooth and non-keratinized",
        "Keratinized outer surface",
        "Highly vascular and red",
        "Covered with mucous membrane",
      ],
      correct: 1
    },
    {
      id: 70002,
      question: "Which structure represents the coronal portion of the junctional epithelium?",
      options: [
        "Mucogingival junction",
        "Gingival sulcus",
        "Epithelial attachment",
        "Free gingival groove",
      ],
      correct: 2
    },
    {
      id: 70003,
      question: "What characteristic describes healthy gingival tissue color?",
      options: [
        "Bright red with shiny appearance",
        "Uniform pink color, may be pigmented",
        "Purple or blue coloration",
        "Dark red with white patches",
      ],
      correct: 1
    },
    {
      id: 70004,
      question: "How is healthy tissue contour described in relation to the alveolar bone?",
      options: [
        "Loose and separated from bone",
        "Inflamed and swollen",
        "Snug and firm against the alveolar bone",
        "Retracted away from teeth",
      ],
      correct: 2
    },
    {
      id: 70005,
      question: "What term describes the elastic quality of healthy gingival tissue?",
      options: [
        "Fibrotic",
        "Resilient",
        "Flabby",
        "Spongy",
      ],
      correct: 1
    },
    {
      id: 70006,
      question: "What is the surface texture characteristic of healthy gingiva?",
      options: [
        "Smooth and shiny",
        "Rough and irregular",
        "Firm and dimpled (stippled)",
        "Soft and edematous",
      ],
      correct: 2
    },
    {
      id: 70007,
      question: "Where is the position of the gingival margin in healthy tissue relative to the CEJ?",
      options: [
        "Apical to the CEJ",
        "At the same level as the CEJ",
        "Slightly coronal to the CEJ",
        "3mm coronal to the CEJ",
      ],
      correct: 2
    },
    {
      id: 70008,
      question: "What happens when healthy tissue is gently probed?",
      options: [
        "It bleeds immediately",
        "It does not bleed",
        "It shows spontaneous bleeding",
        "It becomes inflamed",
      ],
      correct: 1
    },
    {
      id: 70009,
      question: "What does \"generalized\" mean when describing tissue color changes?",
      options: [
        "Affecting less than 10% of areas",
        "Affecting less than 30% of areas",
        "Affecting over 30% of areas",
        "Affecting only one quadrant",
      ],
      correct: 2
    },
    {
      id: 70010,
      question: "What causes gingival tissue color changes according to the document?",
      options: [
        "Only bacterial infections",
        "Thickness of connective tissue, number and size of blood vessels",
        "Diet and nutrition only",
        "Age of the patient only",
      ],
      correct: 1
    },
    {
      id: 70011,
      question: "How do fair-skinned individuals typically present gingival tissue color?",
      options: [
        "Darker pink shade",
        "Red or purple color",
        "Lighter pink shade",
        "Blue coloration",
      ],
      correct: 2
    },
    {
      id: 70012,
      question: "What indicates a \"localized\" condition on the soft tissue exam form?",
      options: [
        "The color is circled",
        "The color is underlined and areas identified",
        "The color is highlighted",
        "The color is crossed out",
      ],
      correct: 1
    },
    {
      id: 70013,
      question: "What does recession of the free gingival margin indicate?",
      options: [
        "Tissue enlargement",
        "Loss of free gingival margin exposing root surface",
        "Healthy tissue adaptation",
        "Increased keratinization",
      ],
      correct: 1
    },
    {
      id: 70014,
      question: "What shape characterizes clefting of the gingival margin?",
      options: [
        "Round margin",
        "Flat margin",
        "\"Y\" shaped margin",
        "Rolled margin",
      ],
      correct: 2
    },
    {
      id: 70015,
      question: "What does a \"flat\" gingival margin indicate?",
      options: [
        "Presence of stippling",
        "Healthy rolled margin",
        "Lack of a rolled margin",
        "Excessive keratinization",
      ],
      correct: 2
    },
    {
      id: 70016,
      question: "What does \"snug\" indicate about tissue health?",
      options: [
        "Tissue recession",
        "Tissue inflammation",
        "Firmness indicating health",
        "Tissue enlargement",
      ],
      correct: 2
    },
    {
      id: 70017,
      question: "What might cause enlarged gingival tissue?",
      options: [
        "Excellent oral hygiene",
        "Medications taken by the client",
        "Calculus removal",
        "Professional cleaning",
      ],
      correct: 1
    },
    {
      id: 70018,
      question: "What classification is given when assessment reveals no inflammation and no additional bone loss?",
      options: [
        "Gingivitis",
        "Periodontitis",
        "Healthy on a reduced periodontium",
        "Acute inflammation",
      ],
      correct: 2
    },
    {
      id: 70019,
      question: "What is the primary cause of gingival inflammation?",
      options: [
        "Nutritional deficiency",
        "Bacterial infection by pathogens",
        "Mechanical trauma only",
        "Genetic factors only",
      ],
      correct: 1
    },
    {
      id: 70020,
      question: "What color characterizes gingival inflammation?",
      options: [
        "Uniform pink",
        "Bright red",
        "Light pink",
        "White",
      ],
      correct: 1
    },
    {
      id: 70021,
      question: "How does the margin of the tooth appear during gingival inflammation?",
      options: [
        "Flat and thin",
        "Pointed and firm",
        "Rolled and edematous",
        "Stippled and healthy",
      ],
      correct: 2
    },
    {
      id: 70022,
      question: "What happens to the interdental papilla during inflammation?",
      options: [
        "Becomes pointed and firm",
        "Becomes edematous, bulbous, may be blunted or cratered",
        "Remains unchanged",
        "Becomes keratinized",
      ],
      correct: 1
    },
    {
      id: 70023,
      question: "What is the consistency of inflamed tissue when pressed?",
      options: [
        "Firm and resistant",
        "Hard and calcified",
        "Spongy, indents easily",
        "Elastic and resilient",
      ],
      correct: 2
    },
    {
      id: 70024,
      question: "How does inflamed tissue appear in terms of texture?",
      options: [
        "Dimpled with stippling",
        "Rough and irregular",
        "Smooth and shiny, no dimpling or stippling",
        "Keratinized and firm",
      ],
      correct: 2
    },
    {
      id: 70025,
      question: "Where is the free gingival margin positioned during gingivitis?",
      options: [
        "Apical to the CEJ",
        "At the CEJ level",
        "More coronal above the CEJ",
        "Receded from the CEJ",
      ],
      correct: 2
    },
    {
      id: 70026,
      question: "What is a key clinical sign of gingivitis?",
      options: [
        "Absence of bleeding",
        "Presence of bleeding on probing",
        "Tissue recession",
        "Bone loss",
      ],
      correct: 1
    },
    {
      id: 70027,
      question: "How does healthy papilla appear in the embrasure?",
      options: [
        "Bulbous and swollen",
        "Flat and receded",
        "Pointed and fills the embrasure",
        "Cratered and scooped",
      ],
      correct: 2
    },
    {
      id: 70028,
      question: "What does \"bulbous\" papilla indicate?",
      options: [
        "Healthy tissue",
        "Papilla is enlarged and bulges out of interproximal space",
        "Papilla is receded",
        "Papilla has stippling",
      ],
      correct: 1
    },
    {
      id: 70029,
      question: "What does \"blunted\" papilla mean?",
      options: [
        "Papilla is swollen",
        "Papilla fills the embrasure completely",
        "Papilla is flat and does not fill the embrasure",
        "Papilla is pointed",
      ],
      correct: 2
    },
    {
      id: 70030,
      question: "What does \"cratered\" papilla describe?",
      options: [
        "Enlarged appearance",
        "\"Scooped out\" appearance",
        "Pointed appearance",
        "Firm texture",
      ],
      correct: 1
    },
    {
      id: 70031,
      question: "What does \"marginal\" distribution of gingivitis refer to?",
      options: [
        "Only the attached gingiva",
        "Free gingival margin and papilla",
        "Only the alveolar mucosa",
        "The entire periodontium",
      ],
      correct: 1
    },
    {
      id: 70032,
      question: "What does \"papillary\" distribution indicate?",
      options: [
        "Entire gingiva affected",
        "Only free margin affected",
        "Interdental papilla only",
        "Alveolar bone affected",
      ],
      correct: 2
    },
    {
      id: 70033,
      question: "What does \"diffuse\" distribution of inflammation mean?",
      options: [
        "Only the papilla",
        "Only the margin",
        "Gingival margin, papilla, and attached gingiva",
        "Only attached gingiva",
      ],
      correct: 2
    },
    {
      id: 70034,
      question: "Why may the gingival margin appear more coronally during gingivitis?",
      options: [
        "Bone growth",
        "Tissue swelling and enlargement",
        "Tooth eruption",
        "Calculus buildup",
      ],
      correct: 1
    },
    {
      id: 70035,
      question: "What relationship exists between sulcular tissue ulceration and bleeding?",
      options: [
        "No relationship",
        "More ulceration leads to less bleeding",
        "More ulceration leads to more bleeding and inflammation",
        "Ulceration prevents bleeding",
      ],
      correct: 2
    },
    {
      id: 70036,
      question: "How is tissue consistency determined to be \"spongy\"?",
      options: [
        "By visual inspection only",
        "Side of probe pressed on tissue retains an imprint",
        "Tissue appears shiny",
        "Air deflects the tissue",
      ],
      correct: 1
    },
    {
      id: 70037,
      question: "What describes \"soft\" tissue appearance?",
      options: [
        "Firm and resilient",
        "Stippled texture",
        "Shiny and stretched appearance",
        "Dimpled surface",
      ],
      correct: 2
    },
    {
      id: 70038,
      question: "How is \"flabby\" tissue determined?",
      options: [
        "By pressing with probe",
        "Visual inspection only",
        "Air is used and tissue is moveable and flaccid",
        "Bleeding on probing",
      ],
      correct: 2
    },
    {
      id: 70039,
      question: "What characterizes fibrotic gingiva?",
      options: [
        "Soft and pink tissue",
        "Hyperkeratinized with abnormal whitish thickening",
        "Red and inflamed",
        "Normal pink color",
      ],
      correct: 1
    },
    {
      id: 70040,
      question: "In whom is fibrotic gingiva often found?",
      options: [
        "Children only",
        "Smokers (past or current) and certain medication users",
        "Only elderly patients",
        "Patients with excellent oral hygiene",
      ],
      correct: 1
    },
    {
      id: 70041,
      question: "What does stippling indicate about gingival health?",
      options: [
        "Sign of disease",
        "Sign of health",
        "Sign of inflammation",
        "Sign of medication side effects",
      ],
      correct: 1
    },
    {
      id: 70042,
      question: "What appearance is associated with stippling?",
      options: [
        "Smooth surface",
        "Shiny surface",
        "Orange peel appearance",
        "Glassy surface",
      ],
      correct: 2
    },
    {
      id: 70043,
      question: "What does \"shiny\" texture indicate?",
      options: [
        "Healthy stippling",
        "Firm consistency",
        "Stretched appearance with soft tissue",
        "Keratinized surface",
      ],
      correct: 2
    },
    {
      id: 70044,
      question: "What defines \"acute\" plaque-induced gingivitis?",
      options: [
        "Long-lasting inflammation",
        "Chronic bone loss",
        "Sudden onset and short duration",
        "Permanent tissue damage",
      ],
      correct: 2
    },
    {
      id: 70045,
      question: "What happens to tissue after debridement in acute gingivitis?",
      options: [
        "Remains inflamed",
        "Returns to healthy state",
        "Becomes fibrotic",
        "Develops periodontitis",
      ],
      correct: 1
    },
    {
      id: 70046,
      question: "What characterizes \"chronic\" gingivitis?",
      options: [
        "Sudden onset",
        "Short duration",
        "Long-lasting gingivitis, more commonly encountered",
        "Easily reversible",
      ],
      correct: 2
    },
    {
      id: 70047,
      question: "What is the sulcular epithelium characteristic?",
      options: [
        "Keratinized",
        "Nonkeratinized",
        "Highly vascular",
        "Calcified",
      ],
      correct: 1
    },
    {
      id: 70048,
      question: "Where is the cementoenamel junction located in the diagram?",
      options: [
        "At the gingival margin",
        "Between enamel and cementum",
        "At the alveolar crest",
        "In the gingival sulcus",
      ],
      correct: 1
    },
    {
      id: 70049,
      question: "What fibers are located coronally in the gingiva?",
      options: [
        "Periodontal ligament fibers",
        "Circular and gingival fibers",
        "Alveolar crest fibers only",
        "Transseptal fibers",
      ],
      correct: 1
    },
    {
      id: 70050,
      question: "What is the characteristic of attached gingiva's outer surface?",
      options: [
        "Nonkeratinized",
        "Keratinized",
        "Smooth texture",
        "Highly vascular",
      ],
      correct: 1
    },
    {
      id: 70051,
      question: "What is the characteristic of alveolar mucosa's outer surface?",
      options: [
        "Keratinized",
        "Stippled",
        "Nonkeratinized",
        "Firm texture",
      ],
      correct: 2
    },
    {
      id: 70052,
      question: "What does the gingival groove represent?",
      options: [
        "Always present",
        "May be absent",
        "Site of inflammation",
        "Attachment loss",
      ],
      correct: 1
    },
    {
      id: 70053,
      question: "What tissue type is connective tissue in the periodontium?",
      options: [
        "Epithelial tissue",
        "Muscle tissue",
        "Supporting tissue between epithelium and bone",
        "Nervous tissue",
      ],
      correct: 2
    },
    {
      id: 70054,
      question: "What bleeding level indicates \"Low\" on the form?",
      options: [
        "Over 50% of sites",
        "30-50% of sites",
        "Less than 30% of sites",
        "No bleeding present",
      ],
      correct: 2
    },
    {
      id: 70055,
      question: "What bleeding level indicates \"Medium\" on the form?",
      options: [
        "Less than 30%",
        "30-50% of sites",
        "Over 50%",
        "100% of sites",
      ],
      correct: 1
    },
    {
      id: 70056,
      question: "What bleeding level indicates \"High\" on the form?",
      options: [
        "Less than 30%",
        "30-50%",
        "Over 50% of sites",
        "Exactly 40%",
      ],
      correct: 2
    },
    {
      id: 70057,
      question: "What are considered \"local factors\" on the soft tissue exam?",
      options: [
        "Systemic diseases only",
        "Stain, plaque, and calculus",
        "Medications only",
        "Genetic factors",
      ],
      correct: 1
    },
    {
      id: 70058,
      question: "How is client compliance rated on the form?",
      options: [
        "Poor, fair, good",
        "Excellent, good, fair, needs improvement",
        "High, medium, low",
        "Satisfactory, unsatisfactory",
      ],
      correct: 1
    },
    {
      id: 70059,
      question: "What does \"WNL\" stand for in oral cancer screenings?",
      options: [
        "Will Need Labs",
        "Without New Lesions",
        "Within Normal Limits",
        "Weekly Needs List",
      ],
      correct: 2
    },
    {
      id: 70060,
      question: "What documentation is required if oral cancer screening shows findings?",
      options: [
        "No documentation needed",
        "Findings must be documented",
        "Only visual inspection",
        "Referral only",
      ],
      correct: 1
    },
    {
      id: 70061,
      question: "What determines the case type on the soft tissue form?",
      options: [
        "Patient age",
        "Insurance coverage",
        "DD level (difficulty/disease level)",
        "Appointment length",
      ],
      correct: 2
    },
    {
      id: 70062,
      question: "Where should the DH instructor's signature appear?",
      options: [
        "Top of form",
        "Each section",
        "On the completed form",
        "Not required",
      ],
      correct: 2
    },
    {
      id: 70063,
      question: "What diagnostic date format is used on the example form?",
      options: [
        "MM/DD/YYYY",
        "Month Day, Year (May 24, 2023)",
        "DD/MM/YYYY",
        "Year/Month/Day",
      ],
      correct: 1
    },
    {
      id: 70064,
      question: "In the example, what areas showed pink-red color?",
      options: [
        "Entire maxillary arch",
        "4.3 – 3.3 facial areas",
        "All mandibular teeth",
        "Only anterior teeth",
      ],
      correct: 1
    },
    {
      id: 70065,
      question: "In the example, what areas showed recession?",
      options: [
        "All teeth",
        "Maxillary molars",
        "4.1, 3.1, and 1.6 Facial",
        "Mandibular anteriors",
      ],
      correct: 2
    },
    {
      id: 70066,
      question: "What consistency was noted for teeth 4.1 and 3.1 lingual in the example?",
      options: [
        "Firm",
        "Spongy",
        "Soft",
        "Fibrotic",
      ],
      correct: 2
    },
    {
      id: 70067,
      question: "What is located between the gingival margin and mucogingival junction?",
      options: [
        "Junctional epithelium",
        "Free gingiva",
        "Attached gingiva",
        "Alveolar mucosa",
      ],
      correct: 2
    },
    {
      id: 70068,
      question: "What connects the tooth to the alveolar bone?",
      options: [
        "Gingival fibers",
        "Periodontal ligament",
        "Circular fibers",
        "Junctional epithelium",
      ],
      correct: 1
    },
    {
      id: 70069,
      question: "What structure is the gingiva firmly connected to?",
      options: [
        "Enamel only",
        "Mucosa only",
        "Underlying cementum and bone",
        "Oral epithelium",
      ],
      correct: 2
    },
    {
      id: 70070,
      question: "What does gentle pressure with the side of the probe test?",
      options: [
        "Bleeding tendency",
        "Tissue resilience and resistance to compression",
        "Pocket depth",
        "Attachment level",
      ],
      correct: 1
    },
    {
      id: 70071,
      question: "What happens to healthy tissue after compression with a probe?",
      options: [
        "Remains indented",
        "Bleeds immediately",
        "Springs back quickly",
        "Becomes inflamed",
      ],
      correct: 2
    },
    {
      id: 70072,
      question: "Healthy tissue has a uniform pink color and may be pigmented.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70073,
      question: "The outer surface of the free gingiva is nonkeratinized.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 70074,
      question: "Healthy tissue bleeds when gently probed.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 70075,
      question: "Stippling is also known as dimpling and indicates healthy tissue.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70076,
      question: "The gingival margin in healthy tissue is positioned slightly coronal to the CEJ.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70077,
      question: "Generalized conditions affect less than 30% of the areas.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 70078,
      question: "Clefting presents as a \"Y\" shaped margin of tissue.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70079,
      question: "Enlarged tissue may be due to medications taken by the client.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70080,
      question: "Gingival inflammation is caused by bacterial infection of the gingival tissue by pathogens.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70081,
      question: "During inflammation, the gingival tissue color is bright red.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70082,
      question: "Inflamed tissue has a firm consistency that resists compression.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 70083,
      question: "Bulbous papilla is enlarged and appears to bulge out of the interproximal space.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70084,
      question: "Blunted papilla is pointed and fills the embrasure.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 70085,
      question: "Cratered papilla has a \"scooped out\" appearance.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70086,
      question: "Marginal distribution affects only the alveolar mucosa.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 70087,
      question: "Diffuse inflammation affects the gingival margin, papilla, and attached gingiva.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70088,
      question: "Spongy tissue is determined by pressing with the side of the probe and the tissue retains an imprint.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70089,
      question: "Fibrotic gingiva is hyperkeratinized with an abnormal whitish thickening.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70090,
      question: "Fibrotic gingiva can often be found in smokers.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70091,
      question: "Stippling gives an orange peel appearance to healthy gingiva.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70092,
      question: "Shiny tissue texture is associated with the stretched appearance of soft tissue.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70093,
      question: "Acute gingivitis has a sudden onset and short duration.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70094,
      question: "After debridement, acute gingivitis tissue returns to a healthy state.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70095,
      question: "Chronic gingivitis is less commonly encountered than acute gingivitis.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 70096,
      question: "The alveolar mucosa has a keratinized outer surface.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 70097,
      question: "The gingival groove may be absent in some cases.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70098,
      question: "\"Low\" bleeding indicates over 50% of sites bleeding.",
      options: [
        "True",
        "False",
      ],
      correct: 1
    },
    {
      id: 70099,
      question: "Client compliance can be rated as \"needs improvement\" on the soft tissue exam form.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70100,
      question: "WNL in oral cancer screenings stands for \"Within Normal Limits.\"",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70101,
      question: "The junctional epithelium's coronal portion is the epithelial attachment.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70102,
      question: "Healthy tissue is resilient and elastic when tested with gentle pressure.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    },
    {
      id: 70103,
      question: "The position of inflammation in gingivitis may make the gingival margin appear more coronal due to swelling.",
      options: [
        "True",
        "False",
      ],
      correct: 0
    }
  ]
};
